export const ICON_TAGS = [
    {
        name: 'a-arrow-down',
        tags: ['letter', 'font size', 'text', 'formatting', 'smaller']
    },
    {
        name: 'a-arrow-up',
        tags: ['letter', 'font size', 'text', 'formatting', 'larger', 'bigger']
    },
    {
        name: 'a-large-small',
        tags: ['letter', 'font size', 'text', 'formatting']
    },
    {
        name: 'accessibility',
        tags: ['disability', 'disabled', 'dda', 'wheelchair']
    },
    {
        name: 'activity',
        tags: [
            'pulse',
            'action',
            'motion',
            'movement',
            'exercise',
            'fitness',
            'healthcare',
            'heart rate monitor',
            'vital signs',
            'vitals',
            'emergency room',
            'er',
            'intensive care',
            'hospital',
            'defibrillator',
            'earthquake',
            'siesmic',
            'magnitude',
            'richter scale',
            'aftershock',
            'tremor',
            'shockwave',
            'audio',
            'waveform',
            'synthesizer',
            'synthesiser',
            'music'
        ]
    },
    {
        name: 'air-vent',
        tags: ['air conditioner', 'ac', 'central air', 'cooling', 'climate-control']
    },
    {
        name: 'airplay',
        tags: ['stream', 'cast', 'mirroring', 'screen', 'monitor', 'macos', 'osx']
    },
    {
        name: 'alarm-clock',
        tags: ['morning']
    },
    {
        name: 'alarm-clock-check',
        tags: ['done', 'todo', 'tick', 'complete', 'task']
    },
    {
        name: 'alarm-clock-minus',
        tags: ['remove']
    },
    {
        name: 'alarm-clock-off',
        tags: ['morning', 'turn-off']
    },
    {
        name: 'alarm-clock-plus',
        tags: ['add']
    },
    {
        name: 'alarm-smoke',
        tags: ['fire', 'alert', 'warning', 'detector', 'carbon monoxide', 'safety', 'equipment', 'amenities']
    },
    {
        name: 'album',
        tags: ['photo', 'book']
    },
    {
        name: 'align-center',
        tags: ['text', 'alignment', 'center']
    },
    {
        name: 'align-center-horizontal',
        tags: ['items', 'flex', 'justify']
    },
    {
        name: 'align-center-vertical',
        tags: ['items', 'flex', 'justify']
    },
    {
        name: 'align-end-horizontal',
        tags: ['items', 'bottom', 'flex', 'justify']
    },
    {
        name: 'align-end-vertical',
        tags: ['items', 'right', 'flex', 'justify']
    },
    {
        name: 'align-horizontal-distribute-center',
        tags: ['items', 'flex', 'justify', 'space', 'evenly', 'around']
    },
    {
        name: 'align-horizontal-distribute-end',
        tags: ['right', 'items', 'flex', 'justify']
    },
    {
        name: 'align-horizontal-distribute-start',
        tags: ['left', 'items', 'flex', 'justify']
    },
    {
        name: 'align-horizontal-justify-center',
        tags: ['center', 'items', 'flex', 'justify']
    },
    {
        name: 'align-horizontal-justify-end',
        tags: ['right', 'items', 'flex', 'justify']
    },
    {
        name: 'align-horizontal-justify-start',
        tags: ['left', 'items', 'flex', 'justify']
    },
    {
        name: 'align-horizontal-space-around',
        tags: ['center', 'items', 'flex', 'justify', 'distribute', 'between']
    },
    {
        name: 'align-horizontal-space-between',
        tags: ['around', 'items', 'bottom', 'flex', 'justify']
    },
    {
        name: 'align-justify',
        tags: ['text', 'alignment', 'justified', 'menu', 'list']
    },
    {
        name: 'align-left',
        tags: ['text', 'alignment', 'left', 'list']
    },
    {
        name: 'align-right',
        tags: ['text', 'alignment', 'right']
    },
    {
        name: 'align-start-horizontal',
        tags: ['top', 'items', 'flex', 'justify']
    },
    {
        name: 'align-start-vertical',
        tags: ['left', 'items', 'flex', 'justify']
    },
    {
        name: 'align-vertical-distribute-center',
        tags: ['items', 'flex', 'justify', 'space', 'evenly', 'around']
    },
    {
        name: 'align-vertical-distribute-end',
        tags: ['bottom', 'items', 'flex', 'justify']
    },
    {
        name: 'align-vertical-distribute-start',
        tags: ['top', 'items', 'flex', 'justify']
    },
    {
        name: 'align-vertical-justify-center',
        tags: ['center', 'items', 'flex', 'justify', 'distribute', 'between']
    },
    {
        name: 'align-vertical-justify-end',
        tags: ['bottom', 'items', 'flex', 'justify', 'distribute', 'between']
    },
    {
        name: 'align-vertical-justify-start',
        tags: ['top', 'items', 'flex', 'justify', 'distribute', 'between']
    },
    {
        name: 'align-vertical-space-around',
        tags: ['center', 'items', 'flex', 'justify', 'distribute', 'between']
    },
    {
        name: 'align-vertical-space-between',
        tags: ['center', 'items', 'flex', 'justify', 'distribute', 'between']
    },
    {
        name: 'ambulance',
        tags: [
            'ambulance',
            'emergency',
            'medical',
            'vehicle',
            'siren',
            'healthcare',
            'transportation',
            'rescue',
            'urgent',
            'first aid'
        ]
    },
    {
        name: 'ampersand',
        tags: ['and', 'typography', 'operator', 'join', 'concatenate', 'code', '&']
    },
    {
        name: 'ampersands',
        tags: ['and', 'operator', 'then', 'code', '&&']
    },
    {
        name: 'amphora',
        tags: ['pottery', 'artifact', 'artefact', 'vase', 'ceramics', 'clay', 'archaeology', 'museum', 'wine', 'oil']
    },
    {
        name: 'anchor',
        tags: ['ship']
    },
    {
        name: 'angry',
        tags: ['emoji', 'anger', 'face', 'emotion']
    },
    {
        name: 'annoyed',
        tags: ['emoji', 'nuisance', 'face', 'emotion']
    },
    {
        name: 'antenna',
        tags: [
            'signal',
            'connection',
            'connectivity',
            'tv',
            'television',
            'broadcast',
            'live',
            'frequency',
            'tune',
            'scan',
            'channels',
            'aerial',
            'receiver',
            'transmission',
            'transducer',
            'terrestrial',
            'satellite',
            'cable'
        ]
    },
    {
        name: 'anvil',
        tags: ['metal', 'iron', 'alloy', 'materials', 'heavy', 'weight', 'blacksmith', 'forge', 'acme']
    },
    {
        name: 'aperture',
        tags: ['camera', 'photo', 'pictures', 'shutter', 'exposure']
    },
    {
        name: 'app-window',
        tags: ['application', 'menu bar', 'pane', 'executable']
    },
    {
        name: 'app-window-mac',
        tags: ['application', 'menu bar', 'pane', 'preferences', 'macos', 'osx', 'executable']
    },
    {
        name: 'apple',
        tags: ['fruit', 'food']
    },
    {
        name: 'archive',
        tags: ['index', 'backup', 'box', 'storage', 'records']
    },
    {
        name: 'archive-restore',
        tags: ['unarchive', 'index', 'backup', 'box', 'storage', 'records']
    },
    {
        name: 'archive-x',
        tags: ['index', 'backup', 'box', 'storage', 'records', 'junk']
    },
    {
        name: 'armchair',
        tags: ['sofa', 'furniture', 'leisure', 'lounge', 'loveseat', 'couch']
    },
    {
        name: 'arrow-big-down',
        tags: ['backwards', 'reverse', 'direction', 'south']
    },
    {
        name: 'arrow-big-down-dash',
        tags: ['backwards', 'reverse', 'slow', 'direction', 'south', 'download']
    },
    {
        name: 'arrow-big-left',
        tags: ['previous', 'back', 'direction', 'west', 'indicate turn']
    },
    {
        name: 'arrow-big-left-dash',
        tags: ['previous', 'back', 'direction', 'west', 'turn', 'corner']
    },
    {
        name: 'arrow-big-right',
        tags: ['next', 'forward', 'direction', 'east', 'indicate turn']
    },
    {
        name: 'arrow-big-right-dash',
        tags: ['next', 'forward', 'direction', 'east', 'turn', 'corner']
    },
    {
        name: 'arrow-big-up',
        tags: ['shift', 'keyboard', 'button', 'mac', 'capitalize', 'capitalise', 'forward', 'direction', 'north']
    },
    {
        name: 'arrow-big-up-dash',
        tags: [
            'caps lock',
            'capitals',
            'keyboard',
            'button',
            'mac',
            'forward',
            'direction',
            'north',
            'faster',
            'speed',
            'boost'
        ]
    },
    {
        name: 'arrow-down',
        tags: ['backwards', 'reverse', 'direction', 'south']
    },
    {
        name: 'arrow-down-0-1',
        tags: [
            'filter',
            'sort',
            'ascending',
            'descending',
            'increasing',
            'decreasing',
            'rising',
            'falling',
            'numerical'
        ]
    },
    {
        name: 'arrow-down-1-0',
        tags: [
            'filter',
            'sort',
            'ascending',
            'descending',
            'increasing',
            'decreasing',
            'rising',
            'falling',
            'numerical'
        ]
    },
    {
        name: 'arrow-down-a-z',
        tags: [
            'filter',
            'sort',
            'ascending',
            'descending',
            'increasing',
            'decreasing',
            'rising',
            'falling',
            'alphabetical'
        ]
    },
    {
        name: 'arrow-down-from-line',
        tags: ['backwards', 'reverse', 'direction', 'south', 'download', 'expand', 'fold', 'vertical']
    },
    {
        name: 'arrow-down-left',
        tags: ['direction', 'south-west', 'diagonal']
    },
    {
        name: 'arrow-down-narrow-wide',
        tags: ['filter', 'sort', 'ascending', 'descending', 'increasing', 'decreasing', 'rising', 'falling']
    },
    {
        name: 'arrow-down-right',
        tags: ['direction', 'south-east', 'diagonal']
    },
    {
        name: 'arrow-down-to-dot',
        tags: ['direction', 'south', 'waypoint', 'location', 'step', 'into']
    },
    {
        name: 'arrow-down-to-line',
        tags: [
            'behind',
            'direction',
            'south',
            'download',
            'save',
            'git',
            'version control',
            'pull',
            'collapse',
            'fold',
            'vertical'
        ]
    },
    {
        name: 'arrow-down-up',
        tags: [
            'bidirectional',
            'two-way',
            '2-way',
            'swap',
            'switch',
            'network',
            'traffic',
            'flow',
            'mobile data',
            'internet',
            'sort',
            'reorder',
            'move'
        ]
    },
    {
        name: 'arrow-down-wide-narrow',
        tags: ['filter', 'sort', 'ascending', 'descending', 'increasing', 'decreasing', 'rising', 'falling']
    },
    {
        name: 'arrow-down-z-a',
        tags: [
            'filter',
            'sort',
            'ascending',
            'descending',
            'increasing',
            'decreasing',
            'rising',
            'falling',
            'alphabetical',
            'reverse'
        ]
    },
    {
        name: 'arrow-left',
        tags: ['previous', 'back', 'direction', 'west', '<-']
    },
    {
        name: 'arrow-left-from-line',
        tags: ['previous', 'back', 'direction', 'west', 'expand', 'fold', 'horizontal', '<-|']
    },
    {
        name: 'arrow-left-right',
        tags: ['bidirectional', 'two-way', '2-way', 'swap', 'switch', 'transaction', 'reorder', 'move', '<-', '->']
    },
    {
        name: 'arrow-left-to-line',
        tags: ['previous', 'back', 'direction', 'west', 'collapse', 'fold', 'horizontal', '|<-']
    },
    {
        name: 'arrow-right',
        tags: ['forward', 'next', 'direction', 'east', '->']
    },
    {
        name: 'arrow-right-from-line',
        tags: ['next', 'forward', 'direction', 'east', 'export', 'expand', 'fold', 'horizontal', '|->']
    },
    {
        name: 'arrow-right-left',
        tags: ['bidirectional', 'two-way', '2-way', 'swap', 'switch', 'transaction', 'reorder', 'move', '<-', '->']
    },
    {
        name: 'arrow-right-to-line',
        tags: [
            'next',
            'forward',
            'direction',
            'east',
            'tab',
            'keyboard',
            'mac',
            'indent',
            'collapse',
            'fold',
            'horizontal',
            '->|'
        ]
    },
    {
        name: 'arrow-up',
        tags: ['forward', 'direction', 'north']
    },
    {
        name: 'arrow-up-0-1',
        tags: [
            'filter',
            'sort',
            'ascending',
            'descending',
            'increasing',
            'decreasing',
            'rising',
            'falling',
            'numerical'
        ]
    },
    {
        name: 'arrow-up-1-0',
        tags: [
            'filter',
            'sort',
            'ascending',
            'descending',
            'increasing',
            'decreasing',
            'rising',
            'falling',
            'numerical'
        ]
    },
    {
        name: 'arrow-up-a-z',
        tags: [
            'filter',
            'sort',
            'ascending',
            'descending',
            'increasing',
            'decreasing',
            'rising',
            'falling',
            'alphabetical'
        ]
    },
    {
        name: 'arrow-up-down',
        tags: [
            'bidirectional',
            'two-way',
            '2-way',
            'swap',
            'switch',
            'network',
            'mobile data',
            'internet',
            'sort',
            'reorder',
            'move'
        ]
    },
    {
        name: 'arrow-up-from-dot',
        tags: ['direction', 'north', 'step', 'out']
    },
    {
        name: 'arrow-up-from-line',
        tags: [
            'forward',
            'direction',
            'north',
            'upload',
            'git',
            'version control',
            'push',
            'expand',
            'fold',
            'vertical'
        ]
    },
    {
        name: 'arrow-up-left',
        tags: ['direction', 'north-west', 'diagonal']
    },
    {
        name: 'arrow-up-narrow-wide',
        tags: ['filter', 'sort', 'ascending', 'descending', 'increasing', 'decreasing', 'rising', 'falling']
    },
    {
        name: 'arrow-up-right',
        tags: ['direction', 'north-east', 'diagonal']
    },
    {
        name: 'arrow-up-to-line',
        tags: ['forward', 'direction', 'north', 'upload', 'collapse', 'fold', 'vertical']
    },
    {
        name: 'arrow-up-wide-narrow',
        tags: ['filter', 'sort', 'ascending', 'descending', 'increasing', 'decreasing', 'rising', 'falling']
    },
    {
        name: 'arrow-up-z-a',
        tags: [
            'filter',
            'sort',
            'ascending',
            'descending',
            'increasing',
            'decreasing',
            'rising',
            'falling',
            'alphabetical',
            'reverse'
        ]
    },
    {
        name: 'arrows-up-from-line',
        tags: [
            'direction',
            'orientation',
            'this way up',
            'vertical',
            'package',
            'box',
            'fragile',
            'postage',
            'shipping'
        ]
    },
    {
        name: 'asterisk',
        tags: ['reference', 'times', 'multiply', 'multiplication', 'operator', 'code', 'glob pattern', 'wildcard', '*']
    },
    {
        name: 'at-sign',
        tags: ['mention', 'at', 'email', 'message', '@']
    },
    {
        name: 'atom',
        tags: ['atomic', 'nuclear', 'physics', 'particle', 'element', 'molecule', 'electricity', 'energy', 'chemistry']
    },
    {
        name: 'audio-lines',
        tags: [
            'graphic equaliser',
            'sound',
            'noise',
            'listen',
            'hearing',
            'hertz',
            'frequency',
            'wavelength',
            'vibrate',
            'sine',
            'synthesizer',
            'synthesiser',
            'levels',
            'track',
            'music',
            'playback',
            'radio',
            'broadcast',
            'airwaves',
            'voice',
            'vocals',
            'singer',
            'song'
        ]
    },
    {
        name: 'audio-waveform',
        tags: [
            'sound',
            'noise',
            'listen',
            'hearing',
            'hertz',
            'frequency',
            'wavelength',
            'vibrate',
            'sine',
            'synthesizer',
            'synthesiser',
            'levels',
            'track',
            'music',
            'playback',
            'radio',
            'broadcast',
            'airwaves',
            'voice',
            'vocals',
            'singer',
            'song'
        ]
    },
    {
        name: 'award',
        tags: ['achievement', 'badge', 'rosette', 'prize', 'winner']
    },
    {
        name: 'axe',
        tags: [
            'hatchet',
            'weapon',
            'chop',
            'sharp',
            'equipment',
            'fireman',
            'firefighter',
            'brigade',
            'lumberjack',
            'woodcutter',
            'logger',
            'forestry'
        ]
    },
    {
        name: 'axis-3d',
        tags: ['gizmo', 'coordinates']
    },
    {
        name: 'baby',
        tags: ['child', 'childproof', 'children']
    },
    {
        name: 'backpack',
        tags: ['bag', 'hiking', 'travel', 'camping', 'school', 'childhood']
    },
    {
        name: 'badge',
        tags: ['check', 'verified', 'unverified']
    },
    {
        name: 'badge-alert',
        tags: ['check', 'verified', 'unverified', 'security', 'safety', 'issue']
    },
    {
        name: 'badge-cent',
        tags: [
            'discount',
            'offer',
            'sale',
            'voucher',
            'tag',
            'monetization',
            'marketing',
            'finance',
            'financial',
            'exchange',
            'transaction',
            'payment',
            'cents',
            'dollar',
            'usd',
            '$',
            '¢'
        ]
    },
    {
        name: 'badge-check',
        tags: ['verified', 'check']
    },
    {
        name: 'badge-dollar-sign',
        tags: [
            'discount',
            'offer',
            'sale',
            'voucher',
            'tag',
            'monetization',
            'marketing',
            'finance',
            'financial',
            'exchange',
            'transaction',
            'payment',
            'usd',
            '$'
        ]
    },
    {
        name: 'badge-euro',
        tags: [
            'discount',
            'offer',
            'sale',
            'voucher',
            'tag',
            'monetization',
            'marketing',
            'finance',
            'financial',
            'exchange',
            'transaction',
            'payment',
            '€'
        ]
    },
    {
        name: 'badge-help',
        tags: ['verified', 'unverified', 'help']
    },
    {
        name: 'badge-indian-rupee',
        tags: [
            'discount',
            'offer',
            'sale',
            'voucher',
            'tag',
            'monetization',
            'marketing',
            'finance',
            'financial',
            'exchange',
            'transaction',
            'payment',
            'inr',
            '₹'
        ]
    },
    {
        name: 'badge-info',
        tags: ['verified', 'unverified', 'help']
    },
    {
        name: 'badge-japanese-yen',
        tags: [
            'discount',
            'offer',
            'sale',
            'voucher',
            'tag',
            'monetization',
            'marketing',
            'finance',
            'financial',
            'exchange',
            'transaction',
            'payment',
            'jpy',
            '¥'
        ]
    },
    {
        name: 'badge-minus',
        tags: ['verified', 'unverified', 'delete', 'remove', 'erase']
    },
    {
        name: 'badge-percent',
        tags: ['verified', 'unverified', 'sale', 'discount', 'offer', 'marketing', 'sticker', 'price tag']
    },
    {
        name: 'badge-plus',
        tags: ['verified', 'unverified', 'add', 'create', 'new']
    },
    {
        name: 'badge-pound-sterling',
        tags: [
            'discount',
            'offer',
            'sale',
            'voucher',
            'tag',
            'monetization',
            'marketing',
            'finance',
            'financial',
            'exchange',
            'transaction',
            'payment',
            'british',
            'gbp',
            '£'
        ]
    },
    {
        name: 'badge-russian-ruble',
        tags: [
            'discount',
            'offer',
            'sale',
            'voucher',
            'tag',
            'monetization',
            'marketing',
            'finance',
            'financial',
            'exchange',
            'transaction',
            'payment',
            'rub',
            '₽'
        ]
    },
    {
        name: 'badge-swiss-franc',
        tags: [
            'discount',
            'offer',
            'sale',
            'voucher',
            'tag',
            'monetization',
            'marketing',
            'finance',
            'financial',
            'exchange',
            'transaction',
            'payment',
            'chf',
            '₣'
        ]
    },
    {
        name: 'badge-x',
        tags: ['verified', 'unverified', 'lost', 'delete', 'remove']
    },
    {
        name: 'baggage-claim',
        tags: ['baggage', 'luggage', 'travel', 'cart', 'trolley', 'suitcase']
    },
    {
        name: 'ban',
        tags: [
            'cancel',
            'no',
            'stop',
            'forbidden',
            'prohibited',
            'error',
            'incorrect',
            'mistake',
            'wrong',
            'failure',
            'circle',
            'slash',
            'null',
            'void'
        ]
    },
    {
        name: 'banana',
        tags: ['fruit', 'food']
    },
    {
        name: 'bandage',
        tags: [
            'plaster',
            'band-aid',
            'first aid',
            'medical',
            'health',
            'wound',
            'injury',
            'care',
            'treatment',
            'healing',
            'protection',
            'emergency',
            'aid',
            'safety'
        ]
    },
    {
        name: 'banknote',
        tags: ['currency', 'money', 'payment']
    },
    {
        name: 'barcode',
        tags: [
            'scan',
            'checkout',
            'till',
            'cart',
            'transaction',
            'purchase',
            'buy',
            'product',
            'packaging',
            'retail',
            'consumer'
        ]
    },
    {
        name: 'baseline',
        tags: ['text', 'format', 'color']
    },
    {
        name: 'bath',
        tags: ['amenities', 'services', 'bathroom', 'shower']
    },
    {
        name: 'battery',
        tags: ['power', 'electricity', 'energy', 'accumulator', 'charge']
    },
    {
        name: 'battery-charging',
        tags: ['power', 'electricity', 'energy', 'accumulator', 'charge']
    },
    {
        name: 'battery-full',
        tags: ['power', 'electricity', 'energy', 'accumulator', 'charge']
    },
    {
        name: 'battery-low',
        tags: ['power', 'electricity', 'energy', 'accumulator', 'charge']
    },
    {
        name: 'battery-medium',
        tags: ['power', 'electricity', 'energy', 'accumulator', 'charge']
    },
    {
        name: 'battery-warning',
        tags: ['power', 'electricity', 'energy', 'accumulator', 'charge', 'exclamation mark']
    },
    {
        name: 'beaker',
        tags: ['cup', 'lab', 'chemistry', 'experiment', 'test']
    },
    {
        name: 'bean',
        tags: ['legume', 'soy', 'food', 'seed']
    },
    {
        name: 'bean-off',
        tags: ['soy free', 'legume', 'soy', 'food', 'seed', 'allergy', 'intolerance', 'diet']
    },
    {
        name: 'bed',
        tags: ['sleep', 'hotel', 'furniture']
    },
    {
        name: 'bed-double',
        tags: ['sleep', 'hotel', 'furniture']
    },
    {
        name: 'bed-single',
        tags: ['sleep', 'hotel', 'furniture']
    },
    {
        name: 'beef',
        tags: ['food', 'dish', 'restaurant', 'course', 'meal', 'meat', 'bbq', 'steak']
    },
    {
        name: 'beer',
        tags: ['alcohol', 'bar', 'beverage', 'brewery', 'drink']
    },
    {
        name: 'beer-off',
        tags: ['alcohol', 'bar', 'beverage', 'brewery', 'drink']
    },
    {
        name: 'bell',
        tags: ['alarm', 'notification', 'sound', 'reminder']
    },
    {
        name: 'bell-dot',
        tags: ['alarm', 'notification', 'sound', 'reminder', 'unread']
    },
    {
        name: 'bell-electric',
        tags: [
            'fire alarm',
            'flames',
            'smoke',
            'firefighter',
            'fireman',
            'department',
            'brigade',
            'station',
            'emergency',
            'alert',
            'safety',
            'school bell',
            'period break',
            'recess',
            'doorbell',
            'entrance',
            'entry',
            'ring',
            'reception'
        ]
    },
    {
        name: 'bell-minus',
        tags: ['alarm', 'notification', 'silent', 'reminder', 'delete', 'remove', 'erase']
    },
    {
        name: 'bell-off',
        tags: ['alarm', 'notification', 'silent', 'reminder']
    },
    {
        name: 'bell-plus',
        tags: ['notification', 'silent', 'reminder', 'add', 'create', 'new']
    },
    {
        name: 'bell-ring',
        tags: ['alarm', 'notification', 'sound', 'reminder']
    },
    {
        name: 'between-horizontal-end',
        tags: [
            'insert',
            'add',
            'left',
            'slot',
            'squeeze',
            'space',
            'vertical',
            'grid',
            'table',
            'rows',
            'cells',
            'excel',
            'spreadsheet',
            'accountancy',
            'data',
            'enter',
            'entry',
            'entries',
            'blocks',
            'rectangles',
            'chevron'
        ]
    },
    {
        name: 'between-horizontal-start',
        tags: [
            'insert',
            'add',
            'right',
            'slot',
            'squeeze',
            'space',
            'vertical',
            'grid',
            'table',
            'rows',
            'cells',
            'excel',
            'spreadsheet',
            'accountancy',
            'data',
            'enter',
            'entry',
            'entries',
            'blocks',
            'rectangles',
            'chevron'
        ]
    },
    {
        name: 'between-vertical-end',
        tags: [
            'insert',
            'add',
            'top',
            'slot',
            'squeeze',
            'space',
            'vertical',
            'grid',
            'table',
            'columns',
            'cells',
            'data',
            'enter',
            'entry',
            'entries',
            'blocks',
            'rectangles',
            'chevron'
        ]
    },
    {
        name: 'between-vertical-start',
        tags: [
            'insert',
            'add',
            'bottom',
            'slot',
            'squeeze',
            'space',
            'vertical',
            'grid',
            'table',
            'columns',
            'cells',
            'data',
            'enter',
            'entry',
            'entries',
            'blocks',
            'rectangles',
            'chevron'
        ]
    },
    {
        name: 'biceps-flexed',
        tags: ['arm', 'muscle', 'strong', 'working out', 'athletic', 'toned', 'muscular', 'forelimb', 'curled']
    },
    {
        name: 'bike',
        tags: ['bicycle', 'transport', 'trip']
    },
    {
        name: 'binary',
        tags: ['code', 'digits', 'computer', 'zero', 'one', 'boolean']
    },
    {
        name: 'binoculars',
        tags: [
            'field glasses',
            'lorgnette',
            'pince-nez',
            'observation',
            'sightseeing',
            'nature',
            'wildlife',
            'birdwatching',
            'scouting',
            'surveillance',
            'search',
            'discovery',
            'monitoring',
            'lookout',
            'viewpoint',
            'travel',
            'tourism',
            'research'
        ]
    },
    {
        name: 'biohazard',
        tags: ['fallout', 'waste', 'biology', 'chemistry', 'chemical', 'element']
    },
    {
        name: 'bird',
        tags: ['peace', 'freedom', 'wing', 'avian', 'tweet']
    },
    {
        name: 'bitcoin',
        tags: ['currency', 'money', 'payment']
    },
    {
        name: 'blend',
        tags: [
            'mode',
            'overlay',
            'multiply',
            'screen',
            'opacity',
            'transparency',
            'alpha',
            'filters',
            'lenses',
            'mixed',
            'shades',
            'tints',
            'hues',
            'saturation',
            'brightness',
            'overlap',
            'colors',
            'colours'
        ]
    },
    {
        name: 'blinds',
        tags: ['shades', 'screen', 'curtain', 'shutter', 'roller blind', 'window', 'lighting', 'household', 'home']
    },
    {
        name: 'blocks',
        tags: [
            'addon',
            'plugin',
            'integration',
            'extension',
            'package',
            'build',
            'stack',
            'toys',
            'kids',
            'children',
            'learning'
        ]
    },
    {
        name: 'bluetooth',
        tags: ['wireless']
    },
    {
        name: 'bluetooth-connected',
        tags: ['paired']
    },
    {
        name: 'bluetooth-off',
        tags: ['lost']
    },
    {
        name: 'bluetooth-searching',
        tags: ['pairing']
    },
    {
        name: 'bold',
        tags: ['text', 'strong', 'format']
    },
    {
        name: 'bolt',
        tags: [
            'nut',
            'screw',
            'settings',
            'preferences',
            'configuration',
            'controls',
            'edit',
            'diy',
            'fixed',
            'build',
            'contruction',
            'parts'
        ]
    },
    {
        name: 'bomb',
        tags: ['fatal', 'error', 'crash', 'blockbuster', 'mine', 'explosion', 'explode', 'explosive']
    },
    {
        name: 'bone',
        tags: ['health', 'skeleton', 'skull', 'death', 'pets', 'dog']
    },
    {
        name: 'book',
        tags: [
            'reading',
            'paperback',
            'booklet',
            'magazine',
            'leaflet',
            'pamphlet',
            'tome',
            'library',
            'writing',
            'written',
            'writer',
            'author',
            'story',
            'script',
            'fiction',
            'novel',
            'information',
            'knowledge',
            'education',
            'high school',
            'university',
            'college',
            'academy',
            'student',
            'study',
            'learning',
            'homework',
            'research',
            'documentation'
        ]
    },
    {
        name: 'book-a',
        tags: [
            'dictionary',
            'define',
            'definition',
            'thesaurus',
            'encyclopedia',
            'encyclopaedia',
            'reading',
            'booklet',
            'magazine',
            'leaflet',
            'pamphlet',
            'tome',
            'library',
            'writing',
            'written',
            'writer',
            'author',
            'story',
            'script',
            'fiction',
            'novel',
            'information',
            'knowledge',
            'education',
            'high school',
            'university',
            'college',
            'academy',
            'student',
            'study',
            'learning',
            'homework',
            'research',
            'language',
            'translate',
            'alphabetical',
            'a-z',
            'ordered'
        ]
    },
    {
        name: 'book-audio',
        tags: [
            'audiobook',
            'reading',
            'listening',
            'sound',
            'story',
            'fiction',
            'novel',
            'information',
            'knowledge',
            'education',
            'student',
            'study',
            'learning',
            'research'
        ]
    },
    {
        name: 'book-check',
        tags: [
            'read',
            'booklet',
            'magazine',
            'leaflet',
            'pamphlet',
            'library',
            'written',
            'authored',
            'published',
            'informed',
            'knowledgeable',
            'educated',
            'schooled',
            'homework',
            'examined',
            'tested',
            'marked',
            'passed',
            'graduated',
            'studied',
            'learned',
            'lesson',
            'researched',
            'documented',
            'revealed',
            'blank',
            'plain language',
            'true',
            'truth',
            'verified',
            'corrected',
            'task',
            'todo',
            'done',
            'completed',
            'finished',
            'ticked'
        ]
    },
    {
        name: 'book-copy',
        tags: [
            'code',
            'coding',
            'version control',
            'git',
            'repository',
            'clone',
            'fork',
            'duplicate',
            'multiple',
            'books',
            'library',
            'copies',
            'copied',
            'plagiarism',
            'plagiarised',
            'plagiarized',
            'reading list',
            'information',
            'informed',
            'knowledge',
            'knowledgeable',
            'knowledgable',
            'education',
            'high school',
            'university',
            'college',
            'academy',
            'student',
            'study',
            'learning',
            'research',
            'smart',
            'intelligent',
            'intellectual'
        ]
    },
    {
        name: 'book-dashed',
        tags: [
            'code',
            'coding',
            'version control',
            'git',
            'repository',
            'template',
            'draft',
            'script',
            'screenplay',
            'writing',
            'writer',
            'author',
            'unwritten',
            'unpublished',
            'untold'
        ]
    },
    {
        name: 'book-down',
        tags: ['code', 'coding', 'version control', 'git', 'repository', 'pull']
    },
    {
        name: 'book-headphones',
        tags: [
            'audiobook',
            'reading',
            'listening',
            'sound',
            'story',
            'fiction',
            'novel',
            'information',
            'knowledge',
            'education',
            'student',
            'study',
            'learning',
            'research'
        ]
    },
    {
        name: 'book-heart',
        tags: [
            'diary',
            'romance',
            'novel',
            'journal',
            'entry',
            'entries',
            'personal',
            'private',
            'secret',
            'crush',
            'like',
            'love',
            'emotion',
            'feminine',
            'girls',
            'teens',
            'teenager',
            'therapy',
            'theraputic',
            'therapist',
            'planner',
            'organizer',
            'organiser',
            'notes',
            'notepad',
            'stationery',
            'sketchbook',
            'writing',
            'written',
            'reading',
            'favorite',
            'favourite',
            'high school'
        ]
    },
    {
        name: 'book-image',
        tags: [
            'images',
            'pictures',
            'photos',
            'album',
            'collection',
            'event',
            'magazine',
            'catalog',
            'catalogue',
            'brochure',
            'browse',
            'gallery'
        ]
    },
    {
        name: 'book-key',
        tags: [
            'code',
            'coding',
            'version control',
            'git',
            'repository',
            'private',
            'public',
            'secret',
            'unlocked',
            'hidden',
            'revealed',
            'knowledge',
            'learning'
        ]
    },
    {
        name: 'book-lock',
        tags: ['code', 'coding', 'version control', 'git', 'repository', 'private', 'secret', 'hidden', 'knowledge']
    },
    {
        name: 'book-marked',
        tags: [
            'dictionary',
            'reading',
            'booklet',
            'magazine',
            'leaflet',
            'pamphlet',
            'tome',
            'library',
            'writing',
            'written',
            'writer',
            'author',
            'story',
            'script',
            'fiction',
            'novel',
            'information',
            'knowledge',
            'education',
            'high school',
            'university',
            'college',
            'academy',
            'student',
            'study',
            'learning',
            'homework',
            'research',
            'documentation',
            'saved',
            'later',
            'future',
            'reference',
            'index',
            'code',
            'coding',
            'version control',
            'git',
            'repository'
        ]
    },
    {
        name: 'book-minus',
        tags: [
            'code',
            'coding',
            'version control',
            'git',
            'repository',
            'remove',
            'delete',
            'censor',
            'cancel',
            'forbid',
            'prohibit',
            'ban',
            'uneducated',
            're-educate',
            'unlearn',
            'downgrade'
        ]
    },
    {
        name: 'book-open',
        tags: [
            'reading',
            'pages',
            'booklet',
            'magazine',
            'leaflet',
            'pamphlet',
            'library',
            'writing',
            'written',
            'writer',
            'author',
            'story',
            'script',
            'screenplay',
            'fiction',
            'novel',
            'information',
            'knowledge',
            'education',
            'high school',
            'university',
            'college',
            'academy',
            'student',
            'study',
            'learning',
            'homework',
            'research',
            'documentation',
            'revealed',
            'blank',
            'plain'
        ]
    },
    {
        name: 'book-open-check',
        tags: [
            'read',
            'pages',
            'booklet',
            'magazine',
            'leaflet',
            'pamphlet',
            'library',
            'written',
            'authored',
            'published',
            'informed',
            'knowledgeable',
            'educated',
            'schooled',
            'homework',
            'examined',
            'tested',
            'marked',
            'passed',
            'graduated',
            'studied',
            'learned',
            'lesson',
            'researched',
            'documented',
            'revealed',
            'blank',
            'plain language',
            'true',
            'truth',
            'verified',
            'corrected',
            'task',
            'todo',
            'done',
            'completed',
            'finished',
            'ticked'
        ]
    },
    {
        name: 'book-open-text',
        tags: [
            'reading',
            'pages',
            'booklet',
            'magazine',
            'leaflet',
            'pamphlet',
            'library',
            'writing',
            'written',
            'writer',
            'author',
            'story',
            'script',
            'fiction',
            'novel',
            'information',
            'knowledge',
            'education',
            'high school',
            'university',
            'college',
            'academy',
            'student',
            'study',
            'learning',
            'homework',
            'research',
            'documentation',
            'revealed'
        ]
    },
    {
        name: 'book-plus',
        tags: [
            'code',
            'coding',
            'version control',
            'git',
            'repository',
            'remove',
            'delete',
            'read',
            'write',
            'author',
            'publish',
            'inform',
            'graduate',
            're-educate',
            'study',
            'learn',
            'research',
            'knowledge',
            'improve',
            'upgrade',
            'level up'
        ]
    },
    {
        name: 'book-text',
        tags: [
            'reading',
            'booklet',
            'magazine',
            'leaflet',
            'pamphlet',
            'tome',
            'library',
            'writing',
            'written',
            'writer',
            'author',
            'story',
            'script',
            'fiction',
            'novel',
            'information',
            'knowledge',
            'education',
            'high school',
            'university',
            'college',
            'academy',
            'student',
            'study',
            'learning',
            'homework',
            'research',
            'documentation'
        ]
    },
    {
        name: 'book-type',
        tags: [
            'thesaurus',
            'synonym',
            'reading',
            'booklet',
            'magazine',
            'leaflet',
            'pamphlet',
            'tome',
            'library',
            'writing',
            'written',
            'writer',
            'author',
            'story',
            'script',
            'fiction',
            'novel',
            'information',
            'knowledge',
            'education',
            'high school',
            'university',
            'college',
            'academy',
            'student',
            'study',
            'learning',
            'homework',
            'research',
            'language',
            'translate',
            'typography',
            'fonts',
            'collection'
        ]
    },
    {
        name: 'book-up',
        tags: ['code', 'coding', 'version control', 'git', 'repository', 'push']
    },
    {
        name: 'book-up-2',
        tags: ['code', 'coding', 'version control', 'git', 'repository', 'push', 'force']
    },
    {
        name: 'book-user',
        tags: [
            'person',
            'people',
            'family',
            'friends',
            'acquaintances',
            'contacts',
            'details',
            'addresses',
            'phone numbers',
            'directory',
            'listing',
            'networking'
        ]
    },
    {
        name: 'book-x',
        tags: [
            'code',
            'coding',
            'version control',
            'git',
            'repository',
            'remove',
            'delete',
            'reading',
            'misinformation',
            'disinformation',
            'misinformed',
            'charlatan',
            'sophistry',
            'false',
            'lies',
            'untruth',
            'propaganda',
            'censored',
            'cancelled',
            'forbidden',
            'prohibited',
            'banned',
            'uneducated',
            're-education',
            'unlearn'
        ]
    },
    {
        name: 'bookmark',
        tags: ['read', 'clip', 'marker', 'tag']
    },
    {
        name: 'bookmark-check',
        tags: ['read', 'finished', 'complete', 'clip', 'marker', 'tag', 'task', 'todo']
    },
    {
        name: 'bookmark-minus',
        tags: ['delete', 'remove']
    },
    {
        name: 'bookmark-plus',
        tags: ['add']
    },
    {
        name: 'bookmark-x',
        tags: ['read', 'clip', 'marker', 'tag', 'cancel', 'close', 'delete', 'remove', 'clear']
    },
    {
        name: 'boom-box',
        tags: ['radio', 'speakers', 'audio', 'music', 'sound', 'broadcast', 'live', 'frequency']
    },
    {
        name: 'bot',
        tags: ['robot', 'ai', 'chat', 'assistant']
    },
    {
        name: 'bot-message-square',
        tags: ['robot', 'ai', 'chat', 'assistant']
    },
    {
        name: 'bot-off',
        tags: ['robot', 'ai', 'chat', 'assistant']
    },
    {
        name: 'box',
        tags: ['cube', 'package', 'container', 'storage', 'geometry', '3d', 'isometric']
    },
    {
        name: 'boxes',
        tags: ['cubes', 'packages', 'parts', 'group', 'units', 'collection', 'cluster', 'geometry']
    },
    {
        name: 'braces',
        tags: ['json', 'code', 'token', 'curly brackets', 'data', '{', '}']
    },
    {
        name: 'brackets',
        tags: ['code', 'token', 'array', 'list', 'square', '[', ']']
    },
    {
        name: 'brain',
        tags: ['medical', 'mind', 'intellect', 'cerebral', 'consciousness', 'genius', 'artificial intelligence', 'ai']
    },
    {
        name: 'brain-circuit',
        tags: ['mind', 'intellect', 'artificial intelligence', 'ai', 'deep learning', 'machine learning', 'computing']
    },
    {
        name: 'brain-cog',
        tags: ['mind', 'intellect', 'artificial intelligence', 'ai', 'deep learning', 'machine learning', 'computing']
    },
    {
        name: 'brick-wall',
        tags: [
            'bricks',
            'mortar',
            'cement',
            'materials',
            'construction',
            'builder',
            'labourer',
            'quantity surveyor',
            'blocks',
            'stone'
        ]
    },
    {
        name: 'briefcase',
        tags: ['work', 'bag', 'baggage', 'folder']
    },
    {
        name: 'briefcase-business',
        tags: ['work', 'bag', 'baggage', 'folder', 'portfolio']
    },
    {
        name: 'briefcase-medical',
        tags: ['doctor', 'medicine', 'first aid']
    },
    {
        name: 'bring-to-front',
        tags: ['bring', 'send', 'move', 'over', 'forward', 'front', 'overlap', 'layer', 'order']
    },
    {
        name: 'brush',
        tags: ['draw', 'paint', 'color', 'artist']
    },
    {
        name: 'bug',
        tags: ['issue', 'report', 'debug', 'code', 'insect']
    },
    {
        name: 'bug-off',
        tags: ['debug', 'code', 'insect', 'kill', 'exterminate', 'pest control']
    },
    {
        name: 'bug-play',
        tags: ['debug', 'code', 'insect']
    },
    {
        name: 'building',
        tags: ['organisation', 'organization']
    },
    {
        name: 'building-2',
        tags: ['business', 'company', 'enterprise', 'skyscraper', 'organisation', 'organization']
    },
    {
        name: 'bus',
        tags: ['bus', 'vehicle', 'transport', 'trip']
    },
    {
        name: 'bus-front',
        tags: ['coach', 'vehicle', 'trip', 'road']
    },
    {
        name: 'cable',
        tags: [
            'cord',
            'wire',
            'connector',
            'connection',
            'link',
            'signal',
            'console',
            'computer',
            'equipment',
            'electricity',
            'energy',
            'electronics',
            'recharging',
            'charger',
            'power',
            'supply',
            'disconnected',
            'unplugged',
            'plugs',
            'interface',
            'input',
            'output',
            'audio video',
            'av',
            'rca',
            'scart',
            'tv',
            'television',
            'optical'
        ]
    },
    {
        name: 'cable-car',
        tags: ['ski lift', 'winter holiday', 'alpine', 'resort', 'mountains']
    },
    {
        name: 'cake',
        tags: [
            'birthday',
            'birthdate',
            'celebration',
            'party',
            'surprise',
            'gateaux',
            'dessert',
            'fondant',
            'icing sugar',
            'sweet',
            'baking'
        ]
    },
    {
        name: 'cake-slice',
        tags: [
            'birthday',
            'birthdate',
            'celebration',
            'party',
            'surprise',
            'gateaux',
            'dessert',
            'candles',
            'wish',
            'fondant',
            'icing sugar',
            'sweet',
            'baking'
        ]
    },
    {
        name: 'calculator',
        tags: ['count', 'calculating machine']
    },
    {
        name: 'calendar',
        tags: ['date', 'month', 'year', 'event', 'birthday', 'birthdate']
    },
    {
        name: 'calendar-arrow-down',
        tags: [
            'date',
            'month',
            'year',
            'event',
            'sort',
            'order',
            'ascending',
            'descending',
            'increasing',
            'decreasing',
            'rising',
            'falling'
        ]
    },
    {
        name: 'calendar-arrow-up',
        tags: [
            'date',
            'month',
            'year',
            'event',
            'sort',
            'order',
            'ascending',
            'descending',
            'increasing',
            'decreasing',
            'rising',
            'falling'
        ]
    },
    {
        name: 'calendar-check',
        tags: [
            'date',
            'day',
            'month',
            'year',
            'event',
            'confirm',
            'subscribe',
            'schedule',
            'done',
            'todo',
            'tick',
            'complete',
            'task'
        ]
    },
    {
        name: 'calendar-check-2',
        tags: [
            'date',
            'day',
            'month',
            'year',
            'event',
            'confirm',
            'subscribe',
            'schedule',
            'done',
            'todo',
            'tick',
            'complete',
            'task'
        ]
    },
    {
        name: 'calendar-clock',
        tags: ['date', 'day', 'month', 'year', 'event', 'clock', 'hour']
    },
    {
        name: 'calendar-cog',
        tags: ['date', 'day', 'month', 'year', 'events', 'settings', 'gear', 'cog']
    },
    {
        name: 'calendar-days',
        tags: ['date', 'month', 'year', 'event']
    },
    {
        name: 'calendar-fold',
        tags: ['date', 'month', 'year', 'event', 'birthday', 'birthdate', 'ics']
    },
    {
        name: 'calendar-heart',
        tags: ['date', 'month', 'year', 'event', 'heart', 'favourite', 'subscribe', 'valentines day']
    },
    {
        name: 'calendar-minus',
        tags: ['date', 'day', 'month', 'year', 'event', 'delete', 'remove']
    },
    {
        name: 'calendar-minus-2',
        tags: ['date', 'day', 'month', 'year', 'event', 'delete', 'remove']
    },
    {
        name: 'calendar-off',
        tags: ['date', 'day', 'month', 'year', 'event', 'delete', 'remove']
    },
    {
        name: 'calendar-plus',
        tags: ['date', 'day', 'month', 'year', 'event', 'add', 'subscribe', 'create', 'new']
    },
    {
        name: 'calendar-plus-2',
        tags: ['date', 'day', 'month', 'year', 'event', 'add', 'subscribe', 'create', 'new']
    },
    {
        name: 'calendar-range',
        tags: ['date', 'day', 'month', 'year', 'event', 'range', 'period']
    },
    {
        name: 'calendar-search',
        tags: ['date', 'day', 'month', 'year', 'events', 'search']
    },
    {
        name: 'calendar-x',
        tags: ['date', 'day', 'month', 'year', 'event', 'remove', 'busy']
    },
    {
        name: 'calendar-x-2',
        tags: ['date', 'day', 'month', 'year', 'event', 'remove']
    },
    {
        name: 'camera',
        tags: ['photo', 'webcam', 'video']
    },
    {
        name: 'camera-off',
        tags: ['photo', 'webcam', 'video']
    },
    {
        name: 'candy',
        tags: ['sugar', 'food', 'sweet']
    },
    {
        name: 'candy-cane',
        tags: ['sugar', 'food', 'sweet', 'christmas', 'xmas']
    },
    {
        name: 'candy-off',
        tags: ['sugar free', 'food', 'sweet', 'allergy', 'intolerance', 'diet']
    },
    {
        name: 'cannabis',
        tags: ['cannabis', 'weed', 'leaf']
    },
    {
        name: 'captions',
        tags: ['closed captions', 'subtitles', 'subhead', 'transcription', 'transcribe', 'dialogue', 'accessibility']
    },
    {
        name: 'captions-off',
        tags: ['closed captions', 'subtitles', 'subhead', 'transcription', 'transcribe', 'dialogue', 'accessibility']
    },
    {
        name: 'car',
        tags: ['vehicle', 'drive', 'trip', 'journey']
    },
    {
        name: 'car-front',
        tags: ['vehicle', 'drive', 'trip', 'journey']
    },
    {
        name: 'car-taxi-front',
        tags: ['cab', 'vehicle', 'drive', 'trip', 'journey']
    },
    {
        name: 'caravan',
        tags: ['trailer', 'tow', 'camping', 'campsite', 'mobile home', 'holiday', 'nomadic', 'wilderness', 'outdoors']
    },
    {
        name: 'carrot',
        tags: ['vegetable', 'food', 'eat']
    },
    {
        name: 'case-lower',
        tags: ['text', 'letters', 'characters', 'font', 'typography']
    },
    {
        name: 'case-sensitive',
        tags: ['text', 'letters', 'characters', 'font', 'typography']
    },
    {
        name: 'case-upper',
        tags: ['text', 'letters', 'characters', 'font', 'typography']
    },
    {
        name: 'cassette-tape',
        tags: ['audio', 'music', 'recording', 'play']
    },
    {
        name: 'cast',
        tags: ['chromecast', 'airplay', 'screen']
    },
    {
        name: 'castle',
        tags: ['fortress', 'stronghold', 'palace', 'chateau', 'building']
    },
    {
        name: 'cat',
        tags: ['animal', 'pet', 'kitten', 'feline']
    },
    {
        name: 'cctv',
        tags: ['camera', 'surveillance', 'recording', 'film', 'videotape', 'crime', 'watching']
    },
    {
        name: 'chart-area',
        tags: ['statistics', 'analytics', 'diagram', 'graph', 'area']
    },
    {
        name: 'chart-bar',
        tags: ['statistics', 'analytics', 'diagram', 'graph']
    },
    {
        name: 'chart-bar-big',
        tags: ['statistics', 'analytics', 'diagram', 'graph']
    },
    {
        name: 'chart-bar-decreasing',
        tags: ['statistics', 'analytics', 'diagram', 'graph', 'trending down']
    },
    {
        name: 'chart-bar-increasing',
        tags: ['statistics', 'analytics', 'diagram', 'graph', 'trending up']
    },
    {
        name: 'chart-bar-stacked',
        tags: ['statistics', 'analytics', 'diagram', 'graph', 'multivariate', 'categorical', 'comparison']
    },
    {
        name: 'chart-candlestick',
        tags: [
            'trading',
            'trader',
            'financial',
            'markets',
            'portfolio',
            'assets',
            'prices',
            'value',
            'valuation',
            'commodities',
            'currencies',
            'currency',
            'exchange',
            'hedge fund',
            'statistics',
            'analytics',
            'diagram',
            'graph'
        ]
    },
    {
        name: 'chart-column',
        tags: ['statistics', 'analytics', 'diagram', 'graph']
    },
    {
        name: 'chart-column-big',
        tags: ['statistics', 'analytics', 'diagram', 'graph']
    },
    {
        name: 'chart-column-decreasing',
        tags: ['statistics', 'analytics', 'diagram', 'graph', 'trending down']
    },
    {
        name: 'chart-column-increasing',
        tags: ['statistics', 'analytics', 'diagram', 'graph', 'trending up']
    },
    {
        name: 'chart-column-stacked',
        tags: ['statistics', 'analytics', 'diagram', 'graph', 'multivariate', 'categorical', 'comparison']
    },
    {
        name: 'chart-gantt',
        tags: ['diagram', 'graph', 'timeline', 'planning']
    },
    {
        name: 'chart-line',
        tags: ['statistics', 'analytics', 'diagram', 'graph']
    },
    {
        name: 'chart-network',
        tags: [
            'statistics',
            'analytics',
            'diagram',
            'graph',
            'topology',
            'cluster',
            'web',
            'nodes',
            'connections',
            'edges'
        ]
    },
    {
        name: 'chart-no-axes-column',
        tags: ['statistics', 'analytics', 'diagram', 'graph']
    },
    {
        name: 'chart-no-axes-column-decreasing',
        tags: ['statistics', 'analytics', 'diagram', 'graph', 'trending down']
    },
    {
        name: 'chart-no-axes-column-increasing',
        tags: ['statistics', 'analytics', 'diagram', 'graph', 'trending up']
    },
    {
        name: 'chart-no-axes-combined',
        tags: ['statistics', 'analytics', 'diagram', 'graph', 'trending up']
    },
    {
        name: 'chart-no-axes-gantt',
        tags: [
            'projects',
            'manage',
            'overview',
            'roadmap',
            'plan',
            'intentions',
            'timeline',
            'deadline',
            'date',
            'event',
            'range',
            'period',
            'productivity',
            'work',
            'agile',
            'code',
            'coding'
        ]
    },
    {
        name: 'chart-pie',
        tags: ['statistics', 'analytics', 'diagram', 'presentation']
    },
    {
        name: 'chart-scatter',
        tags: ['statistics', 'analytics', 'diagram', 'graph']
    },
    {
        name: 'chart-spline',
        tags: [
            'statistics',
            'analytics',
            'diagram',
            'graph',
            'curve',
            'continuous',
            'smooth',
            'polynomial',
            'quadratic',
            'function',
            'interpolation'
        ]
    },
    {
        name: 'check',
        tags: ['done', 'todo', 'tick', 'complete', 'task']
    },
    {
        name: 'check-check',
        tags: ['done', 'received', 'double', 'todo', 'tick', 'complete', 'task']
    },
    {
        name: 'chef-hat',
        tags: ['cooking', 'food', 'kitchen', 'restaurant']
    },
    {
        name: 'cherry',
        tags: ['fruit', 'food']
    },
    {
        name: 'chevron-down',
        tags: ['backwards', 'reverse', 'slow', 'dropdown']
    },
    {
        name: 'chevron-first',
        tags: ['previous', 'music']
    },
    {
        name: 'chevron-last',
        tags: ['skip', 'next', 'music']
    },
    {
        name: 'chevron-left',
        tags: ['back', 'previous', 'less than', 'fewer', 'menu', '<']
    },
    {
        name: 'chevron-right',
        tags: [
            'forward',
            'next',
            'more than',
            'greater',
            'menu',
            'code',
            'coding',
            'command line',
            'terminal',
            'prompt',
            'shell',
            '>'
        ]
    },
    {
        name: 'chevron-up',
        tags: [
            'caret',
            'keyboard',
            'mac',
            'control',
            'ctrl',
            'superscript',
            'exponential',
            'power',
            'ahead',
            'fast',
            '^',
            'dropdown'
        ]
    },
    {
        name: 'chevrons-down',
        tags: ['backwards', 'reverse', 'slower']
    },
    {
        name: 'chevrons-down-up',
        tags: ['collapse', 'fold', 'vertical']
    },
    {
        name: 'chevrons-left',
        tags: ['turn', 'corner']
    },
    {
        name: 'chevrons-left-right',
        tags: ['expand', 'horizontal', 'unfold']
    },
    {
        name: 'chevrons-left-right-ellipsis',
        tags: [
            'internet',
            'network',
            'connection',
            'cable',
            'lan',
            'port',
            'router',
            'switch',
            'hub',
            'modem',
            'web',
            'online',
            'networking',
            'communication',
            'socket',
            'plug',
            'slot',
            'controller',
            'connector',
            'interface',
            'console',
            'signal',
            'data',
            'input',
            'output'
        ]
    },
    {
        name: 'chevrons-right',
        tags: ['turn', 'corner']
    },
    {
        name: 'chevrons-right-left',
        tags: ['collapse', 'fold', 'horizontal']
    },
    {
        name: 'chevrons-up',
        tags: ['forward', 'ahead', 'faster', 'speed', 'boost']
    },
    {
        name: 'chevrons-up-down',
        tags: ['expand', 'unfold', 'vertical']
    },
    {
        name: 'chrome',
        tags: ['browser', 'logo']
    },
    {
        name: 'church',
        tags: ['temple', 'building']
    },
    {
        name: 'cigarette',
        tags: ['smoking']
    },
    {
        name: 'cigarette-off',
        tags: ['smoking', 'no-smoking']
    },
    {
        name: 'circle',
        tags: ['off', 'zero', 'record', 'shape']
    },
    {
        name: 'circle-alert',
        tags: ['warning', 'alert', 'danger', 'exclamation mark']
    },
    {
        name: 'circle-arrow-down',
        tags: ['backwards', 'reverse', 'direction', 'south', 'sign', 'button']
    },
    {
        name: 'circle-arrow-left',
        tags: ['previous', 'back', 'direction', 'west', 'sign', 'turn', 'button', '<-']
    },
    {
        name: 'circle-arrow-out-down-left',
        tags: ['outwards', 'direction', 'south-west', 'diagonal']
    },
    {
        name: 'circle-arrow-out-down-right',
        tags: ['outwards', 'direction', 'south-east', 'diagonal']
    },
    {
        name: 'circle-arrow-out-up-left',
        tags: ['outwards', 'direction', 'north-west', 'diagonal', 'keyboard', 'button', 'escape']
    },
    {
        name: 'circle-arrow-out-up-right',
        tags: ['outwards', 'direction', 'north-east', 'diagonal']
    },
    {
        name: 'circle-arrow-right',
        tags: ['next', 'forward', 'direction', 'east', 'sign', 'turn', 'button', '->']
    },
    {
        name: 'circle-arrow-up',
        tags: ['forward', 'direction', 'north', 'sign', 'button']
    },
    {
        name: 'circle-check',
        tags: ['done', 'todo', 'tick', 'complete', 'task']
    },
    {
        name: 'circle-check-big',
        tags: ['done', 'todo', 'tick', 'complete', 'task']
    },
    {
        name: 'circle-chevron-down',
        tags: ['back', 'menu']
    },
    {
        name: 'circle-chevron-left',
        tags: ['back', 'previous', 'less than', 'fewer', 'menu', '<']
    },
    {
        name: 'circle-chevron-right',
        tags: ['back', 'more than', 'greater', 'menu', '>']
    },
    {
        name: 'circle-chevron-up',
        tags: ['caret', 'ahead', 'menu', '^']
    },
    {
        name: 'circle-dashed',
        tags: ['pending', 'dot', 'progress', 'issue', 'draft', 'code', 'coding', 'version control']
    },
    {
        name: 'circle-divide',
        tags: ['calculate', 'maths', '÷', '/']
    },
    {
        name: 'circle-dollar-sign',
        tags: ['monetization', 'marketing', 'currency', 'money', 'payment']
    },
    {
        name: 'circle-dot',
        tags: [
            'pending',
            'dot',
            'progress',
            'issue',
            'code',
            'coding',
            'version control',
            'choices',
            'multiple choice',
            'choose'
        ]
    },
    {
        name: 'circle-dot-dashed',
        tags: ['pending', 'dot', 'progress', 'issue', 'draft', 'code', 'coding', 'version control']
    },
    {
        name: 'circle-ellipsis',
        tags: [
            'ellipsis',
            'et cetera',
            'etc',
            'loader',
            'loading',
            'progress',
            'pending',
            'throbber',
            'menu',
            'options',
            'operator',
            'code',
            'spread',
            'rest',
            'more',
            'further',
            'extra',
            'overflow',
            'dots',
            '…',
            '...'
        ]
    },
    {
        name: 'circle-equal',
        tags: ['calculate', 'shape', '=']
    },
    {
        name: 'circle-fading-arrow-up',
        tags: ['north', 'up', 'upgrade', 'improve', 'circle', 'button']
    },
    {
        name: 'circle-fading-plus',
        tags: ['stories', 'social media', 'instagram', 'facebook', 'meta', 'snapchat', 'sharing', 'content']
    },
    {
        name: 'circle-gauge',
        tags: ['dashboard', 'dial', 'meter', 'speed', 'pressure', 'measure', 'level']
    },
    {
        name: 'circle-help',
        tags: ['question mark']
    },
    {
        name: 'circle-minus',
        tags: [
            'subtract',
            'remove',
            'decrease',
            'reduce',
            'calculate',
            'line',
            'operator',
            'code',
            'coding',
            'minimum',
            'downgrade',
            '-'
        ]
    },
    {
        name: 'circle-off',
        tags: [
            'diameter',
            'zero',
            'Ø',
            'nothing',
            'null',
            'void',
            'cancel',
            'ban',
            'no',
            'stop',
            'forbidden',
            'prohibited',
            'error',
            'incorrect',
            'mistake',
            'wrong',
            'failure'
        ]
    },
    {
        name: 'circle-parking',
        tags: ['parking lot', 'car park']
    },
    {
        name: 'circle-parking-off',
        tags: ['parking lot', 'car park', 'no parking']
    },
    {
        name: 'circle-pause',
        tags: ['music', 'audio', 'stop']
    },
    {
        name: 'circle-percent',
        tags: ['verified', 'unverified', 'sale', 'discount', 'offer', 'marketing', 'sticker', 'price tag']
    },
    {
        name: 'circle-play',
        tags: ['music', 'start', 'run']
    },
    {
        name: 'circle-plus',
        tags: [
            'add',
            'new',
            'increase',
            'increment',
            'positive',
            'calculate',
            'crosshair',
            'aim',
            'target',
            'scope',
            'sight',
            'reticule',
            'maximum',
            'upgrade',
            'extra',
            'operator',
            'join',
            'concatenate',
            'code',
            'coding',
            '+'
        ]
    },
    {
        name: 'circle-power',
        tags: [
            'on',
            'off',
            'device',
            'switch',
            'toggle',
            'binary',
            'boolean',
            'reboot',
            'restart',
            'button',
            'keyboard',
            'troubleshoot'
        ]
    },
    {
        name: 'circle-slash',
        tags: [
            'diameter',
            'zero',
            'Ø',
            'nothing',
            'null',
            'void',
            'cancel',
            'ban',
            'no',
            'stop',
            'forbidden',
            'prohibited',
            'error',
            'incorrect',
            'mistake',
            'wrong',
            'failure',
            'divide',
            'division',
            'or',
            '/'
        ]
    },
    {
        name: 'circle-slash-2',
        tags: [
            'diameter',
            'zero',
            'Ø',
            'nothing',
            'null',
            'void',
            'ban',
            'maths',
            'divide',
            'division',
            'half',
            'split',
            '/'
        ]
    },
    {
        name: 'circle-stop',
        tags: ['media', 'music']
    },
    {
        name: 'circle-user',
        tags: ['person', 'account', 'contact']
    },
    {
        name: 'circle-user-round',
        tags: ['person', 'account', 'contact']
    },
    {
        name: 'circle-x',
        tags: [
            'cancel',
            'close',
            'delete',
            'remove',
            'times',
            'clear',
            'error',
            'incorrect',
            'wrong',
            'mistake',
            'failure',
            'linter',
            'multiply',
            'multiplication'
        ]
    },
    {
        name: 'circuit-board',
        tags: ['computing', 'electricity', 'electronics']
    },
    {
        name: 'citrus',
        tags: ['lemon', 'orange', 'grapefruit', 'fruit']
    },
    {
        name: 'clapperboard',
        tags: [
            'movie',
            'film',
            'video',
            'camera',
            'cinema',
            'cut',
            'action',
            'television',
            'tv',
            'show',
            'entertainment'
        ]
    },
    {
        name: 'clipboard',
        tags: ['copy', 'paste']
    },
    {
        name: 'clipboard-check',
        tags: ['copied', 'pasted', 'done', 'todo', 'tick', 'complete', 'task']
    },
    {
        name: 'clipboard-copy',
        tags: ['copy', 'paste']
    },
    {
        name: 'clipboard-list',
        tags: ['copy', 'paste', 'tasks']
    },
    {
        name: 'clipboard-minus',
        tags: ['copy', 'delete', 'remove', 'erase', 'document', 'medical', 'report', 'doctor']
    },
    {
        name: 'clipboard-paste',
        tags: ['copy', 'paste']
    },
    {
        name: 'clipboard-pen',
        tags: ['paste', 'signature']
    },
    {
        name: 'clipboard-pen-line',
        tags: ['paste']
    },
    {
        name: 'clipboard-plus',
        tags: ['copy', 'paste', 'add', 'create', 'new', 'document', 'medical', 'report', 'doctor']
    },
    {
        name: 'clipboard-type',
        tags: ['paste', 'format', 'text']
    },
    {
        name: 'clipboard-x',
        tags: ['copy', 'paste', 'discard', 'remove']
    },
    {
        name: 'clock',
        tags: ['time', 'watch', 'alarm']
    },
    {
        name: 'clock-1',
        tags: ['time', 'watch', 'alarm']
    },
    {
        name: 'clock-10',
        tags: ['time', 'watch', 'alarm']
    },
    {
        name: 'clock-11',
        tags: ['time', 'watch', 'alarm']
    },
    {
        name: 'clock-12',
        tags: ['time', 'watch', 'alarm', 'noon', 'midnight']
    },
    {
        name: 'clock-2',
        tags: ['time', 'watch', 'alarm']
    },
    {
        name: 'clock-3',
        tags: ['time', 'watch', 'alarm']
    },
    {
        name: 'clock-4',
        tags: ['time', 'watch', 'alarm']
    },
    {
        name: 'clock-5',
        tags: ['time', 'watch', 'alarm']
    },
    {
        name: 'clock-6',
        tags: ['time', 'watch', 'alarm']
    },
    {
        name: 'clock-7',
        tags: ['time', 'watch', 'alarm']
    },
    {
        name: 'clock-8',
        tags: ['time', 'watch', 'alarm']
    },
    {
        name: 'clock-9',
        tags: ['time', 'watch', 'alarm']
    },
    {
        name: 'clock-alert',
        tags: ['time', 'watch', 'alarm', 'warning', 'wrong']
    },
    {
        name: 'clock-arrow-down',
        tags: [
            'time',
            'watch',
            'alarm',
            'sort',
            'order',
            'ascending',
            'descending',
            'increasing',
            'decreasing',
            'rising',
            'falling'
        ]
    },
    {
        name: 'clock-arrow-up',
        tags: [
            'time',
            'watch',
            'alarm',
            'sort',
            'order',
            'ascending',
            'descending',
            'increasing',
            'decreasing',
            'rising',
            'falling'
        ]
    },
    {
        name: 'cloud',
        tags: ['weather']
    },
    {
        name: 'cloud-cog',
        tags: ['computing', 'ai', 'cluster', 'network']
    },
    {
        name: 'cloud-download',
        tags: ['import']
    },
    {
        name: 'cloud-drizzle',
        tags: ['weather', 'shower']
    },
    {
        name: 'cloud-fog',
        tags: ['weather', 'mist']
    },
    {
        name: 'cloud-hail',
        tags: ['weather', 'rainfall']
    },
    {
        name: 'cloud-lightning',
        tags: ['weather', 'bolt']
    },
    {
        name: 'cloud-moon',
        tags: ['weather', 'night']
    },
    {
        name: 'cloud-moon-rain',
        tags: ['weather', 'partly', 'night', 'rainfall']
    },
    {
        name: 'cloud-off',
        tags: ['disconnect']
    },
    {
        name: 'cloud-rain',
        tags: ['weather', 'rainfall']
    },
    {
        name: 'cloud-rain-wind',
        tags: ['weather', 'rainfall']
    },
    {
        name: 'cloud-snow',
        tags: ['weather', 'blizzard']
    },
    {
        name: 'cloud-sun',
        tags: ['weather', 'partly']
    },
    {
        name: 'cloud-sun-rain',
        tags: ['weather', 'partly', 'rainfall']
    },
    {
        name: 'cloud-upload',
        tags: ['file']
    },
    {
        name: 'cloudy',
        tags: ['weather', 'clouds']
    },
    {
        name: 'clover',
        tags: ['leaf', 'luck', 'plant']
    },
    {
        name: 'club',
        tags: ['shape', 'suit', 'playing', 'cards']
    },
    {
        name: 'code',
        tags: ['source', 'programming', 'html', 'xml']
    },
    {
        name: 'code-xml',
        tags: ['source', 'programming', 'html', 'xml']
    },
    {
        name: 'codepen',
        tags: ['logo']
    },
    {
        name: 'codesandbox',
        tags: ['logo']
    },
    {
        name: 'coffee',
        tags: ['drink', 'cup', 'mug', 'tea', 'cafe', 'hot', 'beverage']
    },
    {
        name: 'cog',
        tags: ['computing', 'settings', 'cog', 'edit', 'gear', 'preferences']
    },
    {
        name: 'coins',
        tags: ['money', 'cash', 'finance', 'gamble']
    },
    {
        name: 'columns-2',
        tags: [
            'lines',
            'list',
            'queue',
            'preview',
            'panel',
            'parallel',
            'series',
            'split',
            'vertical',
            'horizontal',
            'half',
            'center',
            'middle',
            'even',
            'sidebar',
            'drawer',
            'gutter',
            'fold',
            'reflow',
            'typography',
            'pagination',
            'pages'
        ]
    },
    {
        name: 'columns-3',
        tags: [
            'lines',
            'list',
            'queue',
            'preview',
            'parallel',
            'series',
            'split',
            'vertical',
            'horizontal',
            'thirds',
            'triple',
            'center',
            'middle',
            'alignment',
            'even',
            'sidebars',
            'drawers',
            'gutters',
            'fold',
            'reflow',
            'typography',
            'pagination',
            'pages'
        ]
    },
    {
        name: 'columns-4',
        tags: [
            'lines',
            'list',
            'queue',
            'preview',
            'parallel',
            'series',
            'split',
            'vertical',
            'horizontal',
            'thirds',
            'triple',
            'center',
            'middle',
            'alignment',
            'even',
            'sidebars',
            'drawers',
            'gutters',
            'fold',
            'reflow',
            'typography',
            'pagination',
            'pages',
            'prison',
            'jail',
            'bars',
            'sentence',
            'police',
            'cops',
            'cell',
            'crime',
            'criminal',
            'justice',
            'law',
            'enforcement',
            'grill'
        ]
    },
    {
        name: 'combine',
        tags: ['cubes', 'packages', 'parts', 'units', 'collection', 'cluster', 'combine', 'gather', 'merge']
    },
    {
        name: 'command',
        tags: ['keyboard', 'key', 'mac', 'cmd', 'button']
    },
    {
        name: 'compass',
        tags: ['direction', 'north', 'east', 'south', 'west', 'safari', 'browser']
    },
    {
        name: 'component',
        tags: ['design', 'element', 'group', 'module', 'part', 'symbol']
    },
    {
        name: 'computer',
        tags: ['pc', 'chassis', 'codespaces', 'github']
    },
    {
        name: 'concierge-bell',
        tags: ['reception', 'bell', 'porter']
    },
    {
        name: 'cone',
        tags: [
            'conical',
            'triangle',
            'triangular',
            'geometry',
            'filter',
            'funnel',
            'hopper',
            'spotlight',
            'searchlight'
        ]
    },
    {
        name: 'construction',
        tags: ['roadwork', 'maintenance', 'blockade', 'barricade']
    },
    {
        name: 'contact',
        tags: ['user', 'person', 'family', 'friend', 'acquaintance', 'listing', 'networking']
    },
    {
        name: 'contact-round',
        tags: ['user', 'person', 'family', 'friend', 'acquaintance', 'listing', 'networking']
    },
    {
        name: 'container',
        tags: ['storage', 'shipping', 'freight', 'supply chain', 'docker', 'environment', 'devops', 'code', 'coding']
    },
    {
        name: 'contrast',
        tags: ['display', 'accessibility']
    },
    {
        name: 'cookie',
        tags: ['biscuit', 'privacy', 'legal', 'food']
    },
    {
        name: 'cooking-pot',
        tags: [
            'pod',
            'cooking',
            'recipe',
            'food',
            'kitchen',
            'chef',
            'restaurant',
            'dinner',
            'lunch',
            'breakfast',
            'meal',
            'eat'
        ]
    },
    {
        name: 'copy',
        tags: ['clone', 'duplicate', 'multiple']
    },
    {
        name: 'copy-check',
        tags: ['clone', 'duplicate', 'done', 'multiple']
    },
    {
        name: 'copy-minus',
        tags: ['clone', 'duplicate', 'remove', 'delete', 'collapse', 'subtract', 'multiple', '-']
    },
    {
        name: 'copy-plus',
        tags: ['clone', 'duplicate', 'add', 'multiple', 'expand', '+']
    },
    {
        name: 'copy-slash',
        tags: [
            'clone',
            'duplicate',
            'cancel',
            'ban',
            'no',
            'stop',
            'forbidden',
            'prohibited',
            'error',
            'multiple',
            'divide',
            'division',
            'split',
            'or',
            '/'
        ]
    },
    {
        name: 'copy-x',
        tags: ['cancel', 'close', 'delete', 'remove', 'clear', 'multiple', 'multiply', 'multiplication', 'times']
    },
    {
        name: 'copyleft',
        tags: ['licence']
    },
    {
        name: 'copyright',
        tags: ['licence', 'license']
    },
    {
        name: 'corner-down-left',
        tags: ['arrow', 'return']
    },
    {
        name: 'corner-down-right',
        tags: ['arrow', 'indent', 'tab']
    },
    {
        name: 'corner-left-down',
        tags: ['arrow']
    },
    {
        name: 'corner-left-up',
        tags: ['arrow']
    },
    {
        name: 'corner-right-down',
        tags: ['arrow']
    },
    {
        name: 'corner-right-up',
        tags: ['arrow']
    },
    {
        name: 'corner-up-left',
        tags: ['arrow']
    },
    {
        name: 'corner-up-right',
        tags: ['arrow']
    },
    {
        name: 'cpu',
        tags: [
            'processor',
            'cores',
            'technology',
            'computer',
            'chip',
            'circuit',
            'memory',
            'ram',
            'specs',
            'gigahertz',
            'ghz'
        ]
    },
    {
        name: 'creative-commons',
        tags: ['licence', 'license']
    },
    {
        name: 'credit-card',
        tags: ['bank', 'purchase', 'payment', 'cc']
    },
    {
        name: 'croissant',
        tags: ['bakery', 'cooking', 'food', 'pastry']
    },
    {
        name: 'crop',
        tags: ['photo', 'image']
    },
    {
        name: 'cross',
        tags: ['healthcare', 'first aid']
    },
    {
        name: 'crosshair',
        tags: ['aim', 'target']
    },
    {
        name: 'crown',
        tags: ['diadem', 'tiara', 'circlet', 'corona', 'king', 'ruler', 'winner', 'favourite']
    },
    {
        name: 'cuboid',
        tags: ['brick', 'block', 'container', 'storage', 'geometry', 'rectangular', 'hexahedron']
    },
    {
        name: 'cup-soda',
        tags: ['beverage', 'cup', 'drink', 'soda', 'straw', 'water']
    },
    {
        name: 'currency',
        tags: ['finance', 'money']
    },
    {
        name: 'cylinder',
        tags: ['shape', 'elliptical', 'geometry', 'container', 'storage', 'tin', 'pot']
    },
    {
        name: 'dam',
        tags: ['electricity', 'energy', 'water']
    },
    {
        name: 'database',
        tags: ['storage', 'memory', 'container', 'tin', 'pot', 'bytes', 'servers']
    },
    {
        name: 'database-backup',
        tags: ['storage', 'memory', 'bytes', 'servers', 'backup', 'timemachine', 'rotate', 'arrow', 'left']
    },
    {
        name: 'database-zap',
        tags: ['cache busting', 'storage', 'memory', 'bytes', 'servers', 'power', 'crash']
    },
    {
        name: 'delete',
        tags: ['backspace', 'remove']
    },
    {
        name: 'dessert',
        tags: [
            'pudding',
            'christmas',
            'xmas',
            'custard',
            'iced bun',
            'icing',
            'fondant',
            'cake',
            'ice cream',
            'gelato',
            'sundae',
            'scoop',
            'dollop',
            'sugar',
            'food',
            'sweet'
        ]
    },
    {
        name: 'diameter',
        tags: ['shape', 'circle', 'geometry', 'trigonometry', 'width', 'height', 'size', 'calculate', 'measure']
    },
    {
        name: 'diamond',
        tags: ['square', 'rectangle', 'oblique', 'rhombus', 'shape', 'suit', 'playing', 'cards']
    },
    {
        name: 'diamond-minus',
        tags: [
            'keyframe',
            'subtract',
            'remove',
            'decrease',
            'reduce',
            'calculator',
            'button',
            'keyboard',
            'line',
            'divider',
            'separator',
            'horizontal rule',
            'hr',
            'html',
            'markup',
            'markdown',
            '---',
            'toolbar',
            'operator',
            'code',
            'coding',
            'minimum',
            'downgrade'
        ]
    },
    {
        name: 'diamond-percent',
        tags: ['verified', 'unverified', 'sale', 'discount', 'offer', 'marketing', 'sticker', 'price tag']
    },
    {
        name: 'diamond-plus',
        tags: [
            'keyframe',
            'add',
            'new',
            'increase',
            'increment',
            'positive',
            'calculate',
            'toolbar',
            'crosshair',
            'aim',
            'target',
            'scope',
            'sight',
            'reticule',
            'maximum',
            'upgrade',
            'extra',
            '+'
        ]
    },
    {
        name: 'dice-1',
        tags: ['dice', 'random', 'tabletop', '1', 'board', 'game']
    },
    {
        name: 'dice-2',
        tags: ['dice', 'random', 'tabletop', '2', 'board', 'game']
    },
    {
        name: 'dice-3',
        tags: ['dice', 'random', 'tabletop', '3', 'board', 'game']
    },
    {
        name: 'dice-4',
        tags: ['dice', 'random', 'tabletop', '4', 'board', 'game']
    },
    {
        name: 'dice-5',
        tags: ['dice', 'random', 'tabletop', '5', 'board', 'game']
    },
    {
        name: 'dice-6',
        tags: ['dice', 'random', 'tabletop', '6', 'board', 'game']
    },
    {
        name: 'dices',
        tags: ['dice', 'random', 'tabletop', 'board', 'game']
    },
    {
        name: 'diff',
        tags: ['patch', 'difference', 'compare', 'plus', 'minus', 'plus-minus', 'maths']
    },
    {
        name: 'disc',
        tags: [
            'album',
            'music',
            'songs',
            'format',
            'cd',
            'dvd',
            'vinyl',
            'sleeve',
            'cover',
            'platinum',
            'compilation',
            'ep',
            'recording',
            'playback',
            'spin',
            'rotate',
            'rpm',
            'dj'
        ]
    },
    {
        name: 'disc-2',
        tags: ['album', 'music', 'vinyl', 'record', 'cd', 'dvd', 'format', 'dj', 'spin', 'rotate', 'rpm']
    },
    {
        name: 'disc-3',
        tags: ['album', 'music', 'vinyl', 'record', 'cd', 'dvd', 'format', 'dj', 'spin', 'rotate', 'rpm']
    },
    {
        name: 'disc-album',
        tags: [
            'album',
            'music',
            'songs',
            'format',
            'cd',
            'dvd',
            'vinyl',
            'sleeve',
            'cover',
            'platinum',
            'compilation',
            'ep',
            'recording',
            'playback',
            'spin',
            'rotate',
            'rpm',
            'dj'
        ]
    },
    {
        name: 'divide',
        tags: ['calculate', 'maths', 'division', 'operator', 'code', '÷', '/']
    },
    {
        name: 'dna',
        tags: ['gene', 'gmo', 'helix', 'heredity', 'chromosome', 'nucleic acid']
    },
    {
        name: 'dna-off',
        tags: ['gene', 'gmo free', 'helix', 'heredity', 'chromosome', 'nucleic acid']
    },
    {
        name: 'dock',
        tags: ['desktop', 'applications', 'launch', 'home', 'menu bar', 'bottom', 'line', 'macos', 'osx']
    },
    {
        name: 'dog',
        tags: ['animal', 'pet', 'puppy', 'hound', 'canine']
    },
    {
        name: 'dollar-sign',
        tags: ['currency', 'money', 'payment']
    },
    {
        name: 'donut',
        tags: [
            'doughnut',
            'sprinkles',
            'topping',
            'fast food',
            'junk food',
            'snack',
            'treat',
            'sweet',
            'sugar',
            'dessert',
            'hollow',
            'ring'
        ]
    },
    {
        name: 'door-closed',
        tags: ['entrance', 'entry', 'exit', 'ingress', 'egress', 'gate', 'gateway', 'emergency exit']
    },
    {
        name: 'door-open',
        tags: ['entrance', 'entry', 'exit', 'ingress', 'egress', 'gate', 'gateway', 'emergency exit']
    },
    {
        name: 'dot',
        tags: [
            'interpunct',
            'interpoint',
            'middot',
            'step',
            'punctuation',
            'period',
            'full stop',
            'end',
            'finish',
            'final',
            'characters',
            'font',
            'typography',
            'type',
            'center',
            '.'
        ]
    },
    {
        name: 'download',
        tags: ['import', 'export', 'save']
    },
    {
        name: 'drafting-compass',
        tags: [
            'geometry',
            'trigonometry',
            'radius',
            'diameter',
            'circumference',
            'calculate',
            'measure',
            'arc',
            'curve',
            'draw',
            'sketch'
        ]
    },
    {
        name: 'drama',
        tags: ['drama', 'masks', 'theater', 'theatre', 'entertainment', 'show']
    },
    {
        name: 'dribbble',
        tags: ['design', 'social']
    },
    {
        name: 'drill',
        tags: ['power', 'bit', 'head', 'hole', 'diy', 'toolbox', 'build', 'construction']
    },
    {
        name: 'droplet',
        tags: ['water', 'weather', 'liquid', 'fluid', 'wet', 'moisture', 'damp', 'bead', 'globule']
    },
    {
        name: 'droplets',
        tags: ['water', 'weather', 'liquid', 'fluid', 'wet', 'moisture', 'damp', 'bead', 'globule']
    },
    {
        name: 'drum',
        tags: [
            'drummer',
            'kit',
            'sticks',
            'instrument',
            'beat',
            'bang',
            'bass',
            'backing track',
            'band',
            'play',
            'performance',
            'concert',
            'march',
            'music',
            'audio',
            'sound',
            'noise',
            'loud'
        ]
    },
    {
        name: 'drumstick',
        tags: ['food', 'chicken', 'meat']
    },
    {
        name: 'dumbbell',
        tags: ['barbell', 'weight', 'workout', 'gym']
    },
    {
        name: 'ear',
        tags: ['hearing', 'noise', 'audio', 'accessibility']
    },
    {
        name: 'ear-off',
        tags: ['hearing', 'hard of hearing', 'hearing loss', 'deafness', 'noise', 'silence', 'audio', 'accessibility']
    },
    {
        name: 'earth',
        tags: ['world', 'browser', 'language', 'translate', 'globe']
    },
    {
        name: 'earth-lock',
        tags: [
            'vpn',
            'private',
            'privacy',
            'network',
            'world',
            'browser',
            'security',
            'encryption',
            'protection',
            'connection'
        ]
    },
    {
        name: 'eclipse',
        tags: [
            'lunar',
            'solar',
            'crescent moon',
            'sun',
            'earth',
            'day',
            'night',
            'planet',
            'space',
            'mode',
            'dark',
            'light',
            'toggle',
            'switch',
            'color',
            'css',
            'styles',
            'display',
            'accessibility',
            'contrast',
            'brightness',
            'blend',
            'shade'
        ]
    },
    {
        name: 'egg',
        tags: [
            'bird',
            'chicken',
            'nest',
            'hatch',
            'shell',
            'incubate',
            'soft boiled',
            'hard',
            'breakfast',
            'brunch',
            'morning',
            'easter'
        ]
    },
    {
        name: 'egg-fried',
        tags: ['food', 'breakfast']
    },
    {
        name: 'egg-off',
        tags: ['egg free', 'vegan', 'hatched', 'bad egg']
    },
    {
        name: 'ellipsis',
        tags: [
            'et cetera',
            'etc',
            'loader',
            'loading',
            'progress',
            'pending',
            'throbber',
            'menu',
            'options',
            'operator',
            'code',
            'coding',
            'spread',
            'rest',
            'more',
            'further',
            'extra',
            'overflow',
            'dots',
            '…',
            '...'
        ]
    },
    {
        name: 'ellipsis-vertical',
        tags: ['menu', 'options', 'spread', 'more', 'further', 'extra', 'overflow', 'dots', '…', '...']
    },
    {
        name: 'equal',
        tags: ['calculate', 'maths', 'operator', 'assignment', 'code', '=']
    },
    {
        name: 'equal-not',
        tags: ['calculate', 'off', 'maths', 'operator', 'code', '≠']
    },
    {
        name: 'eraser',
        tags: ['pencil', 'drawing', 'undo', 'delete', 'clear']
    },
    {
        name: 'ethernet-port',
        tags: [
            'internet',
            'network',
            'connection',
            'cable',
            'lan',
            'port',
            'router',
            'switch',
            'hub',
            'modem',
            'web',
            'online',
            'networking',
            'communication',
            'socket',
            'plug',
            'slot',
            'controller',
            'connector',
            'interface',
            'console',
            'signal',
            'data',
            'input',
            'output'
        ]
    },
    {
        name: 'euro',
        tags: ['currency', 'money', 'payment']
    },
    {
        name: 'expand',
        tags: ['scale', 'fullscreen']
    },
    {
        name: 'external-link',
        tags: ['outbound', 'open', 'share']
    },
    {
        name: 'eye',
        tags: [
            'view',
            'watch',
            'see',
            'show',
            'expose',
            'reveal',
            'display',
            'visible',
            'visibility',
            'vision',
            'preview',
            'read'
        ]
    },
    {
        name: 'eye-off',
        tags: ['view', 'watch', 'see', 'hide', 'conceal', 'mask', 'hidden', 'visibility', 'vision']
    },
    {
        name: 'facebook',
        tags: ['logo', 'social']
    },
    {
        name: 'factory',
        tags: ['building', 'business', 'energy', 'industry', 'manufacture', 'sector']
    },
    {
        name: 'fan',
        tags: ['air', 'cooler', 'ventilation', 'ventilator', 'blower']
    },
    {
        name: 'fast-forward',
        tags: ['music']
    },
    {
        name: 'feather',
        tags: ['logo']
    },
    {
        name: 'fence',
        tags: ['picket', 'panels', 'woodwork', 'diy', 'materials', 'suburban', 'garden', 'property', 'territory']
    },
    {
        name: 'ferris-wheel',
        tags: [
            'big wheel',
            'daisy wheel',
            'observation',
            'attraction',
            'entertainment',
            'amusement park',
            'theme park',
            'funfair'
        ]
    },
    {
        name: 'figma',
        tags: ['logo', 'design', 'tool']
    },
    {
        name: 'file',
        tags: ['document']
    },
    {
        name: 'file-archive',
        tags: ['zip', 'package', 'archive']
    },
    {
        name: 'file-audio',
        tags: ['music', 'audio', 'sound', 'headphones']
    },
    {
        name: 'file-audio-2',
        tags: ['music', 'audio', 'sound', 'headphones']
    },
    {
        name: 'file-axis-3d',
        tags: ['model', '3d', 'axis', 'coordinates']
    },
    {
        name: 'file-badge',
        tags: ['award', 'achievement', 'badge', 'rosette', 'prize', 'winner']
    },
    {
        name: 'file-badge-2',
        tags: ['award', 'achievement', 'badge', 'rosette', 'prize', 'winner']
    },
    {
        name: 'file-box',
        tags: ['box', 'package', 'model']
    },
    {
        name: 'file-chart-column',
        tags: ['statistics', 'analytics', 'diagram', 'graph', 'presentation']
    },
    {
        name: 'file-chart-column-increasing',
        tags: ['statistics', 'analytics', 'diagram', 'graph', 'presentation', 'trending up']
    },
    {
        name: 'file-chart-line',
        tags: ['statistics', 'analytics', 'diagram', 'graph', 'presentation']
    },
    {
        name: 'file-chart-pie',
        tags: ['statistics', 'analytics', 'diagram', 'graph', 'presentation']
    },
    {
        name: 'file-check',
        tags: ['done', 'document', 'todo', 'tick', 'complete', 'task']
    },
    {
        name: 'file-check-2',
        tags: ['done', 'document', 'todo', 'tick', 'complete', 'task']
    },
    {
        name: 'file-clock',
        tags: ['history', 'log', 'clock']
    },
    {
        name: 'file-code',
        tags: ['script', 'document', 'gist', 'html', 'xml', 'property list', 'plist']
    },
    {
        name: 'file-code-2',
        tags: ['script', 'document', 'html', 'xml', 'property list', 'plist']
    },
    {
        name: 'file-cog',
        tags: ['executable', 'settings', 'cog', 'edit', 'gear']
    },
    {
        name: 'file-diff',
        tags: ['diff', 'patch']
    },
    {
        name: 'file-digit',
        tags: ['number', 'document']
    },
    {
        name: 'file-down',
        tags: ['download', 'import', 'export']
    },
    {
        name: 'file-heart',
        tags: ['heart', 'favourite', 'bookmark', 'quick link']
    },
    {
        name: 'file-image',
        tags: ['image', 'graphics', 'photo', 'picture']
    },
    {
        name: 'file-input',
        tags: ['document']
    },
    {
        name: 'file-json',
        tags: ['code', 'json', 'curly braces', 'curly brackets']
    },
    {
        name: 'file-json-2',
        tags: ['code', 'json', 'curly braces', 'curly brackets']
    },
    {
        name: 'file-key',
        tags: ['key', 'private', 'public', 'security']
    },
    {
        name: 'file-key-2',
        tags: ['key', 'private', 'public', 'security']
    },
    {
        name: 'file-lock',
        tags: ['lock', 'password', 'security']
    },
    {
        name: 'file-lock-2',
        tags: ['lock', 'password', 'security']
    },
    {
        name: 'file-minus',
        tags: ['delete', 'remove', 'erase', 'document']
    },
    {
        name: 'file-minus-2',
        tags: ['document']
    },
    {
        name: 'file-music',
        tags: [
            'audio',
            'sound',
            'noise',
            'track',
            'digital',
            'recording',
            'playback',
            'piano',
            'keyboard',
            'keys',
            'notes',
            'chord',
            'midi',
            'octave'
        ]
    },
    {
        name: 'file-output',
        tags: ['document']
    },
    {
        name: 'file-pen',
        tags: ['signature']
    },
    {
        name: 'file-pen-line',
        tags: ['edit']
    },
    {
        name: 'file-plus',
        tags: ['add', 'create', 'new', 'document']
    },
    {
        name: 'file-plus-2',
        tags: ['add', 'create', 'new', 'document']
    },
    {
        name: 'file-question',
        tags: ['readme', 'help', 'question']
    },
    {
        name: 'file-scan',
        tags: ['scan', 'code', 'qr-code']
    },
    {
        name: 'file-search',
        tags: ['lost', 'document', 'find', 'browser']
    },
    {
        name: 'file-search-2',
        tags: ['lost', 'document', 'find', 'browser']
    },
    {
        name: 'file-sliders',
        tags: [
            'cogged',
            'gear',
            'mechanical',
            'machinery',
            'configuration',
            'controls',
            'preferences',
            'settings',
            'system',
            'admin',
            'edit',
            'executable'
        ]
    },
    {
        name: 'file-spreadsheet',
        tags: ['spreadsheet', 'sheet', 'table']
    },
    {
        name: 'file-stack',
        tags: ['versions', 'multiple', 'copy', 'documents', 'revisions', 'version control', 'history']
    },
    {
        name: 'file-symlink',
        tags: ['symlink', 'symbolic', 'link']
    },
    {
        name: 'file-terminal',
        tags: ['terminal', 'bash', 'script', 'executable']
    },
    {
        name: 'file-text',
        tags: ['data', 'txt', 'pdf', 'document']
    },
    {
        name: 'file-type',
        tags: ['font', 'text', 'typography', 'type']
    },
    {
        name: 'file-type-2',
        tags: ['font', 'text', 'typography', 'type']
    },
    {
        name: 'file-up',
        tags: ['upload', 'import', 'export']
    },
    {
        name: 'file-video',
        tags: ['movie', 'video', 'film']
    },
    {
        name: 'file-video-2',
        tags: ['movie', 'video', 'film']
    },
    {
        name: 'file-volume',
        tags: ['audio', 'music', 'volume']
    },
    {
        name: 'file-volume-2',
        tags: ['audio', 'music', 'volume']
    },
    {
        name: 'file-warning',
        tags: ['hidden', 'warning', 'alert', 'danger', 'protected', 'exclamation mark']
    },
    {
        name: 'file-x',
        tags: ['lost', 'delete', 'remove', 'document']
    },
    {
        name: 'file-x-2',
        tags: ['lost', 'delete', 'remove', 'document']
    },
    {
        name: 'files',
        tags: ['multiple', 'copy', 'documents']
    },
    {
        name: 'film',
        tags: ['movie', 'video', 'reel', 'camera', 'cinema', 'entertainment']
    },
    {
        name: 'filter',
        tags: ['funnel', 'hopper']
    },
    {
        name: 'filter-x',
        tags: ['funnel', 'hopper']
    },
    {
        name: 'fingerprint',
        tags: ['2fa', 'authentication', 'biometric', 'identity', 'security']
    },
    {
        name: 'fire-extinguisher',
        tags: [
            'flames',
            'smoke',
            'foam',
            'water',
            'spray',
            'hose',
            'firefighter',
            'fireman',
            'department',
            'brigade',
            'station',
            'emergency',
            'suppress',
            'compressed',
            'tank',
            'cylinder',
            'safety',
            'equipment',
            'amenities'
        ]
    },
    {
        name: 'fish',
        tags: ['dish', 'restaurant', 'course', 'meal', 'seafood', 'pet', 'sea', 'marine']
    },
    {
        name: 'fish-off',
        tags: [
            'food',
            'dish',
            'restaurant',
            'course',
            'meal',
            'seafood',
            'animal',
            'pet',
            'sea',
            'marine',
            'allergy',
            'intolerance',
            'diet'
        ]
    },
    {
        name: 'fish-symbol',
        tags: ['dish', 'restaurant', 'course', 'meal', 'seafood', 'pet', 'sea', 'marine']
    },
    {
        name: 'flag',
        tags: ['report']
    },
    {
        name: 'flag-off',
        tags: ['unflag']
    },
    {
        name: 'flag-triangle-left',
        tags: ['report', 'timeline']
    },
    {
        name: 'flag-triangle-right',
        tags: ['report', 'timeline']
    },
    {
        name: 'flame',
        tags: [
            'fire',
            'lit',
            'burning',
            'spark',
            'embers',
            'smoke',
            'firefighter',
            'fireman',
            'department',
            'brigade',
            'station',
            'emergency'
        ]
    },
    {
        name: 'flame-kindling',
        tags: ['campfire', 'camping', 'wilderness', 'outdoors', 'lit', 'warmth', 'wood', 'twigs', 'sticks']
    },
    {
        name: 'flashlight',
        tags: ['torch']
    },
    {
        name: 'flashlight-off',
        tags: ['torch']
    },
    {
        name: 'flask-conical',
        tags: ['beaker', 'erlenmeyer', 'lab', 'chemistry', 'experiment', 'test']
    },
    {
        name: 'flask-conical-off',
        tags: ['beaker', 'erlenmeyer', 'non toxic', 'lab', 'chemistry', 'experiment', 'test']
    },
    {
        name: 'flask-round',
        tags: ['beaker', 'lab', 'chemistry', 'experiment', 'test']
    },
    {
        name: 'flip-horizontal',
        tags: ['reflect', 'mirror', 'alignment', 'dashed']
    },
    {
        name: 'flip-horizontal-2',
        tags: ['reflect', 'mirror', 'alignment', 'dashed']
    },
    {
        name: 'flip-vertical',
        tags: ['reflect', 'mirror', 'alignment', 'dashed']
    },
    {
        name: 'flip-vertical-2',
        tags: ['reflect', 'mirror', 'alignment', 'dashed']
    },
    {
        name: 'flower',
        tags: ['sustainability', 'nature', 'plant', 'spring']
    },
    {
        name: 'flower-2',
        tags: ['sustainability', 'nature', 'plant']
    },
    {
        name: 'focus',
        tags: ['camera', 'lens', 'photo', 'dashed']
    },
    {
        name: 'fold-horizontal',
        tags: ['arrow', 'collapse', 'fold', 'vertical', 'dashed']
    },
    {
        name: 'fold-vertical',
        tags: ['arrow', 'collapse', 'fold', 'vertical', 'dashed']
    },
    {
        name: 'folder',
        tags: ['directory']
    },
    {
        name: 'folder-archive',
        tags: ['archive', 'zip', 'package']
    },
    {
        name: 'folder-check',
        tags: ['done', 'directory', 'todo', 'tick', 'complete', 'task']
    },
    {
        name: 'folder-clock',
        tags: ['history', 'directory', 'clock']
    },
    {
        name: 'folder-closed',
        tags: ['directory', 'closed']
    },
    {
        name: 'folder-code',
        tags: ['directory', 'coding', 'develop', 'software']
    },
    {
        name: 'folder-cog',
        tags: ['directory', 'settings', 'control', 'preferences', 'cog', 'edit', 'gear']
    },
    {
        name: 'folder-dot',
        tags: [
            'directory',
            'root',
            'project',
            'pinned',
            'active',
            'current',
            'cogged',
            'gear',
            'mechanical',
            'machinery',
            'configuration',
            'controls',
            'preferences',
            'settings',
            'system',
            'admin',
            'edit'
        ]
    },
    {
        name: 'folder-down',
        tags: ['directory', 'download', 'import', 'export']
    },
    {
        name: 'folder-git',
        tags: ['directory', 'root', 'project', 'git', 'repo']
    },
    {
        name: 'folder-git-2',
        tags: ['directory', 'root', 'project', 'git', 'repo']
    },
    {
        name: 'folder-heart',
        tags: ['directory', 'heart', 'favourite', 'bookmark', 'quick link']
    },
    {
        name: 'folder-input',
        tags: ['directory', 'import', 'export']
    },
    {
        name: 'folder-kanban',
        tags: [
            'projects',
            'manage',
            'overview',
            'board',
            'tickets',
            'issues',
            'roadmap',
            'plan',
            'intentions',
            'productivity',
            'work',
            'agile',
            'code',
            'coding',
            'directory',
            'project',
            'root'
        ]
    },
    {
        name: 'folder-key',
        tags: ['directory', 'key', 'private', 'security', 'protected']
    },
    {
        name: 'folder-lock',
        tags: ['directory', 'lock', 'private', 'security', 'protected']
    },
    {
        name: 'folder-minus',
        tags: ['directory', 'remove', 'delete']
    },
    {
        name: 'folder-open',
        tags: ['directory']
    },
    {
        name: 'folder-open-dot',
        tags: ['directory', 'root', 'project', 'active', 'current', 'pinned']
    },
    {
        name: 'folder-output',
        tags: ['directory', 'import', 'export']
    },
    {
        name: 'folder-pen',
        tags: ['directory', 'rename']
    },
    {
        name: 'folder-plus',
        tags: ['directory', 'add', 'create', 'new']
    },
    {
        name: 'folder-root',
        tags: ['directory', 'root', 'project', 'git', 'repo']
    },
    {
        name: 'folder-search',
        tags: ['directory', 'search', 'find', 'lost', 'browser']
    },
    {
        name: 'folder-search-2',
        tags: ['directory', 'search', 'find', 'lost', 'browser']
    },
    {
        name: 'folder-symlink',
        tags: ['directory', 'symlink', 'symbolic', 'link']
    },
    {
        name: 'folder-sync',
        tags: ['directory', 'synchronize', 'synchronise', 'refresh', 'reconnect', 'transfer', 'backup']
    },
    {
        name: 'folder-tree',
        tags: ['directory', 'tree', 'browser']
    },
    {
        name: 'folder-up',
        tags: ['directory', 'upload', 'import', 'export']
    },
    {
        name: 'folder-x',
        tags: ['directory', 'remove', 'delete']
    },
    {
        name: 'folders',
        tags: ['multiple', 'copy', 'directories']
    },
    {
        name: 'footprints',
        tags: ['steps', 'walking', 'foot', 'feet', 'trail', 'shoe']
    },
    {
        name: 'forklift',
        tags: ['vehicle', 'transport', 'logistics']
    },
    {
        name: 'forward',
        tags: ['send', 'share', 'email']
    },
    {
        name: 'frame',
        tags: ['logo', 'design', 'tool']
    },
    {
        name: 'framer',
        tags: ['logo', 'design', 'tool']
    },
    {
        name: 'frown',
        tags: ['emoji', 'face', 'bad', 'sad', 'emotion']
    },
    {
        name: 'fuel',
        tags: ['filling-station', 'gas', 'petrol', 'tank']
    },
    {
        name: 'fullscreen',
        tags: ['expand', 'zoom', 'preview', 'focus', 'camera', 'lens', 'image']
    },
    {
        name: 'gallery-horizontal',
        tags: ['carousel', 'pictures', 'images', 'scroll', 'swipe', 'album', 'portfolio']
    },
    {
        name: 'gallery-horizontal-end',
        tags: [
            'carousel',
            'pictures',
            'images',
            'scroll',
            'swipe',
            'album',
            'portfolio',
            'history',
            'versions',
            'backup',
            'time machine'
        ]
    },
    {
        name: 'gallery-thumbnails',
        tags: ['carousel', 'pictures', 'images', 'album', 'portfolio', 'preview']
    },
    {
        name: 'gallery-vertical',
        tags: ['carousel', 'pictures', 'images', 'scroll', 'swipe', 'album', 'portfolio']
    },
    {
        name: 'gallery-vertical-end',
        tags: [
            'carousel',
            'pictures',
            'images',
            'scroll',
            'swipe',
            'album',
            'portfolio',
            'history',
            'versions',
            'backup',
            'time machine'
        ]
    },
    {
        name: 'gamepad',
        tags: ['console']
    },
    {
        name: 'gamepad-2',
        tags: ['console']
    },
    {
        name: 'gauge',
        tags: ['dashboard', 'dial', 'meter', 'speed', 'pressure', 'measure', 'level']
    },
    {
        name: 'gavel',
        tags: ['hammer', 'mallet']
    },
    {
        name: 'gem',
        tags: [
            'diamond',
            'crystal',
            'ruby',
            'jewellery',
            'price',
            'special',
            'present',
            'gift',
            'ring',
            'wedding',
            'proposal',
            'marriage',
            'rubygems'
        ]
    },
    {
        name: 'ghost',
        tags: ['pac-man', 'spooky']
    },
    {
        name: 'gift',
        tags: ['present', 'box', 'birthday', 'party']
    },
    {
        name: 'git-branch',
        tags: ['code', 'version control']
    },
    {
        name: 'git-branch-plus',
        tags: ['add', 'create', '+']
    },
    {
        name: 'git-commit-horizontal',
        tags: ['code', 'version control', 'waypoint', 'stop', 'station']
    },
    {
        name: 'git-commit-vertical',
        tags: ['code', 'version control', 'waypoint', 'stop', 'station']
    },
    {
        name: 'git-compare',
        tags: ['code', 'version control', 'diff']
    },
    {
        name: 'git-compare-arrows',
        tags: ['code', 'version control', 'diff']
    },
    {
        name: 'git-fork',
        tags: ['code', 'version control']
    },
    {
        name: 'git-graph',
        tags: ['code', 'version control', 'commit graph', 'commits', 'gitlens']
    },
    {
        name: 'git-merge',
        tags: ['code', 'version control']
    },
    {
        name: 'git-pull-request',
        tags: ['code', 'version control', 'open']
    },
    {
        name: 'git-pull-request-arrow',
        tags: ['code', 'version control', 'open']
    },
    {
        name: 'git-pull-request-closed',
        tags: ['code', 'version control', 'rejected', 'closed', 'cancelled', 'x']
    },
    {
        name: 'git-pull-request-create',
        tags: ['code', 'version control', 'open', 'plus', 'add', '+']
    },
    {
        name: 'git-pull-request-create-arrow',
        tags: ['code', 'version control', 'open', 'plus', 'add', '+']
    },
    {
        name: 'git-pull-request-draft',
        tags: ['code', 'version control', 'open', 'draft', 'dashed']
    },
    {
        name: 'github',
        tags: ['logo', 'version control']
    },
    {
        name: 'gitlab',
        tags: ['logo', 'version control']
    },
    {
        name: 'glass-water',
        tags: ['beverage', 'drink', 'glass', 'water']
    },
    {
        name: 'glasses',
        tags: ['glasses', 'spectacles']
    },
    {
        name: 'globe',
        tags: ['world', 'browser', 'language', 'translate']
    },
    {
        name: 'globe-lock',
        tags: [
            'vpn',
            'private',
            'privacy',
            'network',
            'world',
            'browser',
            'security',
            'encryption',
            'protection',
            'connection'
        ]
    },
    {
        name: 'goal',
        tags: ['flag', 'bullseye']
    },
    {
        name: 'grab',
        tags: ['hand']
    },
    {
        name: 'graduation-cap',
        tags: [
            'school',
            'university',
            'learn',
            'study',
            'mortarboard',
            'education',
            'ceremony',
            'academic',
            'hat',
            'diploma',
            "bachlor's",
            "master's",
            'doctorate'
        ]
    },
    {
        name: 'grape',
        tags: ['fruit', 'wine', 'food']
    },
    {
        name: 'grid-2x2',
        tags: [
            'table',
            'rows',
            'columns',
            'blocks',
            'plot',
            'land',
            'geometry',
            'measure',
            'size',
            'width',
            'height',
            'distance',
            'surface area',
            'square meter',
            'acre'
        ]
    },
    {
        name: 'grid-2x2-check',
        tags: [
            'table',
            'rows',
            'columns',
            'blocks',
            'plot',
            'land',
            'geometry',
            'measure',
            'data',
            'size',
            'width',
            'height',
            'distance',
            'surface area',
            'square meter',
            'acre'
        ]
    },
    {
        name: 'grid-2x2-plus',
        tags: [
            'table',
            'rows',
            'columns',
            'blocks',
            'plot',
            'land',
            'geometry',
            'measure',
            'data',
            'size',
            'width',
            'height',
            'distance',
            'surface area',
            'square meter',
            'acre'
        ]
    },
    {
        name: 'grid-2x2-x',
        tags: [
            'table',
            'rows',
            'columns',
            'data',
            'blocks',
            'plot',
            'land',
            'geometry',
            'measure',
            'size',
            'width',
            'height',
            'distance',
            'surface area',
            'square meter',
            'acre'
        ]
    },
    {
        name: 'grid-3x3',
        tags: ['table', 'rows', 'columns']
    },
    {
        name: 'grip',
        tags: ['grab', 'dots', 'handle', 'move', 'drag']
    },
    {
        name: 'grip-horizontal',
        tags: ['grab', 'dots', 'handle', 'move', 'drag']
    },
    {
        name: 'grip-vertical',
        tags: ['grab', 'dots', 'handle', 'move', 'drag']
    },
    {
        name: 'group',
        tags: ['cubes', 'packages', 'parts', 'units', 'collection', 'cluster', 'gather', 'dashed']
    },
    {
        name: 'guitar',
        tags: [
            'acoustic',
            'instrument',
            'strings',
            'riff',
            'rock',
            'band',
            'country',
            'concert',
            'performance',
            'play',
            'lead',
            'loud',
            'music',
            'audio',
            'sound',
            'noise'
        ]
    },
    {
        name: 'ham',
        tags: ['food', 'pork', 'pig', 'meat', 'bone', 'hock', 'knuckle', 'gammon', 'cured']
    },
    {
        name: 'hammer',
        tags: ['mallet', 'nails', 'diy', 'toolbox', 'build', 'construction']
    },
    {
        name: 'hand',
        tags: ['wave', 'move', 'mouse', 'grab']
    },
    {
        name: 'hand-coins',
        tags: [
            'savings',
            'banking',
            'money',
            'finance',
            'offers',
            'mortgage',
            'payment',
            'received',
            'wage',
            'payroll',
            'allowance',
            'pocket money',
            'handout',
            'pennies'
        ]
    },
    {
        name: 'hand-heart',
        tags: ['love', 'like', 'emotion']
    },
    {
        name: 'hand-helping',
        tags: ['agreement', 'help', 'proposal', 'charity', 'begging', 'terms']
    },
    {
        name: 'hand-metal',
        tags: ['rock']
    },
    {
        name: 'hand-platter',
        tags: [
            'waiter',
            'waitress',
            'restaurant',
            'table service',
            'served',
            'dinner',
            'dining',
            'meal',
            'course',
            'luxury'
        ]
    },
    {
        name: 'handshake',
        tags: [
            'agreement',
            'partnership',
            'deal',
            'business',
            'assistance',
            'cooperation',
            'friendship',
            'union',
            'terms'
        ]
    },
    {
        name: 'hard-drive',
        tags: ['computer', 'server', 'memory', 'data', 'ssd', 'disk', 'hard disk']
    },
    {
        name: 'hard-drive-download',
        tags: ['computer', 'server', 'memory', 'data', 'ssd', 'disk', 'hard disk', 'save']
    },
    {
        name: 'hard-drive-upload',
        tags: ['computer', 'server', 'memory', 'data', 'ssd', 'disk', 'hard disk', 'save']
    },
    {
        name: 'hard-hat',
        tags: ['helmet', 'construction', 'safety', 'savety']
    },
    {
        name: 'hash',
        tags: ['hashtag', 'number', 'pound']
    },
    {
        name: 'haze',
        tags: ['mist', 'fog']
    },
    {
        name: 'hdmi-port',
        tags: [
            'socket',
            'plug',
            'slot',
            'controller',
            'connector',
            'interface',
            'console',
            'signal',
            'audio',
            'video',
            'visual',
            'av',
            'data',
            'input',
            'output'
        ]
    },
    {
        name: 'heading',
        tags: ['h1', 'html', 'markup', 'markdown']
    },
    {
        name: 'heading-1',
        tags: ['h1', 'html', 'markup', 'markdown']
    },
    {
        name: 'heading-2',
        tags: ['h2', 'html', 'markup', 'markdown']
    },
    {
        name: 'heading-3',
        tags: ['h3', 'html', 'markup', 'markdown']
    },
    {
        name: 'heading-4',
        tags: ['h4', 'html', 'markup', 'markdown']
    },
    {
        name: 'heading-5',
        tags: ['h5', 'html', 'markup', 'markdown']
    },
    {
        name: 'heading-6',
        tags: ['h6', 'html', 'markup', 'markdown']
    },
    {
        name: 'headphone-off',
        tags: ['music', 'audio', 'sound', 'mute', 'off']
    },
    {
        name: 'headphones',
        tags: ['music', 'audio', 'sound']
    },
    {
        name: 'headset',
        tags: [
            'music',
            'audio',
            'sound',
            'gaming',
            'headphones',
            'headset',
            'call',
            'center',
            'phone',
            'telephone',
            'voip',
            'video'
        ]
    },
    {
        name: 'heart',
        tags: ['like', 'love', 'emotion', 'suit', 'playing', 'cards']
    },
    {
        name: 'heart-crack',
        tags: ['heartbreak', 'sadness', 'emotion']
    },
    {
        name: 'heart-handshake',
        tags: ['agreement', 'charity', 'help', 'deal', 'terms', 'emotion', 'together', 'handshake']
    },
    {
        name: 'heart-off',
        tags: ['unlike', 'dislike', 'hate', 'emotion']
    },
    {
        name: 'heart-pulse',
        tags: ['heartbeat', 'pulse', 'health', 'medical', 'blood pressure', 'cardiac', 'systole', 'diastole']
    },
    {
        name: 'heater',
        tags: ['heating', 'warmth', 'comfort', 'fire', 'stove', 'electric', 'electronics', 'amenities']
    },
    {
        name: 'hexagon',
        tags: ['shape', 'node.js', 'logo']
    },
    {
        name: 'highlighter',
        tags: ['mark', 'text']
    },
    {
        name: 'history',
        tags: ['time', 'redo', 'undo', 'rewind', 'timeline', 'version', 'time machine', 'backup', 'rotate', 'ccw']
    },
    {
        name: 'hop',
        tags: ['beer', 'brewery', 'drink']
    },
    {
        name: 'hop-off',
        tags: ['beer', 'brewery', 'drink', 'hop free', 'allergy', 'intolerance', 'diet']
    },
    {
        name: 'hospital',
        tags: [
            'infirmary',
            'sanatorium',
            'healthcare',
            'doctor',
            'hospice',
            'clinic',
            'emergency room',
            'ward',
            'building',
            'medical',
            'vet'
        ]
    },
    {
        name: 'hotel',
        tags: ['building', 'hostel', 'motel', 'inn']
    },
    {
        name: 'hourglass',
        tags: ['timer', 'time', 'sandglass']
    },
    {
        name: 'house',
        tags: ['home', 'living', 'building', 'residence', 'architecture']
    },
    {
        name: 'house-plug',
        tags: ['home', 'living', 'building', 'residence', 'architecture', 'autarky', 'energy']
    },
    {
        name: 'house-plus',
        tags: ['home', 'living', 'medical', 'new', 'addition', 'building', 'residence', 'architecture']
    },
    {
        name: 'ice-cream-bowl',
        tags: ['gelato', 'food', 'dessert', 'dish', 'restaurant', 'course', 'meal']
    },
    {
        name: 'ice-cream-cone',
        tags: ['gelato', 'food']
    },
    {
        name: 'id-card',
        tags: ['card', 'badge', 'identity', 'authentication', 'secure']
    },
    {
        name: 'image',
        tags: ['picture', 'photo']
    },
    {
        name: 'image-down',
        tags: ['picture', 'photo', 'download', 'save', 'export']
    },
    {
        name: 'image-minus',
        tags: ['remove', 'delete']
    },
    {
        name: 'image-off',
        tags: ['picture', 'photo']
    },
    {
        name: 'image-play',
        tags: ['picture', 'gif', 'photo']
    },
    {
        name: 'image-plus',
        tags: ['add', 'create', 'picture']
    },
    {
        name: 'image-up',
        tags: ['picture', 'photo', 'upload', 'import']
    },
    {
        name: 'images',
        tags: ['picture', 'photo', 'multiple', 'copy', 'gallery', 'album', 'collection', 'slideshow', 'showcase']
    },
    {
        name: 'import',
        tags: ['save']
    },
    {
        name: 'inbox',
        tags: ['email']
    },
    {
        name: 'indent-decrease',
        tags: ['text', 'tab']
    },
    {
        name: 'indent-increase',
        tags: ['text', 'tab']
    },
    {
        name: 'indian-rupee',
        tags: ['currency', 'money', 'payment']
    },
    {
        name: 'infinity',
        tags: ['unlimited', 'forever', 'loop', 'maths']
    },
    {
        name: 'info',
        tags: ['help']
    },
    {
        name: 'inspection-panel',
        tags: ['access', 'cover', 'tile', 'metal', 'materials', 'screws']
    },
    {
        name: 'instagram',
        tags: ['logo', 'camera', 'social']
    },
    {
        name: 'italic',
        tags: ['oblique', 'text', 'format']
    },
    {
        name: 'iteration-ccw',
        tags: ['arrow', 'right']
    },
    {
        name: 'iteration-cw',
        tags: ['arrow', 'left']
    },
    {
        name: 'japanese-yen',
        tags: ['currency', 'money', 'payment']
    },
    {
        name: 'joystick',
        tags: ['game', 'console', 'control stick']
    },
    {
        name: 'kanban',
        tags: [
            'projects',
            'manage',
            'overview',
            'board',
            'tickets',
            'issues',
            'roadmap',
            'plan',
            'intentions',
            'productivity',
            'work',
            'agile',
            'code',
            'coding'
        ]
    },
    {
        name: 'key',
        tags: ['password', 'login', 'authentication', 'secure', 'unlock', 'keychain', 'key ring', 'fob']
    },
    {
        name: 'key-round',
        tags: ['password', 'login', 'authentication', 'secure', 'unlock']
    },
    {
        name: 'key-square',
        tags: ['password', 'login', 'authentication', 'secure', 'unlock', 'car key']
    },
    {
        name: 'keyboard',
        tags: ['layout', 'spell', 'settings', 'mouse']
    },
    {
        name: 'keyboard-music',
        tags: [
            'music',
            'audio',
            'sound',
            'noise',
            'notes',
            'keys',
            'chord',
            'octave',
            'midi',
            'controller',
            'instrument',
            'electric',
            'signal',
            'digital',
            'studio',
            'production',
            'producer',
            'pianist',
            'piano',
            'play',
            'performance',
            'concert'
        ]
    },
    {
        name: 'keyboard-off',
        tags: ['unkeys', 'layout', 'spell', 'settings', 'mouse']
    },
    {
        name: 'lamp',
        tags: ['lighting', 'household', 'home', 'furniture']
    },
    {
        name: 'lamp-ceiling',
        tags: ['lighting', 'household', 'home', 'furniture']
    },
    {
        name: 'lamp-desk',
        tags: ['lighting', 'household', 'office', 'desk', 'home', 'furniture']
    },
    {
        name: 'lamp-floor',
        tags: ['lighting', 'household', 'floor', 'home', 'furniture']
    },
    {
        name: 'lamp-wall-down',
        tags: ['lighting', 'household', 'wall', 'home', 'furniture']
    },
    {
        name: 'lamp-wall-up',
        tags: ['lighting', 'household', 'wall', 'home', 'furniture']
    },
    {
        name: 'land-plot',
        tags: [
            'area',
            'surface',
            'square metres',
            'allotment',
            'parcel',
            'property',
            'plane',
            'acres',
            'measure',
            'distance',
            'isometric',
            'flag',
            'golf course',
            'hole'
        ]
    },
    {
        name: 'landmark',
        tags: ['bank', 'building', 'capitol', 'finance', 'money']
    },
    {
        name: 'languages',
        tags: ['translate']
    },
    {
        name: 'laptop',
        tags: ['computer', 'screen', 'remote']
    },
    {
        name: 'laptop-minimal',
        tags: ['computer', 'screen', 'remote']
    },
    {
        name: 'lasso',
        tags: ['select', 'cursor']
    },
    {
        name: 'lasso-select',
        tags: ['select', 'cursor']
    },
    {
        name: 'laugh',
        tags: ['emoji', 'face', 'happy', 'good', 'emotion']
    },
    {
        name: 'layers',
        tags: ['stack', 'pile', 'pages', 'sheets', 'paperwork', 'copies', 'copy']
    },
    {
        name: 'layers-2',
        tags: ['stack', 'pile', 'pages', 'sheets', 'paperwork', 'copies', 'copy', 'duplicate', 'double', 'shortcuts']
    },
    {
        name: 'layers-3',
        tags: ['stack', 'pile', 'pages', 'sheets', 'paperwork', 'copies', 'copy', 'duplicate', 'triple']
    },
    {
        name: 'layout-dashboard',
        tags: ['masonry', 'brick']
    },
    {
        name: 'layout-grid',
        tags: ['app', 'home', 'start']
    },
    {
        name: 'layout-list',
        tags: ['todo', 'tasks', 'items', 'pending', 'image', 'photo']
    },
    {
        name: 'layout-panel-left',
        tags: ['app', 'home', 'start', 'grid']
    },
    {
        name: 'layout-panel-top',
        tags: ['window', 'webpage', 'block', 'section', 'grid', 'template', 'structure']
    },
    {
        name: 'layout-template',
        tags: ['window', 'webpage', 'block', 'section']
    },
    {
        name: 'leaf',
        tags: ['sustainability', 'nature', 'energy', 'plant', 'autumn']
    },
    {
        name: 'leafy-green',
        tags: ['salad', 'lettuce', 'vegetable', 'chard', 'cabbage', 'bok choy']
    },
    {
        name: 'lectern',
        tags: ['pulpit', 'podium', 'stand']
    },
    {
        name: 'letter-text',
        tags: ['drop cap', 'text', 'format', 'typography', 'letter', 'font size']
    },
    {
        name: 'library',
        tags: [
            'books',
            'reading',
            'written',
            'authors',
            'stories',
            'fiction',
            'novels',
            'information',
            'knowledge',
            'education',
            'high school',
            'university',
            'college',
            'academy',
            'learning',
            'study',
            'research',
            'collection',
            'vinyl',
            'records',
            'albums',
            'music',
            'package'
        ]
    },
    {
        name: 'library-big',
        tags: [
            'books',
            'reading',
            'written',
            'authors',
            'stories',
            'fiction',
            'novels',
            'information',
            'knowledge',
            'education',
            'high school',
            'university',
            'college',
            'academy',
            'learning',
            'study',
            'research',
            'collection',
            'vinyl',
            'records',
            'albums',
            'music',
            'package'
        ]
    },
    {
        name: 'life-buoy',
        tags: [
            'preserver',
            'life belt',
            'lifesaver',
            'help',
            'rescue',
            'ship',
            'ring',
            'raft',
            'inflatable',
            'wheel',
            'donut'
        ]
    },
    {
        name: 'ligature',
        tags: ['text', 'font', 'typography', 'alternates', 'alternatives']
    },
    {
        name: 'lightbulb',
        tags: ['idea', 'bright', 'lights']
    },
    {
        name: 'lightbulb-off',
        tags: ['lights']
    },
    {
        name: 'link',
        tags: ['chain', 'url']
    },
    {
        name: 'link-2',
        tags: ['chain', 'url']
    },
    {
        name: 'link-2-off',
        tags: ['unchain', 'chain']
    },
    {
        name: 'linkedin',
        tags: ['logo', 'social media', 'social']
    },
    {
        name: 'list',
        tags: ['options']
    },
    {
        name: 'list-check',
        tags: ['done', 'check', 'tick', 'complete', 'list', 'to-do', 'bom']
    },
    {
        name: 'list-checks',
        tags: ['todo', 'done', 'check', 'tick', 'complete', 'tasks', 'items', 'pending']
    },
    {
        name: 'list-collapse',
        tags: [
            'items',
            'collapse',
            'expand',
            'details',
            'disclosure',
            'show',
            'hide',
            'toggle',
            'accordion',
            'more',
            'less',
            'fold',
            'unfold'
        ]
    },
    {
        name: 'list-end',
        tags: ['queue', 'bottom', 'end', 'playlist']
    },
    {
        name: 'list-filter',
        tags: ['options']
    },
    {
        name: 'list-minus',
        tags: ['playlist', 'remove', 'song', 'subtract', 'delete', 'unqueue']
    },
    {
        name: 'list-music',
        tags: ['playlist', 'queue', 'music', 'audio', 'playback']
    },
    {
        name: 'list-ordered',
        tags: ['number', 'order', 'queue']
    },
    {
        name: 'list-plus',
        tags: ['playlist', 'add', 'song', 'track', 'new']
    },
    {
        name: 'list-restart',
        tags: ['reset', 'refresh', 'reload', 'playlist', 'replay']
    },
    {
        name: 'list-start',
        tags: ['queue', 'top', 'start', 'next', 'playlist']
    },
    {
        name: 'list-todo',
        tags: ['todo', 'done', 'check', 'tick', 'complete', 'tasks', 'items', 'pending']
    },
    {
        name: 'list-tree',
        tags: ['tree', 'browser']
    },
    {
        name: 'list-video',
        tags: ['playlist', 'video', 'playback']
    },
    {
        name: 'list-x',
        tags: ['playlist', 'subtract', 'remove', 'delete', 'unqueue']
    },
    {
        name: 'loader',
        tags: ['loading', 'wait', 'busy', 'progress', 'spinner', 'spinning', 'throbber']
    },
    {
        name: 'loader-circle',
        tags: ['loading', 'wait', 'busy', 'progress', 'spinner', 'spinning', 'throbber', 'circle']
    },
    {
        name: 'loader-pinwheel',
        tags: [
            'loading',
            'wait',
            'busy',
            'progress',
            'throbber',
            'spinner',
            'spinning',
            'beach ball',
            'frozen',
            'freeze'
        ]
    },
    {
        name: 'locate',
        tags: ['map', 'gps', 'location', 'cross']
    },
    {
        name: 'locate-fixed',
        tags: ['map', 'gps', 'location', 'cross']
    },
    {
        name: 'locate-off',
        tags: ['map', 'gps', 'location', 'cross']
    },
    {
        name: 'lock',
        tags: ['security', 'password', 'secure', 'admin']
    },
    {
        name: 'lock-keyhole',
        tags: ['security', 'password', 'secure', 'admin']
    },
    {
        name: 'lock-keyhole-open',
        tags: ['security']
    },
    {
        name: 'lock-open',
        tags: ['security']
    },
    {
        name: 'log-in',
        tags: ['sign in', 'arrow', 'enter', 'auth']
    },
    {
        name: 'log-out',
        tags: ['sign out', 'arrow', 'exit', 'auth']
    },
    {
        name: 'logs',
        tags: ['options', 'list', 'menu', 'order', 'queue', 'tasks', 'logs']
    },
    {
        name: 'lollipop',
        tags: ['lolly', 'candy', 'sugar', 'food', 'sweet', 'dessert', 'spiral']
    },
    {
        name: 'luggage',
        tags: ['baggage', 'luggage', 'travel', 'suitcase']
    },
    {
        name: 'magnet',
        tags: ['horseshoe', 'lock', 'science', 'snap']
    },
    {
        name: 'mail',
        tags: ['email', 'message', 'letter', 'unread']
    },
    {
        name: 'mail-check',
        tags: [
            'email',
            'message',
            'letter',
            'subscribe',
            'delivered',
            'success',
            'read',
            'done',
            'todo',
            'tick',
            'complete',
            'task'
        ]
    },
    {
        name: 'mail-minus',
        tags: ['email', 'message', 'letter', 'remove', 'delete']
    },
    {
        name: 'mail-open',
        tags: ['email', 'message', 'letter', 'read']
    },
    {
        name: 'mail-plus',
        tags: ['email', 'message', 'letter', 'add', 'create', 'new', 'compose']
    },
    {
        name: 'mail-question',
        tags: ['email', 'message', 'letter', 'delivery', 'undelivered']
    },
    {
        name: 'mail-search',
        tags: ['email', 'message', 'letter', 'search']
    },
    {
        name: 'mail-warning',
        tags: ['email', 'message', 'letter', 'delivery error', 'exclamation mark']
    },
    {
        name: 'mail-x',
        tags: ['email', 'message', 'letter', 'remove', 'delete']
    },
    {
        name: 'mailbox',
        tags: ['emails', 'messages', 'letters', 'mailing list', 'newsletter']
    },
    {
        name: 'mails',
        tags: ['emails', 'messages', 'letters', 'multiple', 'mailing list', 'newsletter', 'copy']
    },
    {
        name: 'map',
        tags: ['location', 'navigation', 'travel']
    },
    {
        name: 'map-pin',
        tags: ['location', 'waypoint', 'marker', 'drop']
    },
    {
        name: 'map-pin-check',
        tags: ['location', 'waypoint', 'marker', 'drop', 'done', 'tick', 'complete', 'task', 'added']
    },
    {
        name: 'map-pin-check-inside',
        tags: ['location', 'waypoint', 'marker', 'drop', 'done', 'tick', 'complete', 'task', 'added']
    },
    {
        name: 'map-pin-house',
        tags: [
            'location',
            'waypoint',
            'marker',
            'drop',
            'home',
            'living',
            'building',
            'residence',
            'architecture',
            'address',
            'poi',
            'real estate',
            'property',
            'navigation',
            'destination',
            'geolocation',
            'place',
            'landmark'
        ]
    },
    {
        name: 'map-pin-minus',
        tags: ['location', 'waypoint', 'marker', 'drop', 'delete', 'remove', 'erase']
    },
    {
        name: 'map-pin-minus-inside',
        tags: ['location', 'waypoint', 'marker', 'drop', 'delete', 'remove', 'erase']
    },
    {
        name: 'map-pin-off',
        tags: ['location', 'waypoint', 'marker', 'remove']
    },
    {
        name: 'map-pin-plus',
        tags: ['location', 'waypoint', 'marker', 'drop', 'add', 'create', 'new']
    },
    {
        name: 'map-pin-plus-inside',
        tags: ['location', 'waypoint', 'marker', 'drop', 'add', 'create', 'new']
    },
    {
        name: 'map-pin-x',
        tags: ['location', 'waypoint', 'marker', 'drop', 'delete', 'remove', 'erase']
    },
    {
        name: 'map-pin-x-inside',
        tags: ['location', 'waypoint', 'marker', 'drop', 'delete', 'remove', 'erase']
    },
    {
        name: 'map-pinned',
        tags: ['location', 'waypoint', 'marker', 'drop']
    },
    {
        name: 'martini',
        tags: ['cocktail', 'alcohol', 'beverage', 'bar', 'drink', 'glass']
    },
    {
        name: 'maximize',
        tags: ['fullscreen', 'expand', 'dashed']
    },
    {
        name: 'maximize-2',
        tags: ['fullscreen', 'arrows', 'expand']
    },
    {
        name: 'medal',
        tags: ['prize', 'sports', 'winner', 'trophy', 'award', 'achievement']
    },
    {
        name: 'megaphone',
        tags: ['advertisement', 'attention', 'alert', 'notification']
    },
    {
        name: 'megaphone-off',
        tags: ['advertisement', 'attention', 'alert', 'notification', 'disable', 'silent']
    },
    {
        name: 'meh',
        tags: ['emoji', 'face', 'neutral', 'emotion']
    },
    {
        name: 'memory-stick',
        tags: [
            'ram',
            'random access',
            'technology',
            'computer',
            'chip',
            'circuit',
            'specs',
            'capacity',
            'gigabytes',
            'gb'
        ]
    },
    {
        name: 'menu',
        tags: ['bars', 'navigation', 'hamburger', 'options']
    },
    {
        name: 'merge',
        tags: ['combine', 'join', 'unite']
    },
    {
        name: 'message-circle',
        tags: ['comment', 'chat', 'conversation', 'dialog', 'feedback', 'speech bubble']
    },
    {
        name: 'message-circle-code',
        tags: ['comment', 'chat', 'conversation', 'dialog', 'feedback', 'speech bubble', 'code review', 'coding']
    },
    {
        name: 'message-circle-dashed',
        tags: ['comment', 'chat', 'conversation', 'dialog', 'feedback', 'speech bubble', 'draft']
    },
    {
        name: 'message-circle-heart',
        tags: [
            'comment',
            'chat',
            'conversation',
            'dialog',
            'feedback',
            'positive',
            'like',
            'love',
            'interest',
            'valentine',
            'dating',
            'date',
            'speech bubble'
        ]
    },
    {
        name: 'message-circle-more',
        tags: [
            'comment',
            'chat',
            'conversation',
            'dialog',
            'feedback',
            'speech bubble',
            'typing',
            'writing',
            'responding',
            'ellipsis',
            'etc',
            'et cetera',
            '...',
            '…'
        ]
    },
    {
        name: 'message-circle-off',
        tags: [
            'comment',
            'chat',
            'conversation',
            'dialog',
            'feedback',
            'speech bubble',
            'clear',
            'close',
            'delete',
            'remove',
            'cancel',
            'silence',
            'mute',
            'moderate'
        ]
    },
    {
        name: 'message-circle-plus',
        tags: ['comment', 'chat', 'conversation', 'dialog', 'feedback', 'speech bubble', 'add']
    },
    {
        name: 'message-circle-question',
        tags: ['comment', 'chat', 'conversation', 'dialog', 'feedback', 'speech bubble', 'help']
    },
    {
        name: 'message-circle-reply',
        tags: ['comment', 'chat', 'conversation', 'dialog', 'feedback', 'speech bubble', 'reply', 'response']
    },
    {
        name: 'message-circle-warning',
        tags: [
            'comment',
            'chat',
            'conversation',
            'dialog',
            'feedback',
            'speech bubble',
            'report',
            'abuse',
            'offense',
            'alert',
            'danger',
            'caution',
            'protected',
            'exclamation mark'
        ]
    },
    {
        name: 'message-circle-x',
        tags: [
            'comment',
            'chat',
            'conversation',
            'dialog',
            'feedback',
            'speech bubble',
            'clear',
            'close',
            'delete',
            'remove',
            'cancel',
            'silence',
            'mute',
            'moderate'
        ]
    },
    {
        name: 'message-square',
        tags: ['comment', 'chat', 'conversation', 'dialog', 'feedback', 'speech bubble']
    },
    {
        name: 'message-square-code',
        tags: ['comment', 'chat', 'conversation', 'dialog', 'feedback', 'speech bubble', 'code review', 'coding']
    },
    {
        name: 'message-square-dashed',
        tags: ['comment', 'chat', 'conversation', 'dialog', 'feedback', 'speech bubble', 'draft']
    },
    {
        name: 'message-square-diff',
        tags: [
            'comment',
            'chat',
            'conversation',
            'dialog',
            'feedback',
            'speech bubble',
            'add',
            'patch',
            'difference',
            'plus',
            'minus',
            'plus-minus',
            'maths',
            'code review',
            'coding',
            'version control',
            'git'
        ]
    },
    {
        name: 'message-square-dot',
        tags: ['unread', 'unresolved', 'comment', 'chat', 'conversation', 'dialog', 'feedback', 'speech bubble']
    },
    {
        name: 'message-square-heart',
        tags: [
            'comment',
            'chat',
            'conversation',
            'dialog',
            'feedback',
            'positive',
            'like',
            'love',
            'interest',
            'valentine',
            'dating',
            'date',
            'speech bubble'
        ]
    },
    {
        name: 'message-square-more',
        tags: [
            'comment',
            'chat',
            'conversation',
            'dialog',
            'feedback',
            'speech bubble',
            'typing',
            'writing',
            'responding',
            'ellipsis',
            'etc',
            'et cetera',
            '...',
            '…'
        ]
    },
    {
        name: 'message-square-off',
        tags: [
            'comment',
            'chat',
            'conversation',
            'dialog',
            'feedback',
            'speech bubble',
            'clear',
            'close',
            'delete',
            'remove',
            'cancel',
            'silence',
            'mute',
            'moderate'
        ]
    },
    {
        name: 'message-square-plus',
        tags: ['comment', 'chat', 'conversation', 'dialog', 'feedback', 'speech bubble', 'add']
    },
    {
        name: 'message-square-quote',
        tags: [
            'comment',
            'chat',
            'conversation',
            'dialog',
            'feedback',
            'speech bubble',
            'blockquote',
            'quotation',
            'indent',
            'reply',
            'response'
        ]
    },
    {
        name: 'message-square-reply',
        tags: ['comment', 'chat', 'conversation', 'dialog', 'feedback', 'speech bubble', 'reply', 'response']
    },
    {
        name: 'message-square-share',
        tags: ['comment', 'chat', 'conversation', 'dialog', 'feedback', 'speech bubble', 'network', 'forward']
    },
    {
        name: 'message-square-text',
        tags: ['comment', 'chat', 'conversation', 'dialog', 'feedback', 'speech bubble']
    },
    {
        name: 'message-square-warning',
        tags: [
            'comment',
            'chat',
            'conversation',
            'dialog',
            'feedback',
            'speech bubble',
            'report',
            'abuse',
            'offense',
            'alert',
            'danger',
            'caution',
            'protected',
            'exclamation mark'
        ]
    },
    {
        name: 'message-square-x',
        tags: [
            'comment',
            'chat',
            'conversation',
            'dialog',
            'feedback',
            'speech bubble',
            'clear',
            'close',
            'delete',
            'remove',
            'cancel',
            'silence',
            'mute',
            'moderate'
        ]
    },
    {
        name: 'messages-square',
        tags: ['comment', 'chat', 'conversation', 'dialog', 'feedback', 'speech bubbles', 'copy', 'multiple']
    },
    {
        name: 'mic',
        tags: ['record', 'sound', 'listen', 'radio', 'podcast', 'microphone']
    },
    {
        name: 'mic-off',
        tags: ['record', 'sound', 'mute', 'microphone']
    },
    {
        name: 'mic-vocal',
        tags: ['lyrics', 'voice', 'listen', 'sound', 'music', 'radio', 'podcast', 'karaoke', 'singing', 'microphone']
    },
    {
        name: 'microchip',
        tags: [
            'processor',
            'cores',
            'technology',
            'computer',
            'chip',
            'integrated circuit',
            'memory',
            'ram',
            'specs',
            'gpu',
            'gigahertz',
            'ghz'
        ]
    },
    {
        name: 'microscope',
        tags: ['medical', 'education', 'science', 'imaging', 'research']
    },
    {
        name: 'microwave',
        tags: ['oven', 'cooker', 'toaster oven', 'bake']
    },
    {
        name: 'milestone',
        tags: ['signpost', 'direction', 'right', 'east', 'forward', 'version control', 'waypoint']
    },
    {
        name: 'milk',
        tags: ['lactose', 'bottle', 'beverage', 'drink', 'water', 'diet']
    },
    {
        name: 'milk-off',
        tags: ['lactose free', 'bottle', 'beverage', 'drink', 'water', 'allergy', 'intolerance', 'diet']
    },
    {
        name: 'minimize',
        tags: ['exit fullscreen', 'close', 'shrink']
    },
    {
        name: 'minimize-2',
        tags: ['exit fullscreen', 'arrows', 'close', 'shrink']
    },
    {
        name: 'minus',
        tags: [
            'subtract',
            'remove',
            'decrease',
            'decrement',
            'reduce',
            'negative',
            'calculate',
            'line',
            'divider',
            'separator',
            'horizontal rule',
            'hr',
            'html',
            'markup',
            'markdown',
            '---',
            'toolbar',
            'operator',
            'code',
            'coding',
            'minimum',
            'downgrade'
        ]
    },
    {
        name: 'monitor',
        tags: ['tv', 'screen', 'display', 'virtual machine', 'vm']
    },
    {
        name: 'monitor-check',
        tags: ['tv', 'screen', 'display', 'desktop', 'running', 'active', 'virtual machine', 'vm']
    },
    {
        name: 'monitor-cog',
        tags: [
            'tv',
            'screen',
            'display',
            'virtual machine',
            'vm',
            'executable',
            'settings',
            'cog',
            'edit',
            'gear',
            'configuration',
            'preferences',
            'system',
            'control panel',
            'network',
            'computing'
        ]
    },
    {
        name: 'monitor-dot',
        tags: ['tv', 'screen', 'display', 'desktop', 'running', 'active', 'virtual machine', 'vm']
    },
    {
        name: 'monitor-down',
        tags: ['tv', 'screen', 'display', 'desktop', 'download']
    },
    {
        name: 'monitor-off',
        tags: ['share']
    },
    {
        name: 'monitor-pause',
        tags: [
            'tv',
            'screen',
            'display',
            'desktop',
            'video',
            'movie',
            'film',
            'suspend',
            'hibernate',
            'boot',
            'virtual machine',
            'vm'
        ]
    },
    {
        name: 'monitor-play',
        tags: [
            'tv',
            'screen',
            'display',
            'desktop',
            'video',
            'movie',
            'film',
            'running',
            'start',
            'boot',
            'virtual machine',
            'vm'
        ]
    },
    {
        name: 'monitor-smartphone',
        tags: ['smartphone', 'phone', 'cellphone', 'device', 'mobile', 'desktop', 'monitor', 'responsive', 'screens']
    },
    {
        name: 'monitor-speaker',
        tags: ['devices', 'connect', 'cast']
    },
    {
        name: 'monitor-stop',
        tags: [
            'tv',
            'screen',
            'display',
            'desktop',
            'video',
            'movie',
            'film',
            'stop',
            'shutdown',
            'virtual machine',
            'vm'
        ]
    },
    {
        name: 'monitor-up',
        tags: ['tv', 'screen', 'display', 'upload', 'connect', 'remote', 'screen share']
    },
    {
        name: 'monitor-x',
        tags: [
            'tv',
            'screen',
            'display',
            'desktop',
            'virtual machine',
            'vm',
            'close',
            'stop',
            'suspend',
            'remove',
            'delete'
        ]
    },
    {
        name: 'moon',
        tags: ['dark', 'night']
    },
    {
        name: 'moon-star',
        tags: ['dark', 'night', 'star']
    },
    {
        name: 'mountain',
        tags: ['climb', 'hike', 'rock']
    },
    {
        name: 'mountain-snow',
        tags: ['alpine', 'climb', 'snow']
    },
    {
        name: 'mouse',
        tags: ['device', 'scroll', 'click']
    },
    {
        name: 'mouse-off',
        tags: ['device', 'scroll', 'click', 'disabled']
    },
    {
        name: 'mouse-pointer',
        tags: ['click', 'select']
    },
    {
        name: 'mouse-pointer-2',
        tags: ['click', 'select']
    },
    {
        name: 'mouse-pointer-ban',
        tags: ['wait', 'busy', 'loading', 'blocked', 'frozen', 'freeze']
    },
    {
        name: 'mouse-pointer-click',
        tags: ['click', 'select']
    },
    {
        name: 'move',
        tags: ['arrows']
    },
    {
        name: 'move-3d',
        tags: ['arrows', 'axis', 'gizmo', 'coordinates', 'transform', 'translate']
    },
    {
        name: 'move-diagonal',
        tags: ['double', 'arrow']
    },
    {
        name: 'move-diagonal-2',
        tags: ['double', 'arrow']
    },
    {
        name: 'move-down',
        tags: ['arrow', 'direction', 'downwards', 'south']
    },
    {
        name: 'move-down-left',
        tags: ['arrow', 'direction']
    },
    {
        name: 'move-down-right',
        tags: ['arrow', 'direction']
    },
    {
        name: 'move-horizontal',
        tags: ['double', 'arrow']
    },
    {
        name: 'move-left',
        tags: ['arrow', 'direction', 'back', 'west']
    },
    {
        name: 'move-right',
        tags: ['arrow', 'direction', 'trend flat', 'east']
    },
    {
        name: 'move-up',
        tags: ['arrow', 'direction', 'upwards', 'north']
    },
    {
        name: 'move-up-left',
        tags: ['arrow', 'direction']
    },
    {
        name: 'move-up-right',
        tags: ['arrow', 'direction']
    },
    {
        name: 'move-vertical',
        tags: ['double', 'arrow']
    },
    {
        name: 'music',
        tags: ['note', 'quaver', 'eighth note']
    },
    {
        name: 'music-2',
        tags: ['quaver', 'eighth note', 'note']
    },
    {
        name: 'music-3',
        tags: ['crotchet', 'minim', 'quarter note', 'half note', 'note']
    },
    {
        name: 'music-4',
        tags: ['semiquaver', 'sixteenth note', 'note']
    },
    {
        name: 'navigation',
        tags: ['location', 'travel']
    },
    {
        name: 'navigation-2',
        tags: ['location', 'travel']
    },
    {
        name: 'navigation-2-off',
        tags: ['location', 'travel']
    },
    {
        name: 'navigation-off',
        tags: ['location', 'travel']
    },
    {
        name: 'network',
        tags: ['tree']
    },
    {
        name: 'newspaper',
        tags: ['news', 'feed', 'home', 'magazine', 'article', 'headline']
    },
    {
        name: 'nfc',
        tags: ['contactless', 'payment', 'near-field communication']
    },
    {
        name: 'notebook',
        tags: [
            'notepad',
            'notes',
            'stationery',
            'sketchbook',
            'moleskine',
            'closure',
            'strap',
            'band',
            'elastic',
            'organizer',
            'organiser',
            'planner',
            'diary',
            'journal',
            'writing',
            'written',
            'writer',
            'reading',
            'high school',
            'university',
            'college',
            'academy',
            'student',
            'study',
            'homework',
            'research'
        ]
    },
    {
        name: 'notebook-pen',
        tags: [
            'pencil',
            'notepad',
            'notes',
            'noted',
            'stationery',
            'sketchbook',
            'organizer',
            'organiser',
            'planner',
            'diary',
            'journal',
            'writing',
            'write',
            'written',
            'reading',
            'high school',
            'university',
            'college',
            'academy',
            'student',
            'study',
            'research',
            'homework',
            'eraser',
            'rubber'
        ]
    },
    {
        name: 'notebook-tabs',
        tags: [
            'notepad',
            'notes',
            'people',
            'family',
            'friends',
            'acquaintances',
            'contacts',
            'details',
            'addresses',
            'phone numbers',
            'directory',
            'listing',
            'networking',
            'alphabetical',
            'a-z',
            'organizer',
            'organiser',
            'planner',
            'diary',
            'stationery'
        ]
    },
    {
        name: 'notebook-text',
        tags: [
            'notepad',
            'notes',
            'pages',
            'paper',
            'stationery',
            'sketchbook',
            'organizer',
            'organiser',
            'planner',
            'diary',
            'journal',
            'writing',
            'write',
            'written',
            'reading',
            'high school',
            'university',
            'college',
            'academy',
            'student',
            'study',
            'research',
            'homework',
            'lines',
            'opened'
        ]
    },
    {
        name: 'notepad-text',
        tags: [
            'notebook',
            'notes',
            'pages',
            'paper',
            'stationery',
            'sketchbook',
            'organizer',
            'organiser',
            'planner',
            'diary',
            'journal',
            'writing',
            'write',
            'written',
            'reading',
            'high school',
            'university',
            'college',
            'academy',
            'student',
            'study',
            'homework',
            'research',
            'lines',
            'opened'
        ]
    },
    {
        name: 'notepad-text-dashed',
        tags: [
            'notebook',
            'notes',
            'pages',
            'paper',
            'stationery',
            'diary',
            'journal',
            'writing',
            'write',
            'written',
            'draft',
            'template',
            'lines'
        ]
    },
    {
        name: 'nut',
        tags: ['hazelnut', 'acorn', 'food', 'diet']
    },
    {
        name: 'nut-off',
        tags: ['hazelnut', 'acorn', 'food', 'allergy', 'intolerance', 'diet']
    },
    {
        name: 'octagon',
        tags: ['stop', 'shape']
    },
    {
        name: 'octagon-alert',
        tags: ['warning', 'alert', 'danger', 'exclamation mark']
    },
    {
        name: 'octagon-minus',
        tags: ['stop', 'forbidden', 'subtract', 'remove', 'decrease', 'reduce', '-', 'traffic', 'halt', 'restricted']
    },
    {
        name: 'octagon-pause',
        tags: ['music', 'audio', 'stop']
    },
    {
        name: 'octagon-x',
        tags: ['delete', 'stop', 'alert', 'warning', 'times', 'clear', 'maths']
    },
    {
        name: 'omega',
        tags: [
            'greek',
            'symbol',
            'mathematics',
            'education',
            'physics',
            'engineering',
            'ohms',
            'electrical resistance',
            'angular frequency',
            'dynamical systems',
            'astronomy',
            'constellations',
            'philosophy'
        ]
    },
    {
        name: 'option',
        tags: ['keyboard', 'key', 'mac', 'alt', 'button']
    },
    {
        name: 'orbit',
        tags: ['planet', 'space', 'physics', 'satellites', 'moons']
    },
    {
        name: 'origami',
        tags: ['paper', 'bird']
    },
    {
        name: 'package',
        tags: [
            'box',
            'container',
            'storage',
            'sealed',
            'delivery',
            'undelivered',
            'unopened',
            'packed',
            'archive',
            'zip',
            'module'
        ]
    },
    {
        name: 'package-2',
        tags: ['box', 'container', 'storage', 'sealed', 'packed', 'unopened', 'undelivered', 'archive', 'zip']
    },
    {
        name: 'package-check',
        tags: ['confirm', 'verified', 'done', 'todo', 'tick', 'complete', 'task', 'delivered']
    },
    {
        name: 'package-minus',
        tags: ['delete', 'remove']
    },
    {
        name: 'package-open',
        tags: ['box', 'container', 'storage', 'unpack', 'unarchive', 'unzip', 'opened', 'delivered']
    },
    {
        name: 'package-plus',
        tags: ['new', 'add', 'create']
    },
    {
        name: 'package-search',
        tags: ['find', 'product process']
    },
    {
        name: 'package-x',
        tags: ['delete', 'remove']
    },
    {
        name: 'paint-bucket',
        tags: ['fill', 'paint', 'bucket', 'color', 'colour']
    },
    {
        name: 'paint-roller',
        tags: ['brush', 'color', 'colour', 'decoration', 'diy']
    },
    {
        name: 'paintbrush',
        tags: ['brush', 'paintbrush', 'design', 'color', 'colour', 'decoration', 'diy']
    },
    {
        name: 'paintbrush-vertical',
        tags: ['brush', 'paintbrush', 'design', 'color', 'colour', 'decoration', 'diy']
    },
    {
        name: 'palette',
        tags: ['colors', 'colours', 'theme', 'scheme', 'paint', 'watercolor', 'watercolour', 'artist']
    },
    {
        name: 'panel-bottom',
        tags: ['drawer', 'dock']
    },
    {
        name: 'panel-bottom-close',
        tags: ['drawer', 'dock', 'hide', 'chevron', 'down']
    },
    {
        name: 'panel-bottom-dashed',
        tags: ['drawer', 'dock', 'show', 'reveal']
    },
    {
        name: 'panel-bottom-open',
        tags: ['drawer', 'dock', 'show', 'reveal', 'chevron', 'up']
    },
    {
        name: 'panel-left',
        tags: ['primary', 'drawer']
    },
    {
        name: 'panel-left-close',
        tags: ['primary', 'drawer', 'hide', 'chevron', '<']
    },
    {
        name: 'panel-left-dashed',
        tags: ['sidebar', 'primary', 'drawer', 'show', 'reveal']
    },
    {
        name: 'panel-left-open',
        tags: ['primary', 'drawer', 'show', 'reveal', 'chevron', 'right', '>']
    },
    {
        name: 'panel-right',
        tags: ['sidebar', 'secondary', 'drawer']
    },
    {
        name: 'panel-right-close',
        tags: ['sidebar', 'secondary', 'drawer', 'hide', 'chevron', '>']
    },
    {
        name: 'panel-right-dashed',
        tags: ['sidebar', 'secondary', 'drawer', 'show', 'reveal']
    },
    {
        name: 'panel-right-open',
        tags: ['sidebar', 'secondary', 'drawer', 'show', 'reveal', 'chevron', 'left', '<']
    },
    {
        name: 'panel-top',
        tags: ['drawer', 'browser', 'webpage']
    },
    {
        name: 'panel-top-close',
        tags: ['menu bar', 'drawer', 'hide', 'chevron', 'up']
    },
    {
        name: 'panel-top-dashed',
        tags: ['menu bar', 'drawer', 'show', 'reveal']
    },
    {
        name: 'panel-top-open',
        tags: ['menu bar', 'drawer', 'show', 'reveal', 'chevron', 'down']
    },
    {
        name: 'panels-left-bottom',
        tags: ['drawers', 'sidebar', 'primary']
    },
    {
        name: 'panels-right-bottom',
        tags: ['drawers', 'sidebar', 'secondary']
    },
    {
        name: 'panels-top-left',
        tags: ['menu bar', 'sidebar', 'primary', 'drawers', 'window', 'webpage', 'projects', 'overview']
    },
    {
        name: 'paperclip',
        tags: ['attachment', 'file']
    },
    {
        name: 'parentheses',
        tags: [
            'code',
            'token',
            'parenthesis',
            'parens',
            'brackets',
            'parameters',
            'arguments',
            'args',
            'input',
            'call',
            'maths',
            'formula',
            'function',
            '(',
            ')'
        ]
    },
    {
        name: 'parking-meter',
        tags: ['driving', 'car park', 'pay', 'sidewalk', 'pavement']
    },
    {
        name: 'party-popper',
        tags: [
            'emoji',
            'congratulations',
            'celebration',
            'party',
            'tada',
            '🎉',
            '🎊',
            'excitement',
            'exciting',
            'excites',
            'confetti'
        ]
    },
    {
        name: 'pause',
        tags: ['music', 'stop']
    },
    {
        name: 'paw-print',
        tags: ['pets', 'vets', 'veterinarian', 'domesticated', 'cat', 'dog', 'bear']
    },
    {
        name: 'pc-case',
        tags: ['computer', 'chassis']
    },
    {
        name: 'pen',
        tags: [
            'pencil',
            'change',
            'create',
            'draw',
            'writer',
            'writing',
            'biro',
            'ink',
            'marker',
            'felt tip',
            'stationery',
            'artist'
        ]
    },
    {
        name: 'pen-line',
        tags: [
            'pencil',
            'change',
            'create',
            'draw',
            'writer',
            'writing',
            'biro',
            'ink',
            'marker',
            'felt tip',
            'stationery',
            'artist'
        ]
    },
    {
        name: 'pen-off',
        tags: [
            'disabled',
            'inactive',
            'non-editable',
            'locked',
            'read-only',
            'unmodifiable',
            'frozen',
            'restricted',
            'pencil',
            'change',
            'create',
            'draw',
            'writer',
            'writing',
            'biro',
            'ink',
            'marker',
            'felt tip',
            'stationery',
            'artist'
        ]
    },
    {
        name: 'pen-tool',
        tags: ['vector', 'drawing', 'path']
    },
    {
        name: 'pencil',
        tags: ['rubber', 'edit', 'create', 'draw', 'sketch', 'draft', 'writer', 'writing', 'stationery', 'artist']
    },
    {
        name: 'pencil-line',
        tags: [
            'pencil',
            'change',
            'create',
            'draw',
            'sketch',
            'draft',
            'writer',
            'writing',
            'biro',
            'ink',
            'marker',
            'felt tip',
            'stationery',
            'artist'
        ]
    },
    {
        name: 'pencil-off',
        tags: [
            'disabled',
            'inactive',
            'non-editable',
            'locked',
            'read-only',
            'unmodifiable',
            'frozen',
            'restricted',
            'rubber',
            'edit',
            'create',
            'draw',
            'sketch',
            'draft',
            'writer',
            'writing',
            'stationery',
            'artist'
        ]
    },
    {
        name: 'pencil-ruler',
        tags: [
            'edit',
            'create',
            'draw',
            'sketch',
            'draft',
            'writer',
            'writing',
            'stationery',
            'artist',
            'measurements',
            'centimeters',
            'cm',
            'millimeters',
            'mm',
            'metre',
            'foot',
            'feet',
            'inches',
            'units',
            'size',
            'length',
            'width',
            'height',
            'dimensions',
            'depth',
            'breadth',
            'extent'
        ]
    },
    {
        name: 'pentagon',
        tags: ['shape']
    },
    {
        name: 'percent',
        tags: ['percentage', 'modulo', 'modulus', 'remainder', '%', 'sale', 'discount', 'offer', 'marketing']
    },
    {
        name: 'person-standing',
        tags: ['people', 'human', 'accessibility', 'stick figure']
    },
    {
        name: 'philippine-peso',
        tags: ['currency', 'peso', 'money', 'php']
    },
    {
        name: 'phone',
        tags: ['call']
    },
    {
        name: 'phone-call',
        tags: ['ring']
    },
    {
        name: 'phone-forwarded',
        tags: ['call']
    },
    {
        name: 'phone-incoming',
        tags: ['call']
    },
    {
        name: 'phone-missed',
        tags: ['call']
    },
    {
        name: 'phone-off',
        tags: ['call', 'mute']
    },
    {
        name: 'phone-outgoing',
        tags: ['call']
    },
    {
        name: 'pi',
        tags: ['constant', 'code', 'coding', 'programming', 'symbol', 'trigonometry', 'geometry', 'formula']
    },
    {
        name: 'piano',
        tags: [
            'music',
            'audio',
            'sound',
            'noise',
            'notes',
            'chord',
            'keys',
            'octave',
            'acoustic',
            'instrument',
            'play',
            'pianist',
            'performance',
            'concert'
        ]
    },
    {
        name: 'pickaxe',
        tags: [
            'mining',
            'mine',
            'land worker',
            'extraction',
            'labor',
            'construction',
            'progress',
            'advancement',
            'crafting',
            'building',
            'creation'
        ]
    },
    {
        name: 'picture-in-picture',
        tags: ['display', 'play', 'video', 'pop out', 'always on top', 'window', 'inset', 'multitask']
    },
    {
        name: 'picture-in-picture-2',
        tags: ['display', 'play', 'video', 'pop out', 'always on top', 'window', 'inset', 'multitask']
    },
    {
        name: 'piggy-bank',
        tags: ['money', 'savings']
    },
    {
        name: 'pilcrow',
        tags: ['paragraph', 'mark', 'paraph', 'blind', 'typography', 'type', 'text', 'prose', 'symbol']
    },
    {
        name: 'pilcrow-left',
        tags: ['direction', 'paragraph', 'mark', 'paraph', 'blind', 'typography', 'type', 'text', 'prose', 'symbol']
    },
    {
        name: 'pilcrow-right',
        tags: ['direction', 'paragraph', 'mark', 'paraph', 'blind', 'typography', 'type', 'text', 'prose', 'symbol']
    },
    {
        name: 'pill',
        tags: ['medicine', 'medication', 'drug', 'prescription', 'tablet', 'pharmacy']
    },
    {
        name: 'pill-bottle',
        tags: [
            'medicine',
            'medication',
            'prescription',
            'drug',
            'supplement',
            'vitamin',
            'capsule',
            'jar',
            'container',
            'healthcare',
            'pharmaceutical',
            'tablet'
        ]
    },
    {
        name: 'pin',
        tags: ['save', 'map', 'lock', 'fix']
    },
    {
        name: 'pin-off',
        tags: ['unpin', 'map', 'unlock', 'unfix', 'unsave', 'remove']
    },
    {
        name: 'pipette',
        tags: ['eye dropper', 'color picker', 'lab', 'chemistry']
    },
    {
        name: 'pizza',
        tags: ['pie', 'quiche', 'food']
    },
    {
        name: 'plane',
        tags: ['plane', 'trip', 'airplane']
    },
    {
        name: 'plane-landing',
        tags: ['arrival', 'plane', 'trip', 'airplane', 'landing']
    },
    {
        name: 'plane-takeoff',
        tags: ['departure', 'plane', 'trip', 'airplane', 'takeoff']
    },
    {
        name: 'play',
        tags: ['music', 'audio', 'video', 'start', 'run']
    },
    {
        name: 'plug',
        tags: ['electricity', 'energy', 'electronics', 'socket', 'outlet']
    },
    {
        name: 'plug-2',
        tags: ['electricity', 'energy', 'socket', 'outlet']
    },
    {
        name: 'plug-zap',
        tags: ['electricity', 'energy', 'electronics', 'charge', 'charging', 'battery', 'connect']
    },
    {
        name: 'plus',
        tags: [
            'add',
            'new',
            'increase',
            'increment',
            'positive',
            'calculate',
            'toolbar',
            'crosshair',
            'aim',
            'target',
            'scope',
            'sight',
            'reticule',
            'maximum',
            'upgrade',
            'extra',
            '+'
        ]
    },
    {
        name: 'pocket',
        tags: ['logo', 'save']
    },
    {
        name: 'pocket-knife',
        tags: ['swiss army knife', 'penknife', 'multi-tool', 'multitask', 'blade', 'cutter', 'gadget', 'corkscrew']
    },
    {
        name: 'podcast',
        tags: ['audio', 'music', 'mic', 'talk', 'voice', 'subscribe', 'subscription', 'stream']
    },
    {
        name: 'pointer',
        tags: ['mouse']
    },
    {
        name: 'pointer-off',
        tags: ['mouse']
    },
    {
        name: 'popcorn',
        tags: ['cinema', 'movies', 'films', 'salted', 'sweet', 'sugar', 'candy', 'snack']
    },
    {
        name: 'popsicle',
        tags: ['ice lolly', 'ice cream', 'sweet', 'food']
    },
    {
        name: 'pound-sterling',
        tags: ['currency', 'money', 'payment']
    },
    {
        name: 'power',
        tags: [
            'on',
            'off',
            'device',
            'switch',
            'toggle',
            'binary',
            'boolean',
            'reboot',
            'restart',
            'button',
            'keyboard',
            'troubleshoot'
        ]
    },
    {
        name: 'power-off',
        tags: ['on', 'off', 'device', 'switch']
    },
    {
        name: 'presentation',
        tags: [
            'screen',
            'whiteboard',
            'marker pens',
            'markers',
            'blackboard',
            'chalk',
            'easel',
            'school',
            'learning',
            'lesson',
            'office',
            'meeting',
            'project',
            'planning'
        ]
    },
    {
        name: 'printer',
        tags: ['fax', 'office', 'device']
    },
    {
        name: 'printer-check',
        tags: ['fax', 'office', 'device', 'success', 'printed']
    },
    {
        name: 'projector',
        tags: [
            'cinema',
            'film',
            'movie',
            'home video',
            'presentation',
            'slideshow',
            'office',
            'meeting',
            'project',
            'planning'
        ]
    },
    {
        name: 'proportions',
        tags: [
            'screens',
            'sizes',
            'rotate',
            'rotation',
            'adjust',
            'aspect ratio',
            '16:9',
            'widescreen',
            '4:3',
            'resolution',
            'responsive',
            'mobile',
            'desktop',
            'dimensions',
            'monitor',
            'orientation',
            'portrait',
            'landscape'
        ]
    },
    {
        name: 'puzzle',
        tags: ['component', 'module', 'part', 'piece']
    },
    {
        name: 'pyramid',
        tags: [
            'prism',
            'triangle',
            'triangular',
            'hierarchy',
            'structure',
            'geometry',
            'ancient',
            'egyptian',
            'landmark',
            'tourism'
        ]
    },
    {
        name: 'qr-code',
        tags: ['barcode', 'scan', 'link', 'url', 'information', 'digital']
    },
    {
        name: 'quote',
        tags: ['quotation']
    },
    {
        name: 'rabbit',
        tags: ['animal', 'rodent', 'pet', 'pest', 'bunny', 'hare', 'fast', 'speed', 'hop']
    },
    {
        name: 'radar',
        tags: ['scan', 'sonar', 'detect', 'find', 'locate']
    },
    {
        name: 'radiation',
        tags: ['radioactive', 'nuclear', 'fallout', 'waste', 'atomic', 'physics', 'particle', 'element', 'molecule']
    },
    {
        name: 'radical',
        tags: ['calculate', 'formula', 'maths', 'operator', 'root', 'square', 'symbol']
    },
    {
        name: 'radio',
        tags: ['signal', 'broadcast', 'connectivity', 'live', 'frequency']
    },
    {
        name: 'radio-receiver',
        tags: ['device', 'music', 'connect']
    },
    {
        name: 'radio-tower',
        tags: ['signal', 'broadcast', 'connectivity', 'live', 'frequency']
    },
    {
        name: 'radius',
        tags: ['shape', 'circle', 'geometry', 'trigonometry', 'radii', 'calculate', 'measure', 'size']
    },
    {
        name: 'rail-symbol',
        tags: ['railway', 'train', 'track', 'line']
    },
    {
        name: 'rainbow',
        tags: ['colors', 'colours', 'spectrum', 'light', 'prism', 'arc', 'clear', 'sunshine']
    },
    {
        name: 'rat',
        tags: ['mouse', 'mice', 'gerbil', 'rodent', 'pet', 'pest', 'plague', 'disease']
    },
    {
        name: 'ratio',
        tags: [
            'screens',
            'sizes',
            'rotate',
            'rotation',
            'adjust',
            'aspect ratio',
            'proportions',
            '16:9',
            'widescreen',
            '4:3',
            'resolution',
            'responsive',
            'mobile',
            'desktop',
            'dimensions',
            'monitor',
            'orientation',
            'portrait',
            'landscape'
        ]
    },
    {
        name: 'receipt',
        tags: ['bill', 'voucher', 'slip', 'check', 'counterfoil', 'currency', 'dollar', 'usd', '$']
    },
    {
        name: 'receipt-cent',
        tags: ['bill', 'voucher', 'slip', 'check', 'counterfoil', 'currency', 'cents', 'dollar', 'usd', '$', '¢']
    },
    {
        name: 'receipt-euro',
        tags: ['bill', 'voucher', 'slip', 'check', 'counterfoil', 'currency', '€']
    },
    {
        name: 'receipt-indian-rupee',
        tags: ['bill', 'voucher', 'slip', 'check', 'counterfoil', 'inr', '₹']
    },
    {
        name: 'receipt-japanese-yen',
        tags: ['bill', 'voucher', 'slip', 'check', 'counterfoil', 'jpy', '¥']
    },
    {
        name: 'receipt-pound-sterling',
        tags: ['bill', 'voucher', 'slip', 'check', 'counterfoil', 'british', 'gbp', '£']
    },
    {
        name: 'receipt-russian-ruble',
        tags: ['bill', 'voucher', 'slip', 'check', 'counterfoil', 'rub', '₽']
    },
    {
        name: 'receipt-swiss-franc',
        tags: ['bill', 'voucher', 'slip', 'check', 'counterfoil', 'chf', '₣']
    },
    {
        name: 'receipt-text',
        tags: [
            'bill',
            'voucher',
            'slip',
            'check',
            'counterfoil',
            'details',
            'small print',
            'terms',
            'conditions',
            'contract'
        ]
    },
    {
        name: 'rectangle-ellipsis',
        tags: [
            'login',
            'password',
            'authenticate',
            '2fa',
            'field',
            'fill',
            'ellipsis',
            'et cetera',
            'etc',
            'loader',
            'loading',
            'progress',
            'pending',
            'throbber',
            'menu',
            'options',
            'operator',
            'code',
            'spread',
            'rest',
            'more',
            'further',
            'extra',
            'overflow',
            'dots',
            '…',
            '...'
        ]
    },
    {
        name: 'rectangle-horizontal',
        tags: ['rectangle', 'aspect ratio', '16:9', 'horizontal', 'shape']
    },
    {
        name: 'rectangle-vertical',
        tags: ['rectangle', 'aspect ratio', '9:16', 'vertical', 'shape']
    },
    {
        name: 'recycle',
        tags: ['sustainability', 'salvage', 'arrows']
    },
    {
        name: 'redo',
        tags: ['undo', 'rerun', 'history']
    },
    {
        name: 'redo-2',
        tags: ['undo', 'rerun', 'history']
    },
    {
        name: 'redo-dot',
        tags: ['redo', 'history', 'step', 'over', 'forward']
    },
    {
        name: 'refresh-ccw',
        tags: ['arrows', 'rotate', 'reload', 'rerun', 'synchronise', 'synchronize', 'circular', 'cycle']
    },
    {
        name: 'refresh-ccw-dot',
        tags: [
            'arrows',
            'rotate',
            'reload',
            'synchronise',
            'synchronize',
            'circular',
            'cycle',
            'issue',
            'code',
            'coding',
            'version control'
        ]
    },
    {
        name: 'refresh-cw',
        tags: ['rotate', 'reload', 'rerun', 'synchronise', 'synchronize', 'arrows', 'circular', 'cycle']
    },
    {
        name: 'refresh-cw-off',
        tags: [
            'rotate',
            'reload',
            'rerun',
            'synchronise',
            'synchronize',
            'arrows',
            'circular',
            'cycle',
            'cancel',
            'no',
            'stop',
            'error',
            'disconnect',
            'ignore'
        ]
    },
    {
        name: 'refrigerator',
        tags: ['frigerator', 'fridge', 'freezer', 'cooler', 'icebox', 'chiller', 'cold storage']
    },
    {
        name: 'regex',
        tags: ['search', 'text', 'code']
    },
    {
        name: 'remove-formatting',
        tags: ['text', 'font', 'typography', 'format', 'x', 'remove', 'delete', 'times', 'clear']
    },
    {
        name: 'repeat',
        tags: ['loop', 'arrows']
    },
    {
        name: 'repeat-1',
        tags: ['replay']
    },
    {
        name: 'repeat-2',
        tags: ['arrows', 'retweet', 'repost', 'share', 'repeat', 'loop']
    },
    {
        name: 'replace',
        tags: ['search', 'substitute', 'swap', 'change']
    },
    {
        name: 'replace-all',
        tags: ['search', 'substitute', 'swap', 'change']
    },
    {
        name: 'reply',
        tags: ['email']
    },
    {
        name: 'reply-all',
        tags: ['email']
    },
    {
        name: 'rewind',
        tags: ['music']
    },
    {
        name: 'ribbon',
        tags: ['awareness', 'strip', 'band', 'tape', 'strap', 'cordon']
    },
    {
        name: 'rocket',
        tags: ['release', 'boost', 'launch', 'space', 'version']
    },
    {
        name: 'rocking-chair',
        tags: ['chair', 'furniture', 'seat']
    },
    {
        name: 'roller-coaster',
        tags: ['attraction', 'entertainment', 'amusement park', 'theme park', 'funfair']
    },
    {
        name: 'rotate-3d',
        tags: ['gizmo', 'transform', 'orientation', 'orbit', 'axis']
    },
    {
        name: 'rotate-ccw',
        tags: ['arrow', 'left', 'counter-clockwise', 'restart', 'reload', 'rerun', 'refresh', 'backup', 'undo']
    },
    {
        name: 'rotate-ccw-square',
        tags: ['left', 'counter-clockwise', 'rotate', 'image', '90', '45', 'degrees', '°']
    },
    {
        name: 'rotate-cw',
        tags: ['arrow', 'right', 'clockwise', 'refresh', 'reload', 'rerun', 'redo']
    },
    {
        name: 'rotate-cw-square',
        tags: ['right', 'clockwise', 'rotate', 'image', '90', '45', 'degrees', '°']
    },
    {
        name: 'route',
        tags: ['path', 'journey', 'planner', 'points', 'stops', 'stations']
    },
    {
        name: 'route-off',
        tags: [
            'path',
            'journey',
            'planner',
            'points',
            'stops',
            'stations',
            'reset',
            'clear',
            'cancelled',
            'closed',
            'blocked'
        ]
    },
    {
        name: 'router',
        tags: ['computer', 'server', 'cloud']
    },
    {
        name: 'rows-2',
        tags: [
            'lines',
            'list',
            'queue',
            'preview',
            'panel',
            'paragraphs',
            'parallel',
            'series',
            'split',
            'vertical',
            'horizontal',
            'half',
            'center',
            'middle',
            'even',
            'drawer'
        ]
    },
    {
        name: 'rows-3',
        tags: [
            'lines',
            'list',
            'queue',
            'preview',
            'paragraphs',
            'parallel',
            'series',
            'split',
            'vertical',
            'horizontal',
            'half',
            'center',
            'middle',
            'even',
            'drawers'
        ]
    },
    {
        name: 'rows-4',
        tags: [
            'lines',
            'list',
            'queue',
            'preview',
            'paragraphs',
            'parallel',
            'series',
            'split',
            'vertical',
            'horizontal',
            'half',
            'center',
            'middle',
            'even',
            'drawers',
            'grill'
        ]
    },
    {
        name: 'rss',
        tags: [
            'feed',
            'subscribe',
            'news',
            'updates',
            'notifications',
            'content',
            'blog',
            'articles',
            'broadcast',
            'syndication',
            'reader',
            'channels',
            'posts',
            'publishing',
            'digest',
            'alert',
            'following',
            'inbox',
            'newsletter',
            'weblog',
            'podcast'
        ]
    },
    {
        name: 'ruler',
        tags: [
            'measurements',
            'centimeters',
            'cm',
            'millimeters',
            'mm',
            'metre',
            'foot',
            'feet',
            'inches',
            'units',
            'size',
            'length',
            'width',
            'height',
            'dimensions',
            'depth',
            'breadth',
            'extent',
            'stationery'
        ]
    },
    {
        name: 'russian-ruble',
        tags: ['currency', 'money', 'payment']
    },
    {
        name: 'sailboat',
        tags: ['ship', 'boat', 'harbor', 'harbour', 'dock']
    },
    {
        name: 'salad',
        tags: ['food', 'vegetarian', 'dish', 'restaurant', 'course', 'meal', 'side', 'vegetables', 'health']
    },
    {
        name: 'sandwich',
        tags: ['food', 'snack', 'dish', 'restaurant', 'lunch', 'meal']
    },
    {
        name: 'satellite',
        tags: ['space station', 'orbit', 'transmitter']
    },
    {
        name: 'satellite-dish',
        tags: ['antenna', 'receiver', 'dish aerial', 'saucer']
    },
    {
        name: 'save',
        tags: ['floppy disk']
    },
    {
        name: 'save-all',
        tags: ['floppy disks', 'copy']
    },
    {
        name: 'save-off',
        tags: ['floppy disk', 'unsalvageable']
    },
    {
        name: 'scale',
        tags: ['balance', 'legal', 'license', 'right', 'rule', 'law']
    },
    {
        name: 'scale-3d',
        tags: ['gizmo', 'transform', 'size', 'axis']
    },
    {
        name: 'scaling',
        tags: ['scale', 'resize', 'design']
    },
    {
        name: 'scan',
        tags: [
            'qr-code',
            'barcode',
            'checkout',
            'augmented reality',
            'ar',
            'target',
            'surveillance',
            'camera',
            'lens',
            'focus',
            'frame',
            'select',
            'box',
            'boundary',
            'bounds',
            'area',
            'square',
            'dashed'
        ]
    },
    {
        name: 'scan-barcode',
        tags: [
            'checkout',
            'till',
            'cart',
            'transaction',
            'purchase',
            'buy',
            'product',
            'packaging',
            'retail',
            'consumer'
        ]
    },
    {
        name: 'scan-eye',
        tags: [
            'preview',
            'zoom',
            'expand',
            'fullscreen',
            'gallery',
            'image',
            'camera',
            'watch',
            'surveillance',
            'retina',
            'focus',
            'lens',
            'biometric',
            'identification',
            'authentication',
            'access',
            'login'
        ]
    },
    {
        name: 'scan-face',
        tags: ['face', 'biometric', 'identification', 'authentication', '2fa', 'access', 'login', 'dashed']
    },
    {
        name: 'scan-line',
        tags: [
            'checkout',
            'till',
            'cart',
            'transaction',
            'purchase',
            'buy',
            'product',
            'packaging',
            'retail',
            'consumer',
            'qr-code',
            'dashed'
        ]
    },
    {
        name: 'scan-qr-code',
        tags: ['barcode', 'scan', 'qrcode', 'url', 'information', 'digital', 'scanner']
    },
    {
        name: 'scan-search',
        tags: ['preview', 'zoom', 'expand', 'fullscreen', 'gallery', 'image', 'focus', 'lens']
    },
    {
        name: 'scan-text',
        tags: ['recognition', 'read', 'translate', 'copy', 'lines']
    },
    {
        name: 'school',
        tags: [
            'building',
            'education',
            'childhood',
            'university',
            'learning',
            'campus',
            'scholar',
            'student',
            'lecture',
            'degree',
            'course',
            'academia',
            'study',
            'knowledge',
            'classroom',
            'research',
            'diploma',
            'graduation',
            'professor',
            'tutorial',
            'homework',
            'assignment',
            'exam'
        ]
    },
    {
        name: 'scissors',
        tags: ['cut', 'snip', 'chop', 'stationery', 'crafts']
    },
    {
        name: 'scissors-line-dashed',
        tags: ['cut here', 'along', 'snip', 'chop', 'stationery', 'crafts', 'instructions', 'diagram']
    },
    {
        name: 'screen-share',
        tags: ['host', 'desktop', 'monitor']
    },
    {
        name: 'screen-share-off',
        tags: ['desktop', 'disconnect', 'monitor']
    },
    {
        name: 'scroll',
        tags: [
            'paper',
            'log',
            'scripture',
            'document',
            'notes',
            'parchment',
            'list',
            'long',
            'script',
            'story',
            'code',
            'coding'
        ]
    },
    {
        name: 'scroll-text',
        tags: [
            'paper',
            'log',
            'scripture',
            'document',
            'notes',
            'parchment',
            'list',
            'long',
            'script',
            'story',
            'code',
            'coding'
        ]
    },
    {
        name: 'search',
        tags: ['find', 'scan', 'magnifier', 'magnifying glass']
    },
    {
        name: 'search-check',
        tags: ['find', 'scan', 'magnifier', 'magnifying glass', 'found', 'correct', 'complete', 'tick']
    },
    {
        name: 'search-code',
        tags: ['find', 'scan', 'magnifier', 'magnifying glass', 'grep', 'chevrons', '<>']
    },
    {
        name: 'search-slash',
        tags: ['find', 'scan', 'magnifier', 'magnifying glass', 'stop', 'clear', 'cancel', 'abort', '/']
    },
    {
        name: 'search-x',
        tags: ['find', 'scan', 'magnifier', 'magnifying glass', 'stop', 'clear', 'cancel', 'abort']
    },
    {
        name: 'section',
        tags: ['mark', 'typography', 'punctuation', 'legal', 'type', 'text', 'prose', 'symbol']
    },
    {
        name: 'send',
        tags: ['email', 'message', 'mail', 'paper airplane', 'paper aeroplane', 'submit']
    },
    {
        name: 'send-horizontal',
        tags: ['email', 'message', 'mail', 'paper airplane', 'paper aeroplane', 'submit']
    },
    {
        name: 'send-to-back',
        tags: ['bring', 'send', 'move', 'under', 'back', 'backwards', 'overlap', 'layer', 'order']
    },
    {
        name: 'separator-horizontal',
        tags: ['move', 'split']
    },
    {
        name: 'separator-vertical',
        tags: ['move', 'split']
    },
    {
        name: 'server',
        tags: ['cloud', 'storage']
    },
    {
        name: 'server-cog',
        tags: ['cloud', 'storage', 'computing', 'cog', 'gear']
    },
    {
        name: 'server-crash',
        tags: ['cloud', 'storage', 'problem', 'error']
    },
    {
        name: 'server-off',
        tags: ['cloud', 'storage']
    },
    {
        name: 'settings',
        tags: ['cog', 'edit', 'gear', 'preferences']
    },
    {
        name: 'settings-2',
        tags: ['cog', 'edit', 'gear', 'preferences']
    },
    {
        name: 'shapes',
        tags: [
            'triangle',
            'equilateral',
            'square',
            'circle',
            'classification',
            'different',
            'collection',
            'toy',
            'blocks',
            'learning'
        ]
    },
    {
        name: 'share',
        tags: ['network', 'connections']
    },
    {
        name: 'share-2',
        tags: ['network', 'connections']
    },
    {
        name: 'sheet',
        tags: ['spreadsheets', 'table', 'excel']
    },
    {
        name: 'shell',
        tags: [
            'beach',
            'sand',
            'holiday',
            'sealife',
            'fossil',
            'ammonite',
            'biology',
            'ocean',
            'terminal',
            'command line',
            'session',
            'bash',
            'zsh',
            'roll',
            'wrap',
            'chewing gum',
            'bubble gum',
            'sweet',
            'sugar',
            'hosepipe',
            'carpet',
            'string',
            'spiral',
            'spinner',
            'hypnotise',
            'hypnosis'
        ]
    },
    {
        name: 'shield',
        tags: [
            'cybersecurity',
            'secure',
            'safety',
            'protection',
            'guardian',
            'armored',
            'armoured',
            'defense',
            'defence',
            'defender',
            'block',
            'threat',
            'prevention',
            'antivirus',
            'vigilance',
            'vigilant',
            'detection',
            'scan',
            'find',
            'strength',
            'strong',
            'tough',
            'invincible',
            'invincibility',
            'invulnerable',
            'undamaged',
            'audit',
            'admin',
            'verification',
            'crest',
            'bravery',
            'knight',
            'foot soldier',
            'infantry',
            'trooper',
            'pawn',
            'battle',
            'war',
            'military',
            'army',
            'cadet',
            'scout'
        ]
    },
    {
        name: 'shield-alert',
        tags: [
            'unshielded',
            'cybersecurity',
            'insecure',
            'unsecured',
            'safety',
            'unsafe',
            'protection',
            'unprotected',
            'guardian',
            'unguarded',
            'unarmored',
            'unarmoured',
            'defenseless',
            'defenceless',
            'undefended',
            'defender',
            'blocked',
            'stopped',
            'intercepted',
            'interception',
            'saved',
            'thwarted',
            'threat',
            'prevention',
            'unprevented',
            'antivirus',
            'vigilance',
            'vigilant',
            'detection',
            'detected',
            'scanned',
            'found',
            'exploit',
            'vulnerability',
            'vulnerable',
            'weakness',
            'infection',
            'infected',
            'comprimised',
            'data leak',
            'audited',
            'admin',
            'verification',
            'unverified',
            'uncertified',
            'warning',
            'emergency',
            'attention',
            'urgent',
            'alarm',
            'crest',
            'bravery',
            'strength',
            'tough',
            'attacked',
            'damaged',
            'injured',
            'hit',
            'expired',
            'disabled',
            'inactive',
            'error',
            'exclamation mark',
            '!'
        ]
    },
    {
        name: 'shield-ban',
        tags: [
            'unshielded',
            'cybersecurity',
            'insecure',
            'unsecured',
            'safety',
            'unsafe',
            'protection',
            'unprotected',
            'guardian',
            'unguarded',
            'unarmored',
            'unarmoured',
            'defenseless',
            'defenceless',
            'undefended',
            'defender',
            'blocked',
            'stopped',
            'intercepted',
            'interception',
            'saved',
            'thwarted',
            'threat',
            'prevention',
            'unprevented',
            'antivirus',
            'vigilance',
            'vigilant',
            'detection',
            'detected',
            'scanned',
            'found',
            'exploit',
            'vulnerability',
            'vulnerable',
            'weakness',
            'infection',
            'infected',
            'comprimised',
            'data leak',
            'audited',
            'admin',
            'verification',
            'unverified',
            'uncertified',
            'cancel',
            'error',
            'crest',
            'bravery',
            'attacked',
            'damaged',
            'injured',
            'hit',
            'expired',
            'eliminated',
            'disabled',
            'inactive',
            '/'
        ]
    },
    {
        name: 'shield-check',
        tags: [
            'cybersecurity',
            'secured',
            'safety',
            'protection',
            'protected',
            'guardian',
            'guarded',
            'armored',
            'armoured',
            'defense',
            'defence',
            'defended',
            'blocked',
            'threat',
            'prevention',
            'prevented',
            'antivirus',
            'vigilance',
            'vigilant',
            'active',
            'activated',
            'enabled',
            'detection',
            'scanned',
            'found',
            'strength',
            'strong',
            'tough',
            'invincible',
            'invincibility',
            'invulnerable',
            'undamaged',
            'audited',
            'admin',
            'verification',
            'verified',
            'certification',
            'certified',
            'tested',
            'passed',
            'qualified',
            'cleared',
            'cleaned',
            'disinfected',
            'uninfected',
            'task',
            'completed',
            'todo',
            'done',
            'ticked',
            'checked',
            'crest',
            'bravery'
        ]
    },
    {
        name: 'shield-ellipsis',
        tags: [
            'cybersecurity',
            'securing',
            'protecting',
            'guarding',
            'armoring',
            'armouring',
            'defending',
            'blocking',
            'preventing',
            'antivirus',
            'detecting',
            'scanning',
            'finding',
            'auditing',
            'admin',
            'verifying',
            'crest',
            'upgrading',
            'loader',
            'loading',
            'throbber',
            'progress',
            'dots',
            'more',
            'etc',
            '...',
            '…'
        ]
    },
    {
        name: 'shield-half',
        tags: [
            'cybersecurity',
            'secure',
            'safety',
            'protection',
            'guardian',
            'armored',
            'armoured',
            'defense',
            'defence',
            'defender',
            'block',
            'threat',
            'prevention',
            'antivirus',
            'vigilance',
            'vigilant',
            'detection',
            'scan',
            'strength',
            'strong',
            'tough',
            'invincible',
            'invincibility',
            'invulnerable',
            'undamaged',
            'audit',
            'admin',
            'verification',
            'crest',
            'logo',
            'sigil',
            'flag',
            'team',
            'faction',
            'fraternity',
            'university',
            'college',
            'academy',
            'school',
            'education',
            'uniform',
            'bravery',
            'knight',
            'foot soldier',
            'infantry',
            'trooper',
            'pawn',
            'battle',
            'war',
            'military',
            'ranking',
            'army',
            'cadet',
            'scout'
        ]
    },
    {
        name: 'shield-minus',
        tags: [
            'unshield',
            'cybersecurity',
            'unsecure',
            'unguard',
            'unblock',
            'antivirus',
            'clean',
            'clear',
            'disinfect',
            'patch',
            'fix',
            'stop',
            'cancel',
            'remove',
            'relax',
            'admin',
            'crest',
            'bravery',
            'weakened',
            'damaged',
            'hit',
            'unarm',
            'disable',
            'deactivate',
            'decommission',
            'downgraded',
            'minimum',
            '-'
        ]
    },
    {
        name: 'shield-off',
        tags: [
            'unshielded',
            'cybersecurity',
            'insecure',
            'unsecured',
            'safety',
            'unsafe',
            'protection',
            'unprotected',
            'guardian',
            'unguarded',
            'unarmored',
            'unarmoured',
            'defenseless',
            'defenceless',
            'undefended',
            'defender',
            'interception',
            'threat',
            'prevention',
            'unprevented',
            'antivirus',
            'detection',
            'undetected',
            'exploit',
            'vulnerability',
            'vulnerable',
            'weakness',
            'infected',
            'infection',
            'comprimised',
            'data leak',
            'unaudited',
            'admin',
            'verification',
            'unverified',
            'inactive',
            'cancelled',
            'error',
            'crest',
            'bravery',
            'damaged',
            'injured',
            'hit',
            'expired',
            'eliminated'
        ]
    },
    {
        name: 'shield-plus',
        tags: [
            'cybersecurity',
            'secure',
            'safety',
            'protection',
            'guardian',
            'armored',
            'armoured',
            'defense',
            'defence',
            'defender',
            'block',
            'threat',
            'prevention',
            'antivirus',
            'vigilance',
            'vigilant',
            'detection',
            'scan',
            'strength',
            'strong',
            'tough',
            'invincible',
            'invincibility',
            'invulnerable',
            'undamaged',
            'extra',
            'added',
            'professional',
            'enterprise',
            'full',
            'maximum',
            'upgraded',
            'ultra',
            'activate',
            'enable',
            'audit',
            'admin',
            'verification',
            'crest',
            'medic',
            '+'
        ]
    },
    {
        name: 'shield-question',
        tags: [
            'unshielded',
            'cybersecurity',
            'insecure',
            'unsecured',
            'safety',
            'unsafe',
            'protection',
            'unprotected',
            'guardian',
            'unguarded',
            'unarmored',
            'unarmoured',
            'defenseless',
            'defenceless',
            'undefended',
            'defender',
            'threat',
            'prevention',
            'unprevented',
            'antivirus',
            'vigilance',
            'vigilant',
            'detection',
            'undetected',
            'scan',
            'find',
            'exploit',
            'vulnerability',
            'vulnerable',
            'weakness',
            'infection',
            'comprimised',
            'data leak',
            'audit',
            'admin',
            'verification',
            'unverified',
            'uncertified',
            'uncertain',
            'unknown',
            'inactive',
            'crest',
            'question mark',
            '?'
        ]
    },
    {
        name: 'shield-x',
        tags: [
            'unshielded',
            'cybersecurity',
            'insecure',
            'unsecured',
            'safety',
            'unsafe',
            'protection',
            'unprotected',
            'guardian',
            'unguarded',
            'unarmored',
            'unarmoured',
            'defenseless',
            'defenceless',
            'undefended',
            'defender',
            'blocked',
            'stopped',
            'intercepted',
            'interception',
            'saved',
            'thwarted',
            'threat',
            'prevention',
            'prevented',
            'antivirus',
            'vigilance',
            'vigilant',
            'detection',
            'detected',
            'scanned',
            'found',
            'exploit',
            'vulnerability',
            'vulnerable',
            'weakness',
            'infection',
            'infected',
            'comprimised',
            'data leak',
            'audited',
            'admin',
            'verification',
            'unverified',
            'inactive',
            'cancel',
            'error',
            'wrong',
            'false',
            'crest',
            'bravery',
            'attacked',
            'damaged',
            'injured',
            'hit',
            'dead',
            'deceased',
            'expired',
            'eliminated',
            'exterminated'
        ]
    },
    {
        name: 'ship',
        tags: [
            'boat',
            'knots',
            'nautical mile',
            'maritime',
            'sailing',
            'yacht',
            'cruise',
            'ocean liner',
            'tanker',
            'vessel',
            'navy',
            'trip'
        ]
    },
    {
        name: 'ship-wheel',
        tags: [
            'steering',
            'rudder',
            'boat',
            'knots',
            'nautical mile',
            'maritime',
            'sailing',
            'yacht',
            'cruise',
            'ocean liner',
            'tanker',
            'vessel',
            'navy',
            'trip'
        ]
    },
    {
        name: 'shirt',
        tags: ['t-shirt', 'shopping', 'store', 'clothing', 'clothes']
    },
    {
        name: 'shopping-bag',
        tags: ['ecommerce', 'cart', 'purchase', 'store']
    },
    {
        name: 'shopping-basket',
        tags: ['cart', 'e-commerce', 'store', 'purchase', 'products', 'items', 'ingredients']
    },
    {
        name: 'shopping-cart',
        tags: ['trolley', 'cart', 'basket', 'e-commerce', 'store', 'purchase', 'products', 'items', 'ingredients']
    },
    {
        name: 'shovel',
        tags: ['dig', 'spade', 'treasure']
    },
    {
        name: 'shower-head',
        tags: ['shower', 'bath', 'bathroom', 'amenities', 'services']
    },
    {
        name: 'shrink',
        tags: ['scale', 'fullscreen']
    },
    {
        name: 'shrub',
        tags: ['forest', 'undergrowth', 'park', 'nature']
    },
    {
        name: 'shuffle',
        tags: ['music', 'random', 'reorder']
    },
    {
        name: 'sigma',
        tags: ['sum', 'calculate', 'formula', 'maths', 'enumeration', 'enumerate']
    },
    {
        name: 'signal',
        tags: ['connection', 'wireless', 'gsm', 'phone', '2g', '3g', '4g', '5g']
    },
    {
        name: 'signal-high',
        tags: ['connection', 'wireless', 'gsm', 'phone', '2g', '3g', '4g', '5g']
    },
    {
        name: 'signal-low',
        tags: ['connection', 'wireless', 'gsm', 'phone', '2g', '3g', '4g', '5g']
    },
    {
        name: 'signal-medium',
        tags: ['connection', 'wireless', 'gsm', 'phone', '2g', '3g', '4g', '5g']
    },
    {
        name: 'signal-zero',
        tags: ['connection', 'wireless', 'gsm', 'phone', '2g', '3g', '4g', '5g', 'lost']
    },
    {
        name: 'signature',
        tags: [
            'text',
            'format',
            'input',
            'contract',
            'autograph',
            'handwriting',
            'sign',
            'cursive',
            'ink',
            'scribble',
            'authorize',
            'personal',
            'agreement',
            'legal',
            'document',
            'identity',
            'authentic',
            'approval',
            'verification',
            'unique'
        ]
    },
    {
        name: 'signpost',
        tags: ['bidirectional', 'left', 'right', 'east', 'west']
    },
    {
        name: 'signpost-big',
        tags: ['bidirectional', 'left', 'right', 'east', 'west']
    },
    {
        name: 'siren',
        tags: ['police', 'ambulance', 'emergency', 'security', 'alert', 'alarm', 'light']
    },
    {
        name: 'skip-back',
        tags: ['arrow', 'previous', 'music']
    },
    {
        name: 'skip-forward',
        tags: ['arrow', 'skip', 'next', 'music']
    },
    {
        name: 'skull',
        tags: ['death', 'danger', 'bone']
    },
    {
        name: 'slack',
        tags: ['logo']
    },
    {
        name: 'slash',
        tags: ['divide', 'division', 'or', '/']
    },
    {
        name: 'slice',
        tags: ['cutter', 'scalpel', 'knife']
    },
    {
        name: 'sliders-horizontal',
        tags: ['settings', 'filters', 'controls']
    },
    {
        name: 'sliders-vertical',
        tags: ['settings', 'controls']
    },
    {
        name: 'smartphone',
        tags: ['phone', 'cellphone', 'device', 'screen']
    },
    {
        name: 'smartphone-charging',
        tags: ['phone', 'cellphone', 'device', 'power', 'screen']
    },
    {
        name: 'smartphone-nfc',
        tags: ['contactless', 'payment', 'near-field communication', 'screen']
    },
    {
        name: 'smile',
        tags: ['emoji', 'face', 'happy', 'good', 'emotion']
    },
    {
        name: 'smile-plus',
        tags: ['emoji', 'face', 'happy', 'good', 'emotion', 'react', 'reaction', 'add']
    },
    {
        name: 'snail',
        tags: ['animal', 'insect', 'slow', 'speed', 'delicacy', 'spiral']
    },
    {
        name: 'snowflake',
        tags: ['cold', 'weather', 'freeze', 'snow', 'winter']
    },
    {
        name: 'sofa',
        tags: ['armchair', 'furniture', 'leisure', 'lounge', 'loveseat', 'couch']
    },
    {
        name: 'soup',
        tags: ['food', 'dish', 'restaurant', 'course', 'meal', 'bowl', 'starter']
    },
    {
        name: 'space',
        tags: ['text', 'selection', 'letters', 'characters', 'font', 'typography']
    },
    {
        name: 'spade',
        tags: ['shape', 'suit', 'playing', 'cards']
    },
    {
        name: 'sparkle',
        tags: ['star', 'effect', 'filter', 'night', 'magic', 'shiny', 'glitter', 'twinkle', 'celebration']
    },
    {
        name: 'sparkles',
        tags: ['stars', 'effect', 'filter', 'night', 'magic']
    },
    {
        name: 'speaker',
        tags: ['sound', 'audio', 'music', 'tweeter', 'subwoofer', 'bass', 'production', 'producer', 'dj']
    },
    {
        name: 'speech',
        tags: ['disability', 'disabled', 'dda', 'human', 'accessibility', 'people', 'sound']
    },
    {
        name: 'spell-check',
        tags: ['spelling', 'error', 'mistake', 'oversight', 'typo', 'correction', 'code', 'linter', 'a']
    },
    {
        name: 'spell-check-2',
        tags: ['spelling', 'error', 'mistake', 'oversight', 'typo', 'correction', 'code', 'linter', 'a']
    },
    {
        name: 'spline',
        tags: ['path', 'pen', 'tool', 'shape', 'curve', 'draw']
    },
    {
        name: 'split',
        tags: ['break', 'disband', 'divide', 'separate', 'branch', 'disunite']
    },
    {
        name: 'spray-can',
        tags: ['paint', 'color', 'graffiti', 'decoration', 'aerosol', 'deodorant', 'shaving foam', 'air freshener']
    },
    {
        name: 'sprout',
        tags: ['leaf', 'nature', 'plant']
    },
    {
        name: 'square',
        tags: ['rectangle', 'aspect ratio', '1:1', 'shape']
    },
    {
        name: 'square-activity',
        tags: [
            'pulse',
            'action',
            'motion',
            'movement',
            'exercise',
            'fitness',
            'healthcare',
            'heart rate monitor',
            'vital signs',
            'vitals',
            'emergency room',
            'er',
            'intensive care',
            'hospital',
            'defibrillator',
            'earthquake',
            'siesmic',
            'magnitude',
            'richter scale',
            'aftershock',
            'tremor',
            'shockwave',
            'audio',
            'waveform',
            'synthesizer',
            'synthesiser',
            'music'
        ]
    },
    {
        name: 'square-arrow-down',
        tags: ['backwards', 'reverse', 'direction', 'south', 'sign', 'keyboard', 'button']
    },
    {
        name: 'square-arrow-down-left',
        tags: ['direction', 'south-west', 'diagonal', 'sign', 'turn', 'keyboard', 'button']
    },
    {
        name: 'square-arrow-down-right',
        tags: ['direction', 'south-east', 'diagonal', 'sign', 'turn', 'keyboard', 'button']
    },
    {
        name: 'square-arrow-left',
        tags: ['previous', 'back', 'direction', 'west', 'sign', 'keyboard', 'button', '<-']
    },
    {
        name: 'square-arrow-out-down-left',
        tags: ['outwards', 'direction', 'south-west', 'diagonal']
    },
    {
        name: 'square-arrow-out-down-right',
        tags: ['outwards', 'direction', 'south-east', 'diagonal']
    },
    {
        name: 'square-arrow-out-up-left',
        tags: ['outwards', 'direction', 'north-west', 'diagonal']
    },
    {
        name: 'square-arrow-out-up-right',
        tags: ['outwards', 'direction', 'north-east', 'diagonal', 'share', 'open', 'external', 'link']
    },
    {
        name: 'square-arrow-right',
        tags: ['next', 'forward', 'direction', 'west', 'sign', 'keyboard', 'button', '->']
    },
    {
        name: 'square-arrow-up',
        tags: ['forward', 'direction', 'north', 'sign', 'keyboard', 'button']
    },
    {
        name: 'square-arrow-up-left',
        tags: ['direction', 'north-west', 'diagonal', 'sign', 'keyboard', 'button']
    },
    {
        name: 'square-arrow-up-right',
        tags: ['direction', 'north-east', 'diagonal', 'sign', 'keyboard', 'button', 'share']
    },
    {
        name: 'square-asterisk',
        tags: ['password', 'secret', 'access', 'key', 'multiply', 'multiplication', 'glob pattern', 'wildcard', '*']
    },
    {
        name: 'square-bottom-dashed-scissors',
        tags: ['cut', 'snippet', 'chop', 'stationery', 'crafts']
    },
    {
        name: 'square-chart-gantt',
        tags: [
            'projects',
            'manage',
            'overview',
            'roadmap',
            'plan',
            'intentions',
            'timeline',
            'deadline',
            'date',
            'event',
            'range',
            'period',
            'productivity',
            'work',
            'agile',
            'code',
            'coding',
            'toolbar',
            'button'
        ]
    },
    {
        name: 'square-check',
        tags: ['done', 'todo', 'tick', 'complete', 'task']
    },
    {
        name: 'square-check-big',
        tags: ['done', 'todo', 'tick', 'complete', 'task']
    },
    {
        name: 'square-chevron-down',
        tags: ['back', 'menu', 'panel']
    },
    {
        name: 'square-chevron-left',
        tags: ['back', 'previous', 'less than', 'fewer', 'menu', 'panel', 'button', 'keyboard', '<']
    },
    {
        name: 'square-chevron-right',
        tags: [
            'forward',
            'next',
            'more than',
            'greater',
            'menu',
            'panel',
            'code',
            'coding',
            'command line',
            'terminal',
            'prompt',
            'shell',
            'console',
            '>'
        ]
    },
    {
        name: 'square-chevron-up',
        tags: [
            'caret',
            'keyboard',
            'button',
            'mac',
            'control',
            'ctrl',
            'superscript',
            'exponential',
            'power',
            'ahead',
            'menu',
            'panel',
            '^'
        ]
    },
    {
        name: 'square-code',
        tags: ['gist', 'source', 'programming', 'html', 'xml', 'coding']
    },
    {
        name: 'square-dashed-bottom',
        tags: ['rectangle', 'aspect ratio', '1:1', 'shape', 'snippet', 'code', 'coding']
    },
    {
        name: 'square-dashed-bottom-code',
        tags: ['rectangle', 'aspect ratio', '1:1', 'shape', 'snippet', 'code', 'coding']
    },
    {
        name: 'square-dashed-kanban',
        tags: [
            'projects',
            'manage',
            'overview',
            'board',
            'tickets',
            'issues',
            'roadmap',
            'plan',
            'intentions',
            'productivity',
            'work',
            'agile',
            'draft',
            'template',
            'boilerplate',
            'code',
            'coding'
        ]
    },
    {
        name: 'square-dashed-mouse-pointer',
        tags: [
            'inspector',
            'element',
            'mouse',
            'click',
            'pointer',
            'box',
            'browser',
            'selector',
            'target',
            'dom',
            'node'
        ]
    },
    {
        name: 'square-divide',
        tags: ['calculate', 'maths', '÷', '/']
    },
    {
        name: 'square-dot',
        tags: ['git', 'diff', 'modified', '.']
    },
    {
        name: 'square-equal',
        tags: ['calculate', '=']
    },
    {
        name: 'square-function',
        tags: ['programming', 'code', 'automation', 'maths']
    },
    {
        name: 'square-kanban',
        tags: [
            'projects',
            'manage',
            'overview',
            'board',
            'tickets',
            'issues',
            'roadmap',
            'plan',
            'intentions',
            'productivity',
            'work',
            'agile',
            'code',
            'coding',
            'toolbar',
            'button'
        ]
    },
    {
        name: 'square-library',
        tags: [
            'books',
            'reading',
            'written',
            'authors',
            'stories',
            'fiction',
            'novels',
            'information',
            'knowledge',
            'education',
            'high school',
            'university',
            'college',
            'academy',
            'learning',
            'study',
            'research',
            'collection',
            'vinyl',
            'records',
            'albums',
            'music',
            'package'
        ]
    },
    {
        name: 'square-m',
        tags: ['metro', 'subway', 'underground', 'track', 'line']
    },
    {
        name: 'square-menu',
        tags: ['bars', 'navigation', 'hamburger', 'options', 'menu bar', 'panel']
    },
    {
        name: 'square-minus',
        tags: [
            'subtract',
            'remove',
            'decrease',
            'reduce',
            'calculator',
            'button',
            'keyboard',
            'line',
            'divider',
            'separator',
            'horizontal rule',
            'hr',
            'html',
            'markup',
            'markdown',
            '---',
            'toolbar',
            'operator',
            'code',
            'coding',
            'minimum',
            'downgrade'
        ]
    },
    {
        name: 'square-mouse-pointer',
        tags: [
            'inspector',
            'element',
            'mouse',
            'click',
            'pointer',
            'box',
            'browser',
            'selector',
            'target',
            'dom',
            'node'
        ]
    },
    {
        name: 'square-parking',
        tags: ['parking lot', 'car park']
    },
    {
        name: 'square-parking-off',
        tags: ['parking lot', 'car park', 'no parking']
    },
    {
        name: 'square-pen',
        tags: [
            'pencil',
            'change',
            'create',
            'draw',
            'sketch',
            'draft',
            'writer',
            'writing',
            'biro',
            'ink',
            'marker',
            'felt tip',
            'stationery',
            'artist'
        ]
    },
    {
        name: 'square-percent',
        tags: ['verified', 'unverified', 'sale', 'discount', 'offer', 'marketing', 'sticker', 'price tag']
    },
    {
        name: 'square-pi',
        tags: ['constant', 'code', 'coding', 'programming', 'symbol', 'trigonometry', 'geometry', 'formula']
    },
    {
        name: 'square-pilcrow',
        tags: ['paragraph', 'mark', 'paraph', 'blind', 'typography', 'type', 'text', 'prose', 'symbol']
    },
    {
        name: 'square-play',
        tags: ['music', 'audio', 'video', 'start', 'run']
    },
    {
        name: 'square-plus',
        tags: [
            'add',
            'new',
            'increase',
            'increment',
            'positive',
            'calculate',
            'calculator',
            'button',
            'keyboard',
            'toolbar',
            'maximum',
            'upgrade',
            'extra',
            'operator',
            'join',
            'concatenate',
            'code',
            'coding',
            '+'
        ]
    },
    {
        name: 'square-power',
        tags: [
            'on',
            'off',
            'device',
            'switch',
            'toggle',
            'binary',
            'boolean',
            'reboot',
            'restart',
            'button',
            'keyboard',
            'troubleshoot'
        ]
    },
    {
        name: 'square-radical',
        tags: ['calculate', 'formula', 'maths', 'operator', 'root', 'square', 'symbol']
    },
    {
        name: 'square-scissors',
        tags: ['cut', 'snippet', 'chop', 'stationery', 'crafts', 'toolbar', 'button']
    },
    {
        name: 'square-sigma',
        tags: ['sum', 'calculate', 'formula', 'maths', 'enumeration', 'enumerate']
    },
    {
        name: 'square-slash',
        tags: ['git', 'diff', 'ignored', 'divide', 'division', 'shortcut', 'or', '/']
    },
    {
        name: 'square-split-horizontal',
        tags: ['split', 'divide']
    },
    {
        name: 'square-split-vertical',
        tags: ['split', 'divide']
    },
    {
        name: 'square-square',
        tags: ['float', 'center', 'rectangle']
    },
    {
        name: 'square-stack',
        tags: [
            'versions',
            'clone',
            'copy',
            'duplicate',
            'multiple',
            'revisions',
            'version control',
            'backup',
            'history'
        ]
    },
    {
        name: 'square-terminal',
        tags: ['code', 'command line', 'prompt', 'shell']
    },
    {
        name: 'square-user',
        tags: ['person', 'account', 'contact']
    },
    {
        name: 'square-user-round',
        tags: ['person', 'account', 'contact']
    },
    {
        name: 'square-x',
        tags: ['cancel', 'close', 'delete', 'remove', 'times', 'clear', 'maths', 'multiply', 'multiplication']
    },
    {
        name: 'squircle',
        tags: ['shape']
    },
    {
        name: 'squirrel',
        tags: ['animal', 'rodent', 'pet', 'pest', 'nuts', 'retrieve', 'updates', 'storage', 'stash']
    },
    {
        name: 'stamp',
        tags: ['mark', 'print', 'clone', 'loyalty', 'library']
    },
    {
        name: 'star',
        tags: ['bookmark', 'favorite', 'like', 'review', 'rating']
    },
    {
        name: 'star-half',
        tags: ['bookmark', 'favorite', 'like', 'review', 'rating']
    },
    {
        name: 'star-off',
        tags: ['dislike', 'unlike', 'remove', 'unrate']
    },
    {
        name: 'step-back',
        tags: ['arrow', 'previous', 'music', 'left', 'reverse']
    },
    {
        name: 'step-forward',
        tags: ['arrow', 'next', 'music', 'right', 'continue']
    },
    {
        name: 'stethoscope',
        tags: ['phonendoscope', 'medical', 'heart', 'lungs', 'sound']
    },
    {
        name: 'sticker',
        tags: ['reaction', 'emotion', 'smile', 'happy', 'feedback']
    },
    {
        name: 'sticky-note',
        tags: [
            'post-it',
            'comment',
            'annotation',
            'reaction',
            'memo',
            'reminder',
            'todo',
            'task',
            'idea',
            'brainstorm',
            'document',
            'page',
            'paper',
            'sheet',
            'stationary',
            'office'
        ]
    },
    {
        name: 'store',
        tags: ['shop', 'supermarket', 'stand', 'boutique', 'building']
    },
    {
        name: 'stretch-horizontal',
        tags: ['items', 'flex', 'justify', 'distribute']
    },
    {
        name: 'stretch-vertical',
        tags: ['items', 'flex', 'justify', 'distribute']
    },
    {
        name: 'strikethrough',
        tags: ['cross out', 'delete', 'remove', 'format']
    },
    {
        name: 'subscript',
        tags: ['text']
    },
    {
        name: 'sun',
        tags: ['brightness', 'weather', 'light', 'summer']
    },
    {
        name: 'sun-dim',
        tags: ['brightness', 'dim', 'low', 'brightness low']
    },
    {
        name: 'sun-medium',
        tags: ['brightness', 'medium']
    },
    {
        name: 'sun-moon',
        tags: [
            'night',
            'dark',
            'light',
            'moon',
            'sun',
            'brightness',
            'theme',
            'auto theme',
            'system theme',
            'appearance'
        ]
    },
    {
        name: 'sun-snow',
        tags: ['weather', 'air conditioning', 'temperature', 'hot', 'cold', 'seasons']
    },
    {
        name: 'sunrise',
        tags: ['weather', 'time', 'morning', 'day']
    },
    {
        name: 'sunset',
        tags: ['weather', 'time', 'evening', 'night']
    },
    {
        name: 'superscript',
        tags: ['text', 'exponent']
    },
    {
        name: 'swatch-book',
        tags: [
            'colors',
            'colours',
            'swatches',
            'pantone',
            'shades',
            'tint',
            'hue',
            'saturation',
            'brightness',
            'theme',
            'scheme',
            'palette',
            'samples',
            'textile',
            'carpet'
        ]
    },
    {
        name: 'swiss-franc',
        tags: ['currency', 'money', 'payment']
    },
    {
        name: 'switch-camera',
        tags: ['photo', 'selfie', 'front', 'back']
    },
    {
        name: 'sword',
        tags: ['battle', 'challenge', 'game', 'war', 'weapon']
    },
    {
        name: 'swords',
        tags: ['battle', 'challenge', 'game', 'war', 'weapon']
    },
    {
        name: 'syringe',
        tags: ['medicine', 'medical', 'needle', 'pump', 'plunger', 'nozzle', 'blood']
    },
    {
        name: 'table',
        tags: ['spreadsheet', 'grid']
    },
    {
        name: 'table-2',
        tags: ['spreadsheet', 'grid']
    },
    {
        name: 'table-cells-merge',
        tags: ['spreadsheet', 'grid', 'row']
    },
    {
        name: 'table-cells-split',
        tags: ['spreadsheet', 'grid', 'row']
    },
    {
        name: 'table-columns-split',
        tags: ['spreadsheet', 'grid', 'cut', 'break', 'divide', 'separate', 'segment']
    },
    {
        name: 'table-of-contents',
        tags: [
            'toc',
            'outline',
            'navigation',
            'document structure',
            'index',
            'overview',
            'sections',
            'chapters',
            'content',
            'documentation',
            'manual',
            'knowledge base',
            'faq'
        ]
    },
    {
        name: 'table-properties',
        tags: ['property list', 'plist', 'spreadsheet', 'grid', 'dictionary', 'object', 'hash']
    },
    {
        name: 'table-rows-split',
        tags: ['spreadsheet', 'grid', 'cut', 'break', 'divide', 'separate', 'segment']
    },
    {
        name: 'tablet',
        tags: ['device']
    },
    {
        name: 'tablet-smartphone',
        tags: ['responsive', 'screens', 'browser', 'testing', 'mobile']
    },
    {
        name: 'tablets',
        tags: ['medicine', 'medication', 'drug', 'prescription', 'pills', 'pharmacy']
    },
    {
        name: 'tag',
        tags: ['label', 'badge', 'ticket', 'mark']
    },
    {
        name: 'tags',
        tags: ['labels', 'badges', 'tickets', 'marks', 'copy', 'multiple']
    },
    {
        name: 'tally-1',
        tags: ['count', 'score', 'enumerate', 'days', 'one', '1', 'first', 'bar', 'prison', 'cell', 'sentence']
    },
    {
        name: 'tally-2',
        tags: [
            'count',
            'score',
            'enumerate',
            'days',
            'two',
            '2',
            'second',
            'double',
            'bars',
            'prison',
            'cell',
            'sentence'
        ]
    },
    {
        name: 'tally-3',
        tags: [
            'count',
            'score',
            'enumerate',
            'days',
            'three',
            '3',
            'third',
            'triple',
            'bars',
            'prison',
            'cell',
            'sentence'
        ]
    },
    {
        name: 'tally-4',
        tags: ['count', 'score', 'enumerate', 'days', '4', 'fourth', 'quadruple', 'bars', 'prison', 'cell', 'sentence']
    },
    {
        name: 'tally-5',
        tags: [
            'count',
            'score',
            'enumerate',
            'days',
            'five',
            '5',
            'fifth',
            'bars',
            'prison',
            'cell',
            'sentence',
            'slash',
            '/'
        ]
    },
    {
        name: 'tangent',
        tags: ['tangential', 'shape', 'circle', 'geometry', 'trigonometry', 'bezier curve']
    },
    {
        name: 'target',
        tags: ['logo', 'bullseye', 'deadline', 'projects', 'overview', 'work', 'productivity']
    },
    {
        name: 'telescope',
        tags: [
            'astronomy',
            'space',
            'discovery',
            'exploration',
            'explore',
            'vision',
            'perspective',
            'focus',
            'stargazing',
            'observe',
            'view'
        ]
    },
    {
        name: 'tent',
        tags: [
            'tipi',
            'teepee',
            'wigwam',
            'lodge',
            'camping',
            'campsite',
            'holiday',
            'retreat',
            'nomadic',
            'native american',
            'indian',
            'wilderness',
            'outdoors'
        ]
    },
    {
        name: 'tent-tree',
        tags: ['camping', 'campsite', 'holiday', 'retreat', 'nomadic', 'wilderness', 'outdoors']
    },
    {
        name: 'terminal',
        tags: ['code', 'command line', 'prompt', 'shell']
    },
    {
        name: 'test-tube',
        tags: ['tube', 'vial', 'phial', 'flask', 'ampoule', 'ampule', 'lab', 'chemistry', 'experiment', 'test']
    },
    {
        name: 'test-tube-diagonal',
        tags: ['tube', 'vial', 'phial', 'flask', 'ampoule', 'ampule', 'lab', 'chemistry', 'experiment', 'test']
    },
    {
        name: 'test-tubes',
        tags: ['tubes', 'vials', 'phials', 'flasks', 'ampoules', 'ampules', 'lab', 'chemistry', 'experiment', 'test']
    },
    {
        name: 'text',
        tags: ['find', 'search', 'data', 'txt', 'pdf', 'document']
    },
    {
        name: 'text-cursor',
        tags: ['select']
    },
    {
        name: 'text-cursor-input',
        tags: ['select']
    },
    {
        name: 'text-quote',
        tags: ['blockquote', 'quotation', 'indent', 'reply', 'response']
    },
    {
        name: 'text-search',
        tags: ['find', 'data', 'copy', 'txt', 'pdf', 'document', 'scan', 'magnifier', 'magnifying glass']
    },
    {
        name: 'text-select',
        tags: ['find', 'search', 'selection', 'dashed']
    },
    {
        name: 'theater',
        tags: ['theater', 'theatre', 'entertainment', 'podium', 'stage', 'musical']
    },
    {
        name: 'thermometer',
        tags: ['temperature', 'celsius', 'fahrenheit', 'weather']
    },
    {
        name: 'thermometer-snowflake',
        tags: ['temperature', 'celsius', 'fahrenheit', 'weather', 'cold', 'freeze', 'freezing']
    },
    {
        name: 'thermometer-sun',
        tags: ['temperature', 'celsius', 'fahrenheit', 'weather', 'warm', 'hot']
    },
    {
        name: 'thumbs-down',
        tags: ['dislike', 'bad', 'emotion']
    },
    {
        name: 'thumbs-up',
        tags: ['like', 'good', 'emotion']
    },
    {
        name: 'ticket',
        tags: ['entry', 'pass', 'voucher', 'event', 'concert', 'show', 'perforated', 'dashed']
    },
    {
        name: 'ticket-check',
        tags: [
            'entry',
            'pass',
            'voucher',
            'event',
            'concert',
            'show',
            'booked',
            'purchased',
            'receipt',
            'redeemed',
            'validated',
            'verified',
            'certified',
            'checked',
            'used'
        ]
    },
    {
        name: 'ticket-minus',
        tags: [
            'entry',
            'pass',
            'voucher',
            'event',
            'concert',
            'show',
            'remove',
            'cancel',
            'unbook',
            'subtract',
            'decrease',
            '-'
        ]
    },
    {
        name: 'ticket-percent',
        tags: [
            'discount',
            'reduced',
            'offer',
            'voucher',
            'entry',
            'pass',
            'event',
            'concert',
            'show',
            'book',
            'purchase',
            '%'
        ]
    },
    {
        name: 'ticket-plus',
        tags: ['entry', 'pass', 'voucher', 'event', 'concert', 'show', 'book', 'purchase', 'add', '+']
    },
    {
        name: 'ticket-slash',
        tags: [
            'entry',
            'pass',
            'voucher',
            'event',
            'concert',
            'show',
            'redeemed',
            'used',
            'marked',
            'checked',
            'verified',
            'spoiled',
            'invalidated',
            'void',
            'denied',
            'refused',
            'banned',
            'barred',
            'forbidden',
            'prohibited',
            'cancelled',
            'cancellation',
            'refunded',
            'delete',
            'remove',
            'clear',
            'error'
        ]
    },
    {
        name: 'ticket-x',
        tags: [
            'entry',
            'pass',
            'voucher',
            'event',
            'concert',
            'show',
            'cancelled',
            'cancellation',
            'refunded',
            'used',
            'void',
            'invalidated',
            'spoiled',
            'denied',
            'refused',
            'banned',
            'barred',
            'forbidden',
            'prohibited',
            'delete',
            'remove',
            'clear',
            'error',
            'x'
        ]
    },
    {
        name: 'tickets',
        tags: ['trip', 'travel', 'pass', 'entry', 'voucher', 'event', 'concert', 'show', 'perforated', 'dashed']
    },
    {
        name: 'tickets-plane',
        tags: [
            'plane',
            'trip',
            'airplane',
            'flight',
            'travel',
            'fly',
            'takeoff',
            'vacation',
            'passenger',
            'pass',
            'check-in',
            'airport'
        ]
    },
    {
        name: 'timer',
        tags: ['time', 'timer', 'stopwatch']
    },
    {
        name: 'timer-off',
        tags: ['time', 'timer', 'stopwatch']
    },
    {
        name: 'timer-reset',
        tags: ['time', 'timer', 'stopwatch']
    },
    {
        name: 'toggle-left',
        tags: ['on', 'off', 'switch', 'boolean']
    },
    {
        name: 'toggle-right',
        tags: ['on', 'off', 'switch', 'boolean']
    },
    {
        name: 'tornado',
        tags: ['weather', 'wind', 'storm', 'hurricane']
    },
    {
        name: 'torus',
        tags: [
            'donut',
            'doughnut',
            'ring',
            'hollow',
            '3d',
            'fast food',
            'junk food',
            'snack',
            'treat',
            'sweet',
            'sugar',
            'dessert'
        ]
    },
    {
        name: 'touchpad',
        tags: ['trackpad', 'cursor']
    },
    {
        name: 'touchpad-off',
        tags: ['trackpad', 'cursor']
    },
    {
        name: 'tower-control',
        tags: ['airport', 'travel', 'tower', 'transportation', 'lighthouse']
    },
    {
        name: 'toy-brick',
        tags: ['lego', 'block', 'addon', 'plugin', 'integration']
    },
    {
        name: 'tractor',
        tags: ['farming', 'farmer', 'ranch', 'harvest', 'equipment', 'vehicle']
    },
    {
        name: 'traffic-cone',
        tags: ['roadworks', 'tarmac', 'safety', 'block']
    },
    {
        name: 'train-front',
        tags: ['railway', 'metro', 'subway', 'underground', 'high-speed', 'bullet', 'fast', 'track', 'line']
    },
    {
        name: 'train-front-tunnel',
        tags: ['railway', 'metro', 'subway', 'underground', 'speed', 'bullet', 'fast', 'track', 'line']
    },
    {
        name: 'train-track',
        tags: ['railway', 'line']
    },
    {
        name: 'tram-front',
        tags: ['railway', 'metro', 'subway', 'underground', 'track', 'line', 'tourism']
    },
    {
        name: 'trash',
        tags: ['garbage', 'delete', 'remove', 'bin']
    },
    {
        name: 'trash-2',
        tags: ['garbage', 'delete', 'remove', 'bin']
    },
    {
        name: 'tree-deciduous',
        tags: ['tree', 'forest', 'park', 'nature']
    },
    {
        name: 'tree-palm',
        tags: ['vacation', 'leisure', 'island']
    },
    {
        name: 'tree-pine',
        tags: ['tree', 'pine', 'forest', 'park', 'nature']
    },
    {
        name: 'trees',
        tags: ['tree', 'forest', 'park', 'nature']
    },
    {
        name: 'trello',
        tags: ['logo', 'brand']
    },
    {
        name: 'trending-down',
        tags: ['statistics']
    },
    {
        name: 'trending-up',
        tags: ['statistics']
    },
    {
        name: 'trending-up-down',
        tags: [
            'arrows',
            'estimated',
            'indeterminate',
            'data fluctuation',
            'uncertain',
            'forecast',
            'variable',
            'prediction',
            'dynamic',
            'volatile'
        ]
    },
    {
        name: 'triangle',
        tags: ['equilateral', 'delta', 'shape', 'pyramid', 'hierarchy']
    },
    {
        name: 'triangle-alert',
        tags: ['warning', 'alert', 'danger', 'exclamation mark', 'linter']
    },
    {
        name: 'triangle-right',
        tags: [
            'volume',
            'controls',
            'controller',
            'tv remote',
            'geometry',
            'delta',
            'ramp',
            'slope',
            'incline',
            'increase'
        ]
    },
    {
        name: 'trophy',
        tags: ['prize', 'sports', 'winner', 'achievement', 'award']
    },
    {
        name: 'truck',
        tags: ['delivery', 'van', 'shipping', 'haulage', 'lorry']
    },
    {
        name: 'turtle',
        tags: ['animal', 'pet', 'tortoise', 'slow', 'speed']
    },
    {
        name: 'tv',
        tags: [
            'television',
            'stream',
            'display',
            'widescreen',
            'high-definition',
            'hd',
            '1080p',
            '4k',
            '8k',
            'smart',
            'digital',
            'video',
            'entertainment',
            'showtime',
            'channels',
            'terrestrial',
            'satellite',
            'cable',
            'broadcast',
            'live',
            'frequency',
            'tune',
            'scan',
            'aerial',
            'receiver',
            'transmission',
            'signal',
            'connection',
            'connectivity'
        ]
    },
    {
        name: 'tv-minimal',
        tags: [
            'flatscreen',
            'television',
            'stream',
            'display',
            'widescreen',
            'high-definition',
            'hd',
            '1080p',
            '4k',
            '8k',
            'smart',
            'digital',
            'video',
            'home cinema',
            'entertainment',
            'showtime',
            'channels',
            'catchup'
        ]
    },
    {
        name: 'tv-minimal-play',
        tags: [
            'flatscreen',
            'television',
            'stream',
            'display',
            'widescreen',
            'high-definition',
            'hd',
            '1080p',
            '4k',
            '8k',
            'smart',
            'digital',
            'video',
            'movie',
            'live',
            'ott',
            'running',
            'start',
            'film',
            'home cinema',
            'entertainment',
            'showtime',
            'channels',
            'catchup'
        ]
    },
    {
        name: 'twitch',
        tags: ['logo', 'social']
    },
    {
        name: 'twitter',
        tags: ['logo', 'social']
    },
    {
        name: 'type',
        tags: ['text', 'font', 'typography']
    },
    {
        name: 'type-outline',
        tags: ['text', 'font', 'typography', 'silhouette', 'profile', 'contour', 'stroke', 'line']
    },
    {
        name: 'umbrella',
        tags: ['rain', 'weather']
    },
    {
        name: 'umbrella-off',
        tags: ['rain', 'weather', 'uncovered', 'uninsured', 'antivirus', 'unprotected', 'risky']
    },
    {
        name: 'underline',
        tags: ['text', 'format']
    },
    {
        name: 'undo',
        tags: ['redo', 'rerun', 'history']
    },
    {
        name: 'undo-2',
        tags: ['redo', 'rerun', 'history', 'back', 'return', 'reverse', 'revert', 'direction', 'u-turn']
    },
    {
        name: 'undo-dot',
        tags: ['redo', 'history', 'step', 'back']
    },
    {
        name: 'unfold-horizontal',
        tags: ['arrow', 'collapse', 'fold', 'vertical', 'dashed']
    },
    {
        name: 'unfold-vertical',
        tags: ['arrow', 'expand', 'vertical', 'dashed']
    },
    {
        name: 'ungroup',
        tags: ['cubes', 'packages', 'parts', 'units', 'collection', 'cluster', 'separate']
    },
    {
        name: 'university',
        tags: ['building', 'education', 'childhood', 'school']
    },
    {
        name: 'unlink',
        tags: ['url', 'unchain']
    },
    {
        name: 'unlink-2',
        tags: ['url', 'unchain']
    },
    {
        name: 'unplug',
        tags: ['electricity', 'energy', 'electronics', 'socket', 'outlet', 'disconnect']
    },
    {
        name: 'upload',
        tags: ['file']
    },
    {
        name: 'usb',
        tags: ['universal', 'serial', 'bus', 'controller', 'connector', 'interface']
    },
    {
        name: 'user',
        tags: ['person', 'account', 'contact']
    },
    {
        name: 'user-check',
        tags: ['followed', 'subscribed', 'done', 'todo', 'tick', 'complete', 'task']
    },
    {
        name: 'user-cog',
        tags: ['settings', 'edit', 'cog', 'gear']
    },
    {
        name: 'user-minus',
        tags: ['delete', 'remove', 'unfollow', 'unsubscribe']
    },
    {
        name: 'user-pen',
        tags: ['person', 'account', 'contact', 'profile', 'edit', 'change']
    },
    {
        name: 'user-plus',
        tags: ['new', 'add', 'create', 'follow', 'subscribe']
    },
    {
        name: 'user-round',
        tags: ['person', 'account', 'contact']
    },
    {
        name: 'user-round-check',
        tags: ['followed', 'subscribed', 'done', 'todo', 'tick', 'complete', 'task']
    },
    {
        name: 'user-round-cog',
        tags: ['settings', 'edit', 'cog', 'gear']
    },
    {
        name: 'user-round-minus',
        tags: ['delete', 'remove', 'unfollow', 'unsubscribe']
    },
    {
        name: 'user-round-pen',
        tags: ['person', 'account', 'contact', 'profile', 'edit', 'change']
    },
    {
        name: 'user-round-plus',
        tags: ['new', 'add', 'create', 'follow', 'subscribe']
    },
    {
        name: 'user-round-search',
        tags: ['person', 'account', 'contact', 'find', 'scan', 'magnifier', 'magnifying glass']
    },
    {
        name: 'user-round-x',
        tags: ['delete', 'remove', 'unfollow', 'unsubscribe', 'unavailable']
    },
    {
        name: 'user-search',
        tags: ['person', 'account', 'contact', 'find', 'scan', 'magnifier', 'magnifying glass']
    },
    {
        name: 'user-x',
        tags: ['delete', 'remove', 'unfollow', 'unsubscribe', 'unavailable']
    },
    {
        name: 'users',
        tags: ['group', 'people']
    },
    {
        name: 'users-round',
        tags: ['group', 'people']
    },
    {
        name: 'utensils',
        tags: [
            'fork',
            'knife',
            'cutlery',
            'flatware',
            'tableware',
            'silverware',
            'food',
            'restaurant',
            'meal',
            'breakfast',
            'dinner',
            'supper'
        ]
    },
    {
        name: 'utensils-crossed',
        tags: [
            'fork',
            'knife',
            'cutlery',
            'flatware',
            'tableware',
            'silverware',
            'food',
            'restaurant',
            'meal',
            'breakfast',
            'dinner',
            'supper'
        ]
    },
    {
        name: 'utility-pole',
        tags: ['electricity', 'energy', 'transmission line', 'telegraph pole', 'power lines', 'phone']
    },
    {
        name: 'variable',
        tags: [
            'code',
            'coding',
            'programming',
            'symbol',
            'calculate',
            'algebra',
            'x',
            'parentheses',
            'parenthesis',
            'brackets',
            'parameter',
            '(',
            ')'
        ]
    },
    {
        name: 'vault',
        tags: [
            'safe',
            'lockbox',
            'deposit',
            'locker',
            'coffer',
            'strongbox',
            'safety',
            'secure',
            'storage',
            'valuables',
            'bank'
        ]
    },
    {
        name: 'vegan',
        tags: ['vegetarian', 'fruitarian', 'herbivorous', 'animal rights', 'diet']
    },
    {
        name: 'venetian-mask',
        tags: ['mask', 'masquerade', 'impersonate', 'secret', 'incognito']
    },
    {
        name: 'vibrate',
        tags: ['smartphone', 'notification', 'rumble', 'haptic feedback', 'screen']
    },
    {
        name: 'vibrate-off',
        tags: ['smartphone', 'notification', 'rumble', 'haptic feedback', 'notifications', 'screen']
    },
    {
        name: 'video',
        tags: ['camera', 'movie', 'film', 'recording', 'motion picture', 'camcorder', 'reel']
    },
    {
        name: 'video-off',
        tags: ['camera', 'movie', 'film']
    },
    {
        name: 'videotape',
        tags: ['vhs', 'movie', 'film', 'recording', 'motion picture', 'showreel', 'cassette']
    },
    {
        name: 'view',
        tags: ['eye', 'look']
    },
    {
        name: 'voicemail',
        tags: ['phone', 'cassette', 'tape', 'reel', 'recording', 'audio']
    },
    {
        name: 'volume',
        tags: ['music', 'sound', 'mute', 'speaker']
    },
    {
        name: 'volume-1',
        tags: ['music', 'sound', 'speaker']
    },
    {
        name: 'volume-2',
        tags: ['music', 'sound', 'speaker']
    },
    {
        name: 'volume-off',
        tags: ['music', 'sound', 'mute', 'speaker']
    },
    {
        name: 'volume-x',
        tags: ['music', 'sound', 'mute', 'speaker']
    },
    {
        name: 'vote',
        tags: ['vote', 'poll', 'ballot', 'political', 'social', 'check', 'tick']
    },
    {
        name: 'wallet',
        tags: ['money', 'finance', 'pocket']
    },
    {
        name: 'wallet-cards',
        tags: ['money', 'finance', 'pocket', 'credit', 'purchase', 'payment', 'shopping', 'retail', 'consumer', 'cc']
    },
    {
        name: 'wallet-minimal',
        tags: ['finance', 'pocket']
    },
    {
        name: 'wallpaper',
        tags: ['cover', 'lock screen']
    },
    {
        name: 'wand',
        tags: ['magic', 'selection']
    },
    {
        name: 'wand-sparkles',
        tags: ['magic', 'wizard', 'magician']
    },
    {
        name: 'warehouse',
        tags: ['storage', 'logistics', 'building']
    },
    {
        name: 'washing-machine',
        tags: ['tumble dryer', 'amenities', 'electronics', 'cycle', 'clothes', 'rinse', 'spin', 'drum']
    },
    {
        name: 'watch',
        tags: ['clock', 'time']
    },
    {
        name: 'waves',
        tags: ['water', 'sea', 'sound', 'hertz', 'wavelength', 'vibrate']
    },
    {
        name: 'waypoints',
        tags: [
            'indirection',
            'vpn',
            'virtual private network',
            'proxy',
            'connections',
            'bounce',
            'reroute',
            'path',
            'journey',
            'planner',
            'stops',
            'stations',
            'shared',
            'spread',
            'viral'
        ]
    },
    {
        name: 'webcam',
        tags: ['camera', 'security']
    },
    {
        name: 'webhook',
        tags: ['push api', 'interface', 'callback']
    },
    {
        name: 'webhook-off',
        tags: ['push api', 'interface', 'callback']
    },
    {
        name: 'weight',
        tags: ['mass', 'heavy', 'lead', 'metal', 'measure', 'geometry', 'scales', 'balance']
    },
    {
        name: 'wheat',
        tags: ['corn', 'cereal', 'grain', 'gluten']
    },
    {
        name: 'wheat-off',
        tags: ['corn', 'cereal', 'grain', 'gluten free', 'allergy', 'intolerance', 'diet']
    },
    {
        name: 'whole-word',
        tags: ['text', 'selection', 'letters', 'characters', 'font', 'typography']
    },
    {
        name: 'wifi',
        tags: ['connection', 'signal', 'wireless']
    },
    {
        name: 'wifi-high',
        tags: ['connection', 'signal', 'wireless']
    },
    {
        name: 'wifi-low',
        tags: ['connection', 'signal', 'wireless']
    },
    {
        name: 'wifi-off',
        tags: ['disabled']
    },
    {
        name: 'wifi-zero',
        tags: ['connection', 'signal', 'wireless']
    },
    {
        name: 'wind',
        tags: ['weather', 'air', 'blow']
    },
    {
        name: 'wine',
        tags: ['alcohol', 'beverage', 'bar', 'drink', 'glass', 'sommelier', 'vineyard', 'winery']
    },
    {
        name: 'wine-off',
        tags: [
            'alcohol',
            'beverage',
            'drink',
            'glass',
            'alcohol free',
            'abstinence',
            'abstaining',
            'teetotalism',
            'allergy',
            'intolerance'
        ]
    },
    {
        name: 'workflow',
        tags: ['action', 'continuous integration', 'ci', 'automation', 'devops', 'network', 'node', 'connection']
    },
    {
        name: 'worm',
        tags: [
            'invertebrate',
            'grub',
            'larva',
            'snake',
            'crawl',
            'wiggle',
            'slither',
            'pest control',
            'computer virus',
            'malware'
        ]
    },
    {
        name: 'wrap-text',
        tags: ['words', 'lines', 'break', 'paragraph']
    },
    {
        name: 'wrench',
        tags: ['account', 'settings', 'spanner', 'diy', 'toolbox', 'build', 'construction']
    },
    {
        name: 'x',
        tags: ['cancel', 'close', 'delete', 'remove', 'times', 'clear', 'maths', 'multiply', 'multiplication']
    },
    {
        name: 'youtube',
        tags: ['logo', 'social', 'video', 'play']
    },
    {
        name: 'zap',
        tags: ['flash', 'camera', 'lightning', 'electricity', 'energy']
    },
    {
        name: 'zap-off',
        tags: ['flash', 'camera', 'lightning', 'electricity', 'energy']
    },
    {
        name: 'zoom-in',
        tags: ['magnifying glass', 'plus']
    },
    {
        name: 'zoom-out',
        tags: ['magnifying glass', 'plus']
    }
];
